import * as e from "react";
import { cloneElement as t, createContext as n, forwardRef as r, useCallback as i, useContext as a, useEffect as o, useId as s, useLayoutEffect as c, useMemo as l, useRef as u, useState as d, useSyncExternalStore as f } from "react";
import { Fragment as p, jsx as m, jsxs as h } from "react/jsx-runtime";
import * as g from "react-dom";
import { createPortal as _ } from "react-dom";
//#region src/theme/useTheme.tsx
var v = n(null);
function y() {
	let e = a(v);
	if (e === null) throw Error("useTheme must be used within a <ThemeProvider>.");
	return e;
}
//#endregion
//#region src/theme/ThemeProvider.tsx
var b = "(prefers-color-scheme: dark)";
function x(e) {
	return e === "light" || e === "dark" || e === "system";
}
function S(e, t) {
	if (typeof window > "u") return t;
	try {
		let n = window.localStorage.getItem(e);
		return x(n) ? n : t;
	} catch {
		return t;
	}
}
function C() {
	return typeof window > "u" || typeof window.matchMedia != "function" ? null : window.matchMedia(b);
}
function w(e) {
	let t = C();
	return t === null ? () => void 0 : (t.addEventListener("change", e), () => {
		t.removeEventListener("change", e);
	});
}
function T() {
	return C()?.matches ?? !1;
}
function E() {
	return !1;
}
function D({ children: e, defaultTheme: t = "system", storageKey: n = "ex-theme", element: r }) {
	let [a, s] = d(() => S(n, t)), c = f(w, T, E), u = a === "system" ? c ? "dark" : "light" : a;
	o(() => {
		if (typeof document > "u") return;
		let e = r ?? document.documentElement;
		a === "system" ? e.removeAttribute("data-theme") : e.setAttribute("data-theme", a);
	}, [a, r]);
	let p = i((e) => {
		s(e);
		try {
			window.localStorage.setItem(n, e);
		} catch {}
	}, [n]), h = i(() => {
		p(u === "dark" ? "light" : "dark");
	}, [u, p]), g = l(() => ({
		theme: a,
		resolvedTheme: u,
		setTheme: p,
		toggleTheme: h
	}), [
		a,
		u,
		p,
		h
	]);
	return /* @__PURE__ */ m(v.Provider, {
		value: g,
		children: e
	});
}
//#endregion
//#region src/internal/status.ts
var O = [
	"info",
	"success",
	"warning",
	"danger",
	"neutral"
], k = {
	info: "ⓘ",
	success: "✓",
	warning: "⚠",
	danger: "✕",
	neutral: "•"
}, A = {
	info: "Information",
	success: "Success",
	warning: "Warning",
	danger: "Error",
	neutral: "Note"
};
//#endregion
//#region src/internal/style-vars.ts
function j(e, t) {
	let n = Object.fromEntries(Object.entries(e).filter(([, e]) => e !== void 0));
	return {
		...t,
		...n
	};
}
var M = [
	"1",
	"1-5",
	"2",
	"3",
	"4",
	"5",
	"6",
	"8",
	"12",
	"16",
	"20",
	"30"
];
function N(e) {
	return e === void 0 ? void 0 : `var(--ex-space-${e})`;
}
//#endregion
//#region src/internal/cx.ts
function P(...e) {
	return e.filter(Boolean).join(" ");
}
var F = { visuallyHidden: "ex-visuallyHidden-KiAzg" }, I = r(function({ className: e, ...t }, n) {
	return /* @__PURE__ */ m("span", {
		...t,
		ref: n,
		className: P(F.visuallyHidden, e)
	});
}), ee = {
	button: "ex-button-2ZuB7",
	spinner: "ex-spinner-ZExvW",
	"button-spin": "ex-button-spin-pv-6a"
}, L = [
	"primary",
	"secondary",
	"action",
	"ghost",
	"danger"
], te = [
	"sm",
	"md",
	"lg"
], R = r(function({ variant: e = "primary", size: t = "md", loading: n = !1, loadingLabel: r = "Loading", disabled: i = !1, type: a = "button", className: o, children: s, onClick: c, ...l }, u) {
	let d = (e) => {
		if (n) {
			e.preventDefault();
			return;
		}
		c?.(e);
	};
	return /* @__PURE__ */ h("button", {
		...l,
		ref: u,
		type: a,
		className: P(ee.button, o),
		"data-variant": e,
		"data-size": t,
		disabled: i,
		"aria-disabled": n || void 0,
		"aria-busy": n || void 0,
		onClick: d,
		children: [
			n ? /* @__PURE__ */ m("span", {
				className: ee.spinner,
				"aria-hidden": "true"
			}) : null,
			s,
			n ? /* @__PURE__ */ m(I, { children: r }) : null
		]
	});
}), ne = {
	iconButton: "ex-iconButton-JAF-a",
	icon: "ex-icon-2DDWy"
}, re = [
	"default",
	"ghost",
	"danger"
], z = [
	"sm",
	"md",
	"lg"
], ie = r(function({ label: e, variant: t = "default", size: n = "md", type: r = "button", className: i, children: a, ...o }, s) {
	return /* @__PURE__ */ m("button", {
		...o,
		ref: s,
		type: r,
		"aria-label": e,
		className: P(ne.iconButton, i),
		"data-variant": t,
		"data-size": n,
		children: /* @__PURE__ */ m("span", {
			className: ne.icon,
			"aria-hidden": "true",
			children: a
		})
	});
}), ae = {
	link: "ex-link-Ly-e3",
	externalIcon: "ex-externalIcon-5jtwn"
}, oe = ["default", "subtle"], se = r(function({ variant: e = "default", external: t = !1, className: n, children: r, ...i }, a) {
	let o = t ? {
		target: "_blank",
		rel: "noopener noreferrer"
	} : void 0;
	return /* @__PURE__ */ h("a", {
		...i,
		...o,
		ref: a,
		className: P(ae.link, n),
		"data-variant": e,
		children: [r, t ? /* @__PURE__ */ h(p, { children: [/* @__PURE__ */ m("span", {
			className: ae.externalIcon,
			"aria-hidden": "true",
			children: "↗"
		}), /* @__PURE__ */ m(I, { children: ", opens in a new tab" })] }) : null]
	});
}), ce = {
	spinner: "ex-spinner-GpFZS",
	"spinner-spin": "ex-spinner-spin-ICM2X"
}, le = [
	"sm",
	"md",
	"lg"
], ue = r(function({ size: e = "md", label: t = "Loading", className: n, ...r }, i) {
	return /* @__PURE__ */ m("span", {
		...r,
		ref: i,
		role: "status",
		"aria-label": t,
		className: P(ce.spinner, n),
		"data-size": e,
		children: /* @__PURE__ */ m(I, { children: t })
	});
}), de = {
	skeleton: "ex-skeleton-CB4uF",
	"skeleton-shimmer": "ex-skeleton-shimmer-rvADK",
	lines: "ex-lines-AvXPO"
}, fe = [
	"rect",
	"text",
	"circle"
], pe = r(function({ shape: e = "rect", width: t, height: n, lines: r = 1, className: i, style: a, ...o }, s) {
	let c = j({
		"--ex-skeleton-width": t,
		"--ex-skeleton-height": n
	});
	return r > 1 ? /* @__PURE__ */ m("div", {
		...o,
		ref: s,
		"aria-hidden": "true",
		className: P(de.lines, i),
		style: a,
		children: Array.from({ length: r }, (t, n) => /* @__PURE__ */ m("div", {
			className: de.skeleton,
			"data-shape": e === "rect" ? "text" : e,
			style: c
		}, n))
	}) : /* @__PURE__ */ m("div", {
		...o,
		ref: s,
		"aria-hidden": "true",
		className: P(de.skeleton, i),
		"data-shape": e,
		style: j({
			"--ex-skeleton-width": t,
			"--ex-skeleton-height": n
		}, a)
	});
}), me = {
	divider: "ex-divider-KSGsi",
	labelled: "ex-labelled-NkCle",
	label: "ex-label-PwL54"
}, he = r(function({ orientation: e = "horizontal", label: t, className: n, ...r }, i) {
	return t === void 0 ? /* @__PURE__ */ m("div", {
		...r,
		ref: i,
		role: "separator",
		"aria-orientation": e,
		className: P(me.divider, n),
		"data-orientation": e
	}) : /* @__PURE__ */ m("div", {
		...r,
		ref: i,
		role: "separator",
		"aria-orientation": e,
		className: P(me.labelled, n),
		children: /* @__PURE__ */ m("span", {
			className: me.label,
			children: t
		})
	});
}), ge = n(null);
function _e() {
	return a(ge);
}
function ve({ id: e, describedBy: t, invalid: n, required: r }) {
	let i = _e(), a = P(i?.describedBy, t), o = n ?? i?.invalid ?? !1, s = r ?? i?.required;
	return {
		id: e ?? i?.controlId,
		"aria-describedby": a === "" ? void 0 : a,
		"aria-invalid": o ? !0 : void 0,
		required: s
	};
}
var ye = {
	field: "ex-field-NXQSy",
	label: "ex-label-98wVM",
	requiredMark: "ex-requiredMark-pk7Eh",
	hint: "ex-hint-ePo59",
	error: "ex-error-4SHKr",
	errorGlyph: "ex-errorGlyph-v5RBj"
};
//#endregion
//#region src/components/FormField/FormField.tsx
function be({ label: e, children: t, hint: n, error: r, required: i = !1, id: a, className: o, style: c }) {
	let l = s(), u = a ?? l, d = `${u}-hint`, f = `${u}-error`, p = P(n !== void 0 && d, r !== void 0 && f), g = {
		controlId: u,
		describedBy: p === "" ? void 0 : p,
		invalid: r !== void 0,
		required: i
	};
	return /* @__PURE__ */ h("div", {
		className: P(ye.field, o),
		style: c,
		children: [
			/* @__PURE__ */ h("label", {
				className: ye.label,
				htmlFor: u,
				children: [e, i ? /* @__PURE__ */ m("span", {
					className: ye.requiredMark,
					"aria-hidden": "true",
					children: "*"
				}) : null]
			}),
			n === void 0 ? null : /* @__PURE__ */ m("p", {
				className: ye.hint,
				id: d,
				children: n
			}),
			/* @__PURE__ */ m(ge.Provider, {
				value: g,
				children: t
			}),
			r === void 0 ? null : /* @__PURE__ */ h("p", {
				className: ye.error,
				id: f,
				role: "alert",
				children: [/* @__PURE__ */ m("span", {
					className: ye.errorGlyph,
					"aria-hidden": "true",
					children: k.danger
				}), /* @__PURE__ */ h("span", { children: [/* @__PURE__ */ m(I, { children: "Error: " }), r] })]
			})
		]
	});
}
var xe = { control: "ex-control-e3jPo" }, Se = [
	"sm",
	"md",
	"lg"
], Ce = r(function({ size: e = "md", invalid: t, id: n, required: r, "aria-describedby": i, type: a = "text", className: o, ...s }, c) {
	let l = ve({
		id: n,
		describedBy: i,
		invalid: t,
		required: r
	});
	return /* @__PURE__ */ m("input", {
		...s,
		...l,
		ref: c,
		type: a,
		className: P(xe.control, o),
		"data-size": e
	});
}), we = { control: "ex-control-5it3b" }, Te = r(function({ invalid: e, resize: t = "vertical", id: n, required: r, "aria-describedby": i, rows: a = 4, className: o, ...s }, c) {
	let l = ve({
		id: n,
		describedBy: i,
		invalid: e,
		required: r
	});
	return /* @__PURE__ */ m("textarea", {
		...s,
		...l,
		ref: c,
		rows: a,
		className: P(we.control, o),
		"data-resize": t
	});
}), Ee = {
	wrapper: "ex-wrapper-KS2K3",
	control: "ex-control-OqOfI",
	chevron: "ex-chevron-PLUsh"
}, De = [
	"sm",
	"md",
	"lg"
], Oe = r(function({ size: e = "md", invalid: t, placeholder: n, id: r, required: i, "aria-describedby": a, className: o, children: s, ...c }, l) {
	let u = ve({
		id: r,
		describedBy: a,
		invalid: t,
		required: i
	});
	return /* @__PURE__ */ h("span", {
		className: Ee.wrapper,
		children: [/* @__PURE__ */ h("select", {
			...c,
			...u,
			ref: l,
			className: P(Ee.control, o),
			"data-size": e,
			children: [n === void 0 ? null : /* @__PURE__ */ m("option", {
				value: "",
				disabled: !0,
				children: n
			}), s]
		}), /* @__PURE__ */ m("span", {
			className: Ee.chevron,
			"aria-hidden": "true",
			children: "▾"
		})]
	});
});
//#endregion
//#region src/internal/merge-refs.ts
function ke(...e) {
	return (t) => {
		for (let n of e) typeof n == "function" ? n(t) : n != null && (n.current = t);
	};
}
var Ae = {
	row: "ex-row-vzcT8",
	input: "ex-input-2kt-h",
	box: "ex-box-OCPee",
	text: "ex-text-EmtRj",
	label: "ex-label-cwRtI",
	description: "ex-description-rMhG1"
}, je = r(function({ label: e, description: t, indeterminate: n = !1, invalid: r, id: i, required: a, disabled: s = !1, "aria-describedby": c, className: l, style: d, ...f }, p) {
	let g = u(null), _ = ve({
		id: i,
		describedBy: c,
		invalid: r,
		required: a
	}), v = t === void 0 ? void 0 : `${_.id ?? ""}-description`;
	return o(() => {
		g.current !== null && (g.current.indeterminate = n);
	}, [n]), /* @__PURE__ */ h("label", {
		className: P(Ae.row, l),
		style: d,
		"data-disabled": s || void 0,
		children: [
			/* @__PURE__ */ m("input", {
				...f,
				..._,
				"aria-describedby": P(_["aria-describedby"], v) || void 0,
				ref: ke(g, p),
				type: "checkbox",
				disabled: s,
				className: Ae.input
			}),
			/* @__PURE__ */ m("span", {
				className: Ae.box,
				"aria-hidden": "true",
				children: n ? "–" : "✓"
			}),
			/* @__PURE__ */ h("span", {
				className: Ae.text,
				children: [/* @__PURE__ */ m("span", {
					className: Ae.label,
					children: e
				}), t === void 0 ? null : /* @__PURE__ */ m("span", {
					className: Ae.description,
					id: v,
					children: t
				})]
			})
		]
	});
}), Me = {
	row: "ex-row-yVbAy",
	input: "ex-input-7R8ZN",
	circle: "ex-circle-6v2W0",
	dot: "ex-dot-P7ejP",
	text: "ex-text-wmNPT",
	label: "ex-label-vAFIP",
	description: "ex-description-bEB8u"
}, Ne = r(function({ label: e, description: t, id: n, disabled: r = !1, "aria-describedby": i, className: a, style: o, ...s }, c) {
	let l = t !== void 0 && n !== void 0 ? `${n}-description` : void 0;
	return /* @__PURE__ */ h("label", {
		className: P(Me.row, a),
		style: o,
		"data-disabled": r || void 0,
		children: [
			/* @__PURE__ */ m("input", {
				...s,
				ref: c,
				id: n,
				type: "radio",
				disabled: r,
				"aria-describedby": P(i, l) || void 0,
				className: Me.input
			}),
			/* @__PURE__ */ m("span", {
				className: Me.circle,
				"aria-hidden": "true",
				children: /* @__PURE__ */ m("span", { className: Me.dot })
			}),
			/* @__PURE__ */ h("span", {
				className: Me.text,
				children: [/* @__PURE__ */ m("span", {
					className: Me.label,
					children: e
				}), t === void 0 ? null : /* @__PURE__ */ m("span", {
					className: Me.description,
					id: l,
					children: t
				})]
			})
		]
	});
}), Pe = {
	row: "ex-row-SufnP",
	input: "ex-input-5BPNu",
	track: "ex-track-7ObdZ",
	thumb: "ex-thumb--FTeK",
	label: "ex-label-LrH7V"
}, Fe = r(function({ label: e, labelPosition: t = "end", disabled: n = !1, className: r, style: i, ...a }, o) {
	let s = /* @__PURE__ */ m("span", {
		className: Pe.label,
		children: e
	});
	return /* @__PURE__ */ h("label", {
		className: P(Pe.row, r),
		style: i,
		"data-disabled": n || void 0,
		children: [
			t === "start" ? s : null,
			/* @__PURE__ */ m("input", {
				...a,
				ref: o,
				type: "checkbox",
				role: "switch",
				disabled: n,
				className: Pe.input
			}),
			/* @__PURE__ */ m("span", {
				className: Pe.track,
				"aria-hidden": "true",
				children: /* @__PURE__ */ m("span", {
					className: Pe.thumb,
					children: "✓"
				})
			}),
			t === "end" ? s : null
		]
	});
}), Ie = {
	wrapper: "ex-wrapper-q8GEq",
	field: "ex-field-ONU-p",
	input: "ex-input-rhhzi",
	searchIcon: "ex-searchIcon-O0FTp",
	trailing: "ex-trailing-ZJbHB",
	clear: "ex-clear-r3kgN",
	listbox: "ex-listbox-CCyCk",
	option: "ex-option-Fz-Eh",
	optionLabel: "ex-optionLabel-hqOHI",
	optionDescription: "ex-optionDescription-RM0EA",
	empty: "ex-empty-FbSB8"
}, Le = [
	"sm",
	"md",
	"lg"
], Re = r(function({ value: e, onValueChange: t, onSearch: n, onClear: r, suggestions: i, onSuggestionSelect: a, emptyMessage: o, size: c = "md", clearLabel: l = "Clear search", suggestionsLabel: f = "Suggestions", placeholder: p = "Search", id: g, required: _, "aria-describedby": v, className: y, style: b, onKeyDown: x, onBlur: S, ...C }, w) {
	let T = u(null), E = s(), D = ve({
		id: g,
		describedBy: v,
		required: _
	}), [O, k] = d(!1), [A, j] = d(-1), M = i !== void 0, N = i ?? [], F = M && O && (N.length > 0 || o !== void 0), I = A >= 0 ? N[A] : void 0, ee = () => {
		k(!1), j(-1);
	}, L = (e) => {
		a?.(e), ee();
	}, te = (e) => {
		N.length !== 0 && j((t) => {
			let n = t + e;
			return n < 0 ? N.length - 1 : n >= N.length ? 0 : n;
		});
	}, R = (i) => {
		if (x?.(i), !i.defaultPrevented) switch (i.key) {
			case "ArrowDown":
				if (!M) return;
				i.preventDefault(), O ? te(1) : (k(!0), j(0));
				return;
			case "ArrowUp":
				if (!M) return;
				i.preventDefault(), O ? te(-1) : (k(!0), j(N.length - 1));
				return;
			case "Home":
				if (!O || N.length === 0) return;
				i.preventDefault(), j(0);
				return;
			case "End":
				if (!O || N.length === 0) return;
				i.preventDefault(), j(N.length - 1);
				return;
			case "Enter":
				if (I !== void 0) {
					i.preventDefault(), L(I);
					return;
				}
				n !== void 0 && (i.preventDefault(), n(e));
				return;
			case "Escape":
				if (O) {
					i.preventDefault(), ee();
					return;
				}
				e !== "" && (i.preventDefault(), t(""), r?.());
				return;
			case "Tab":
				ee();
				return;
		}
	}, ne = M ? {
		role: "combobox",
		"aria-expanded": F,
		"aria-controls": E,
		"aria-autocomplete": "list",
		"aria-activedescendant": I === void 0 ? void 0 : `${E}-${I.id}`
	} : void 0;
	return /* @__PURE__ */ h("div", {
		className: P(Ie.wrapper, y),
		style: b,
		children: [/* @__PURE__ */ h("div", {
			className: Ie.field,
			children: [
				/* @__PURE__ */ m("span", {
					className: Ie.searchIcon,
					"aria-hidden": "true",
					children: /* @__PURE__ */ h("svg", {
						viewBox: "0 0 24 24",
						fill: "none",
						stroke: "currentColor",
						strokeWidth: "2",
						strokeLinecap: "round",
						children: [/* @__PURE__ */ m("circle", {
							cx: "11",
							cy: "11",
							r: "7"
						}), /* @__PURE__ */ m("path", { d: "M21 21l-4.3-4.3" })]
					})
				}),
				/* @__PURE__ */ m("input", {
					...C,
					...D,
					...ne,
					ref: ke(T, w),
					type: "search",
					value: e,
					placeholder: p,
					className: Ie.input,
					"data-size": c,
					onChange: (e) => {
						t(e.target.value), M && (k(!0), j(-1));
					},
					onKeyDown: R,
					onBlur: (e) => {
						ee(), S?.(e);
					}
				}),
				e === "" ? null : /* @__PURE__ */ m("span", {
					className: Ie.trailing,
					children: /* @__PURE__ */ m("button", {
						type: "button",
						className: Ie.clear,
						"aria-label": l,
						onClick: () => {
							t(""), r?.(), ee(), T.current?.focus();
						},
						children: "✕"
					})
				})
			]
		}), F ? /* @__PURE__ */ m("ul", {
			className: Ie.listbox,
			id: E,
			role: "listbox",
			"aria-label": f,
			children: N.length === 0 ? /* @__PURE__ */ m("li", {
				className: Ie.empty,
				role: "presentation",
				children: o
			}) : N.map((e, t) => /* @__PURE__ */ h("li", {
				id: `${E}-${e.id}`,
				role: "option",
				"aria-selected": t === A,
				className: Ie.option,
				"data-active": t === A,
				onMouseDown: (t) => {
					t.preventDefault(), L(e);
				},
				onMouseEnter: () => {
					j(t);
				},
				children: [/* @__PURE__ */ m("span", {
					className: Ie.optionLabel,
					children: e.label
				}), e.description === void 0 ? null : /* @__PURE__ */ m("span", {
					className: Ie.optionDescription,
					children: e.description
				})]
			}, e.id))
		}) : null]
	});
}), ze = {
	group: "ex-group-XTFoq",
	header: "ex-header-b2gnv",
	label: "ex-label-jaBOA",
	readout: "ex-readout-htyh0",
	slider: "ex-slider-c5E5r",
	track: "ex-track-j-2iy",
	selected: "ex-selected-eMX1U",
	input: "ex-input-1MASw"
};
//#endregion
//#region src/components/RangeSlider/RangeSlider.tsx
function Be(e, t, n) {
	return n === t ? 0 : (e - t) / (n - t) * 100;
}
function Ve({ label: e, min: t, max: n, step: r = 1, value: i, onValueChange: a, formatValue: o = String, minHandleLabel: c = "minimum", maxHandleLabel: l = "maximum", hideReadout: u = !1, disabled: d = !1, id: f, className: p, style: g }) {
	let _ = s(), v = f ?? _, [y, b] = i, x = (e) => {
		a([Math.min(e, b), b]);
	}, S = (e) => {
		a([y, Math.max(e, y)]);
	};
	return /* @__PURE__ */ h("div", {
		className: P(ze.group, p),
		style: g,
		role: "group",
		"aria-labelledby": `${v}-label`,
		"data-disabled": d || void 0,
		children: [/* @__PURE__ */ h("div", {
			className: ze.header,
			children: [/* @__PURE__ */ m("span", {
				className: ze.label,
				id: `${v}-label`,
				children: e
			}), u ? null : /* @__PURE__ */ h("span", {
				className: ze.readout,
				children: [
					o(y),
					" – ",
					o(b)
				]
			})]
		}), /* @__PURE__ */ h("div", {
			className: ze.slider,
			children: [
				/* @__PURE__ */ m("div", {
					className: ze.track,
					"aria-hidden": "true",
					children: /* @__PURE__ */ m("div", {
						className: ze.selected,
						style: j({
							"--ex-range-start": `${String(Be(y, t, n))}%`,
							"--ex-range-end": `${String(Be(b, t, n))}%`
						})
					})
				}),
				/* @__PURE__ */ m("input", {
					type: "range",
					className: ze.input,
					"aria-label": `${e}, ${c}`,
					"aria-valuetext": o(y),
					min: t,
					max: n,
					step: r,
					value: y,
					disabled: d,
					onChange: (e) => {
						x(e.target.valueAsNumber);
					}
				}),
				/* @__PURE__ */ m("input", {
					type: "range",
					className: ze.input,
					"aria-label": `${e}, ${l}`,
					"aria-valuetext": o(b),
					min: t,
					max: n,
					step: r,
					value: b,
					disabled: d,
					onChange: (e) => {
						S(e.target.valueAsNumber);
					}
				})
			]
		})]
	});
}
var He = {
	card: "ex-card-Cb1o4",
	interactive: "ex-interactive-B8Tah",
	header: "ex-header-PTXf2",
	body: "ex-body-W441Z",
	footer: "ex-footer-Mu-JC"
}, Ue = r(function(e, t) {
	if (e.interactive === !0) {
		let { header: n, footer: r, interactive: i, className: a, children: o, type: s = "button", ...c } = e;
		return /* @__PURE__ */ h("button", {
			...c,
			ref: t,
			type: s,
			className: P(He.card, He.interactive, a),
			children: [
				n === void 0 ? null : /* @__PURE__ */ m("span", {
					className: He.header,
					children: n
				}),
				/* @__PURE__ */ m("span", {
					className: He.body,
					children: o
				}),
				r === void 0 ? null : /* @__PURE__ */ m("span", {
					className: He.footer,
					children: r
				})
			]
		});
	}
	let { header: n, footer: r, interactive: i, className: a, children: o, ...s } = e;
	return /* @__PURE__ */ h("div", {
		...s,
		ref: t,
		className: P(He.card, a),
		children: [
			n === void 0 ? null : /* @__PURE__ */ m("div", {
				className: He.header,
				children: n
			}),
			/* @__PURE__ */ m("div", {
				className: He.body,
				children: o
			}),
			r === void 0 ? null : /* @__PURE__ */ m("div", {
				className: He.footer,
				children: r
			})
		]
	});
}), We = {
	badge: "ex-badge-RsuMz",
	glyph: "ex-glyph-051-J"
}, Ge = [
	"info",
	"success",
	"warning",
	"danger"
], Ke = [
	...Ge,
	"neutral",
	"brand"
];
function qe(e) {
	return Ge.includes(e);
}
var Je = r(function({ tone: e = "neutral", glyph: t, className: n, children: r, ...i }, a) {
	let o = qe(e) ? e : void 0, s = t ?? (o === void 0 ? void 0 : k[o]);
	return /* @__PURE__ */ h("span", {
		...i,
		ref: a,
		className: P(We.badge, n),
		"data-tone": e,
		children: [
			s === void 0 ? null : /* @__PURE__ */ m("span", {
				className: We.glyph,
				"aria-hidden": "true",
				children: s
			}),
			o === void 0 ? null : /* @__PURE__ */ h(I, { children: [A[o], ": "] }),
			r
		]
	});
}), Ye = {
	tag: "ex-tag-16VPH",
	remove: "ex-remove-UEwgr"
}, Xe = r(function({ label: e, onRemove: t, removeLabel: n, className: r, children: i, ...a }, o) {
	let s = t !== void 0, c = n ?? (typeof e == "string" ? `Remove ${e}` : "Remove");
	return /* @__PURE__ */ h("span", {
		...a,
		ref: o,
		className: P(Ye.tag, r),
		"data-removable": s || void 0,
		children: [
			/* @__PURE__ */ m("span", { children: e }),
			i,
			s ? /* @__PURE__ */ m("button", {
				type: "button",
				className: Ye.remove,
				"aria-label": c,
				onClick: t,
				children: "✕"
			}) : null
		]
	});
}), Ze = { mark: "ex-mark-MqdvC" }, Qe = r(function({ current: e = !1, className: t, children: n, ...r }, i) {
	return /* @__PURE__ */ m("mark", {
		...r,
		ref: i,
		className: P(Ze.mark, t),
		"data-current": e ? "true" : void 0,
		"aria-current": e ? "true" : void 0,
		children: n
	});
}), $e = {
	avatar: "ex-avatar-3xMuZ",
	image: "ex-image-ieqGp"
}, et = [
	"sm",
	"md",
	"lg"
];
function tt(e) {
	let t = e.split(/\s+/u).filter((e) => e.length > 0);
	return t.length === 0 ? "?" : ((t[0]?.[0] ?? "") + (t.length > 1 ? t[t.length - 1]?.[0] ?? "" : "")).toUpperCase();
}
var nt = r(function({ name: e, src: t, size: n = "md", decorative: r = !1, className: i, ...a }, o) {
	let s = r ? { "aria-hidden": !0 } : {
		role: "img",
		"aria-label": e
	};
	return /* @__PURE__ */ m("span", {
		...a,
		...s,
		ref: o,
		className: P($e.avatar, i),
		"data-size": n,
		children: t === void 0 ? tt(e) : /* @__PURE__ */ m("img", {
			className: $e.image,
			src: t,
			alt: ""
		})
	});
}), rt = {
	stat: "ex-stat-zoo9y",
	label: "ex-label-lIH47",
	value: "ex-value-JBWnr",
	hint: "ex-hint-YkTF8",
	trend: "ex-trend-OVIMc",
	trendGlyph: "ex-trendGlyph-wGwiZ"
}, it = [
	"up",
	"down",
	"flat"
], at = {
	up: "↑",
	down: "↓",
	flat: "→"
}, ot = {
	up: "Up",
	down: "Down",
	flat: "No change"
}, st = r(function({ label: e, value: t, hint: n, trend: r, trendValue: i, className: a, children: o, ...s }, c) {
	return /* @__PURE__ */ h("div", {
		...s,
		ref: c,
		className: P(rt.stat, a),
		children: [
			/* @__PURE__ */ m("span", {
				className: rt.label,
				children: e
			}),
			/* @__PURE__ */ m("span", {
				className: rt.value,
				children: t
			}),
			r === void 0 ? null : /* @__PURE__ */ h("span", {
				className: rt.trend,
				"data-direction": r,
				children: [
					/* @__PURE__ */ m("span", {
						className: rt.trendGlyph,
						"aria-hidden": "true",
						children: at[r]
					}),
					/* @__PURE__ */ h(I, { children: [ot[r], ": "] }),
					i
				]
			}),
			n === void 0 ? null : /* @__PURE__ */ m("span", {
				className: rt.hint,
				children: n
			}),
			o
		]
	});
}), ct = {
	emptyState: "ex-emptyState-OlmHA",
	icon: "ex-icon-qVCyh",
	title: "ex-title-xPfUf",
	description: "ex-description-oWwH1",
	actions: "ex-actions-FV1K6"
}, lt = r(function({ title: e, description: t, icon: n, actions: r, headingLevel: i = 2, className: a, children: o, ...s }, c) {
	let l = `h${String(i)}`;
	return /* @__PURE__ */ h("div", {
		...s,
		ref: c,
		className: P(ct.emptyState, a),
		children: [
			n === void 0 ? null : /* @__PURE__ */ m("span", {
				className: ct.icon,
				"aria-hidden": "true",
				children: n
			}),
			/* @__PURE__ */ m(l, {
				className: ct.title,
				children: e
			}),
			t === void 0 ? null : /* @__PURE__ */ m("p", {
				className: ct.description,
				children: t
			}),
			o,
			r === void 0 ? null : /* @__PURE__ */ m("div", {
				className: ct.actions,
				children: r
			})
		]
	});
}), ut = {
	scroller: "ex-scroller-ryIw-",
	table: "ex-table-Dkosn",
	caption: "ex-caption-9vU1I",
	headerCell: "ex-headerCell-vZciR",
	headerLabel: "ex-headerLabel-sKkm7",
	sortButton: "ex-sortButton-V9clQ",
	sortGlyph: "ex-sortGlyph-NrTPj",
	cell: "ex-cell-nJrDK",
	row: "ex-row-DD8Km",
	empty: "ex-empty-O1nyD"
}, dt = {
	ascending: "↑",
	descending: "↓",
	none: "↕"
};
function ft({ caption: e, captionHidden: t = !1, columns: n, rows: r, getRowKey: i, sort: a, onSortChange: o, emptyMessage: c = "No rows to show.", ref: l, className: u, style: d }) {
	let f = s(), p = (e) => {
		o !== void 0 && o({
			key: e,
			direction: a?.key === e && a.direction === "ascending" ? "descending" : "ascending"
		});
	};
	return /* @__PURE__ */ m("div", {
		className: P(ut.scroller, u),
		style: d,
		tabIndex: 0,
		role: "region",
		"aria-labelledby": f,
		children: /* @__PURE__ */ h("table", {
			ref: l,
			className: ut.table,
			children: [
				/* @__PURE__ */ m("caption", {
					className: t ? void 0 : ut.caption,
					id: f,
					children: t ? /* @__PURE__ */ m(I, { children: e }) : e
				}),
				/* @__PURE__ */ m("thead", { children: /* @__PURE__ */ m("tr", { children: n.map((e) => {
					let t = a?.key === e.key ? a.direction : "none", n = e.sortable === !0 && o !== void 0;
					return /* @__PURE__ */ m("th", {
						scope: "col",
						className: ut.headerCell,
						"data-align": e.align ?? "start",
						"aria-sort": n ? t : void 0,
						children: n ? /* @__PURE__ */ h("button", {
							type: "button",
							className: ut.sortButton,
							onClick: () => {
								p(e.key);
							},
							children: [/* @__PURE__ */ m("span", { children: e.sortLabel ?? e.header }), /* @__PURE__ */ m("span", {
								className: ut.sortGlyph,
								"aria-hidden": "true",
								children: dt[t]
							})]
						}) : /* @__PURE__ */ m("span", {
							className: ut.headerLabel,
							children: e.header
						})
					}, e.key);
				}) }) }),
				/* @__PURE__ */ m("tbody", { children: r.length === 0 ? /* @__PURE__ */ m("tr", { children: /* @__PURE__ */ m("td", {
					className: ut.empty,
					colSpan: n.length,
					children: c
				}) }) : r.map((e, t) => /* @__PURE__ */ m("tr", {
					className: ut.row,
					children: n.map((t) => /* @__PURE__ */ m("td", {
						className: ut.cell,
						"data-align": t.align ?? "start",
						children: t.cell(e)
					}, t.key))
				}, i(e, t))) })
			]
		})
	});
}
var pt = {
	nav: "ex-nav-RKxKa",
	button: "ex-button---Saq",
	ellipsis: "ex-ellipsis-V294k"
}, mt = "gap";
function ht(e, t, n = 1) {
	if (t <= n * 2 + 5) return Array.from({ length: t }, (e, t) => t + 1);
	let r = Math.max(e - n, 1), i = Math.min(e + n, t), a = r > 2, o = i < t - 1;
	if (!a) {
		let e = n * 2 + 3;
		return [
			...Array.from({ length: e }, (e, t) => t + 1),
			mt,
			t
		];
	}
	if (!o) {
		let e = n * 2 + 3;
		return [
			1,
			mt,
			...Array.from({ length: e }, (n, r) => t - e + 1 + r)
		];
	}
	return [
		1,
		mt,
		...Array.from({ length: i - r + 1 }, (e, t) => r + t),
		mt,
		t
	];
}
var gt = r(function({ page: e, pageCount: t, onPageChange: n, siblingCount: r = 1, label: i = "Pagination", previousLabel: a = "Previous page", nextLabel: o = "Next page", className: s, ...c }, l) {
	let u = (r) => {
		let i = Math.min(Math.max(r, 1), t);
		i !== e && n(i);
	};
	return /* @__PURE__ */ h("nav", {
		...c,
		ref: l,
		"aria-label": i,
		className: P(pt.nav, s),
		children: [
			/* @__PURE__ */ m("button", {
				type: "button",
				className: pt.button,
				"aria-label": a,
				disabled: e <= 1,
				onClick: () => {
					u(e - 1);
				},
				children: /* @__PURE__ */ m("span", {
					"aria-hidden": "true",
					children: "‹"
				})
			}),
			ht(e, t, r).map((t, n) => t === mt ? /* @__PURE__ */ m("span", {
				className: pt.ellipsis,
				"aria-hidden": "true",
				children: "…"
			}, `gap-${String(n)}`) : /* @__PURE__ */ m("button", {
				type: "button",
				className: pt.button,
				"aria-label": `Page ${String(t)}`,
				"aria-current": t === e ? "page" : void 0,
				onClick: () => {
					u(t);
				},
				children: t
			}, t)),
			/* @__PURE__ */ m("button", {
				type: "button",
				className: pt.button,
				"aria-label": o,
				disabled: e >= t,
				onClick: () => {
					u(e + 1);
				},
				children: /* @__PURE__ */ m("span", {
					"aria-hidden": "true",
					children: "›"
				})
			})
		]
	});
}), _t = {
	list: "ex-list-fwIXq",
	row: "ex-row-c-ciW",
	term: "ex-term-QkQNZ",
	description: "ex-description-e1bNN"
}, vt = r(function({ items: e, orientation: t = "vertical", className: n, ...r }, i) {
	return /* @__PURE__ */ m("dl", {
		...r,
		ref: i,
		className: P(_t.list, n),
		"data-orientation": t,
		children: e.map((e, t) => /* @__PURE__ */ h("div", {
			className: _t.row,
			children: [/* @__PURE__ */ m("dt", {
				className: _t.term,
				children: e.term
			}), /* @__PURE__ */ m("dd", {
				className: _t.description,
				children: e.description
			})]
		}, e.id ?? (typeof e.term == "string" ? e.term : t)))
	});
}), yt = {
	alert: "ex-alert-7cYyI",
	glyph: "ex-glyph-o6oGI",
	content: "ex-content-UXnmZ",
	title: "ex-title-abGgF",
	body: "ex-body-B60Rk",
	actions: "ex-actions-RW9lv",
	dismiss: "ex-dismiss-dQPPE"
}, bt = [
	"info",
	"success",
	"warning",
	"danger"
], xt = /* @__PURE__ */ new Set(["warning", "danger"]), St = r(function({ tone: e = "info", title: t, actions: n, onDismiss: r, dismissLabel: i = "Dismiss", className: a, children: o, ...s }, c) {
	return /* @__PURE__ */ h("div", {
		...s,
		ref: c,
		role: xt.has(e) ? "alert" : "status",
		className: P(yt.alert, a),
		"data-tone": e,
		children: [
			/* @__PURE__ */ m("span", {
				className: yt.glyph,
				"aria-hidden": "true",
				children: k[e]
			}),
			/* @__PURE__ */ h("div", {
				className: yt.content,
				children: [
					/* @__PURE__ */ h(I, { children: [A[e], ": "] }),
					t === void 0 ? null : /* @__PURE__ */ m("span", {
						className: yt.title,
						children: t
					}),
					o === void 0 ? null : /* @__PURE__ */ m("div", {
						className: yt.body,
						children: o
					}),
					n === void 0 ? null : /* @__PURE__ */ m("div", {
						className: yt.actions,
						children: n
					})
				]
			}),
			r === void 0 ? null : /* @__PURE__ */ m("button", {
				type: "button",
				className: yt.dismiss,
				"aria-label": i,
				onClick: r,
				children: "✕"
			})
		]
	});
}), Ct = {
	viewport: "ex-viewport-5YhJF",
	toastList: "ex-toastList-IGmrF",
	toast: "ex-toast-FLdHz",
	glyph: "ex-glyph-kazxJ",
	content: "ex-content-U6Xwq",
	title: "ex-title--H6R2",
	description: "ex-description--QwfC",
	action: "ex-action--b4jg",
	dismiss: "ex-dismiss-fj0MP"
}, wt = r(function({ tone: e = "info", title: t, description: n, action: r, onDismiss: i, dismissLabel: a = "Dismiss notification", className: o, children: s, ...c }, l) {
	return /* @__PURE__ */ h("div", {
		...c,
		ref: l,
		className: P(Ct.toast, o),
		"data-tone": e,
		children: [
			/* @__PURE__ */ m("span", {
				className: Ct.glyph,
				"aria-hidden": "true",
				children: k[e]
			}),
			/* @__PURE__ */ h("div", {
				className: Ct.content,
				children: [
					/* @__PURE__ */ h(I, { children: [A[e], ": "] }),
					t === void 0 ? null : /* @__PURE__ */ m("span", {
						className: Ct.title,
						children: t
					}),
					n === void 0 ? null : /* @__PURE__ */ m("span", {
						className: Ct.description,
						children: n
					}),
					s,
					r === void 0 ? null : /* @__PURE__ */ m("button", {
						type: "button",
						className: Ct.action,
						onClick: r.onClick,
						children: r.label
					})
				]
			}),
			i === void 0 ? null : /* @__PURE__ */ m("button", {
				type: "button",
				className: Ct.dismiss,
				"aria-label": a,
				onClick: i,
				children: "✕"
			})
		]
	});
}), Tt = /* @__PURE__ */ new Set(["warning", "danger"]), Et = n(null);
function Dt() {
	let e = a(Et);
	if (e === null) throw Error("useToast must be used within a <ToastProvider>.");
	return e;
}
function Ot({ children: e, defaultDuration: t = 6e3, limit: n = 4, politeLabel: r = "Notifications", assertiveLabel: a = "Important notifications" }) {
	let [s, c] = d([]), [f, p] = d(!1), g = u(0), v = i((e) => {
		c((t) => t.filter((t) => t.id !== e));
	}, []), y = i(() => {
		c([]);
	}, []), b = i((e) => {
		g.current += 1;
		let t = `toast-${String(g.current)}`;
		return c((r) => [...r, {
			...e,
			id: t
		}].slice(-n)), t;
	}, [n]);
	o(() => {
		if (f) return;
		let e = s.map((e) => {
			let n = e.duration ?? t;
			if (!(n <= 0)) return window.setTimeout(() => {
				v(e.id);
			}, n);
		}).filter((e) => e !== void 0);
		return () => {
			for (let t of e) window.clearTimeout(t);
		};
	}, [
		s,
		f,
		t,
		v
	]);
	let x = l(() => ({
		toast: b,
		dismiss: v,
		dismissAll: y
	}), [
		b,
		v,
		y
	]), S = s.filter((e) => !Tt.has(e.tone ?? "info")), C = s.filter((e) => Tt.has(e.tone ?? "info")), w = (e) => /* @__PURE__ */ m(wt, {
		tone: e.tone ?? "info",
		title: e.title,
		description: e.description,
		action: e.action,
		onDismiss: () => {
			v(e.id);
		}
	}, e.id), T = /* @__PURE__ */ h("div", {
		className: Ct.viewport,
		onMouseEnter: () => {
			p(!0);
		},
		onMouseLeave: () => {
			p(!1);
		},
		onFocusCapture: () => {
			p(!0);
		},
		onBlurCapture: () => {
			p(!1);
		},
		children: [/* @__PURE__ */ m("div", {
			className: Ct.toastList,
			role: "region",
			"aria-label": a,
			"aria-live": "assertive",
			children: C.map(w)
		}), /* @__PURE__ */ m("div", {
			className: Ct.toastList,
			role: "region",
			"aria-label": r,
			"aria-live": "polite",
			children: S.map(w)
		})]
	});
	return /* @__PURE__ */ h(Et.Provider, {
		value: x,
		children: [e, typeof document > "u" ? null : _(T, document.body)]
	});
}
var kt = {
	wrapper: "ex-wrapper-EQ-vF",
	header: "ex-header-7jG4I",
	label: "ex-label-vO584",
	value: "ex-value-EC9y5",
	track: "ex-track-5Fp2t",
	fill: "ex-fill-6W-EK",
	"progress-sweep": "ex-progress-sweep-PQM41"
}, At = [
	"brand",
	"success",
	"warning",
	"danger"
], jt = r(function({ label: e, value: t = 0, max: n = 100, indeterminate: r = !1, tone: i = "brand", hideLabel: a = !1, formatValue: o, className: s, ...c }, l) {
	let u = Math.min(Math.max(t, 0), n), d = n === 0 ? 0 : u / n * 100, f = o?.(u, n) ?? `${String(Math.round(d))}%`;
	return /* @__PURE__ */ h("div", {
		...c,
		ref: l,
		className: P(kt.wrapper, s),
		"data-tone": i,
		children: [a ? null : /* @__PURE__ */ h("div", {
			className: kt.header,
			children: [/* @__PURE__ */ m("span", {
				className: kt.label,
				children: e
			}), r ? null : /* @__PURE__ */ m("span", {
				className: kt.value,
				children: f
			})]
		}), /* @__PURE__ */ m("div", {
			className: kt.track,
			role: "progressbar",
			"aria-label": e,
			"aria-valuemin": r ? void 0 : 0,
			"aria-valuemax": r ? void 0 : n,
			"aria-valuenow": r ? void 0 : u,
			"aria-valuetext": r ? void 0 : f,
			children: /* @__PURE__ */ m("div", {
				className: kt.fill,
				"data-indeterminate": r || void 0,
				style: j({ "--ex-progress-width": r ? void 0 : `${String(d)}%` })
			})
		})]
	});
});
//#endregion
//#region ../../node_modules/.pnpm/@floating-ui+utils@0.2.12/node_modules/@floating-ui/utils/dist/floating-ui.utils.dom.mjs
function Mt() {
	return typeof window < "u";
}
function Nt(e) {
	return Ft(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function B(e) {
	var t;
	return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Pt(e) {
	return ((Ft(e) ? e.ownerDocument : e.document) || window.document)?.documentElement;
}
function Ft(e) {
	return Mt() ? e instanceof Node || e instanceof B(e).Node : !1;
}
function V(e) {
	return Mt() ? e instanceof Element || e instanceof B(e).Element : !1;
}
function H(e) {
	return Mt() ? e instanceof HTMLElement || e instanceof B(e).HTMLElement : !1;
}
function It(e) {
	return !Mt() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof B(e).ShadowRoot;
}
function Lt(e) {
	let { overflow: t, overflowX: n, overflowY: r, display: i } = Jt(e);
	return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && i !== "inline" && i !== "contents";
}
function Rt(e) {
	return /^(table|td|th)$/.test(Nt(e));
}
function zt(e) {
	try {
		if (e.matches(":popover-open")) return !0;
	} catch {}
	try {
		return e.matches(":modal");
	} catch {
		return !1;
	}
}
var Bt = /transform|translate|scale|rotate|perspective|filter/, Vt = /paint|layout|strict|content/, Ht = (e) => !!e && e !== "none", Ut;
function Wt(e) {
	let t = V(e) ? Jt(e) : e;
	return Ht(t.transform) || Ht(t.translate) || Ht(t.scale) || Ht(t.rotate) || Ht(t.perspective) || !Kt() && (Ht(t.backdropFilter) || Ht(t.filter)) || Bt.test(t.willChange || "") || Vt.test(t.contain || "");
}
function Gt(e) {
	let t = Xt(e);
	for (; H(t) && !qt(t);) {
		if (Wt(t)) return t;
		if (zt(t)) return null;
		t = Xt(t);
	}
	return null;
}
function Kt() {
	return Ut ??= typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none"), Ut;
}
function qt(e) {
	return /^(html|body|#document)$/.test(Nt(e));
}
function Jt(e) {
	return B(e).getComputedStyle(e);
}
function Yt(e) {
	return V(e) ? {
		scrollLeft: e.scrollLeft,
		scrollTop: e.scrollTop
	} : {
		scrollLeft: e.scrollX,
		scrollTop: e.scrollY
	};
}
function Xt(e) {
	if (Nt(e) === "html") return e;
	let t = e.assignedSlot || e.parentNode || It(e) && e.host || Pt(e);
	return It(t) ? t.host : t;
}
function Zt(e) {
	let t = Xt(e);
	return qt(t) ? (e.ownerDocument || e).body : H(t) && Lt(t) ? t : Zt(t);
}
function Qt(e, t, n) {
	t === void 0 && (t = []), n === void 0 && (n = !0);
	let r = Zt(e), i = r === e.ownerDocument?.body, a = B(r);
	if (i) {
		let e = $t(a);
		return t.concat(a, a.visualViewport || [], Lt(r) ? r : [], e && n ? Qt(e) : []);
	}
	return t.concat(r, Qt(r, [], n));
}
function $t(e) {
	return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
//#endregion
//#region ../../node_modules/.pnpm/@floating-ui+utils@0.2.12/node_modules/@floating-ui/utils/dist/floating-ui.utils.mjs
var en = Math.min, tn = Math.max, nn = Math.round, rn = Math.floor, an = (e) => ({
	x: e,
	y: e
}), on = {
	left: "right",
	right: "left",
	bottom: "top",
	top: "bottom"
};
function sn(e, t, n) {
	return tn(e, en(t, n));
}
function cn(e, t) {
	return typeof e == "function" ? e(t) : e;
}
function ln(e) {
	return e.split("-")[0];
}
function un(e) {
	return e.split("-")[1];
}
function dn(e) {
	return e === "x" ? "y" : "x";
}
function fn(e) {
	return e === "y" ? "height" : "width";
}
function pn(e) {
	let t = e[0];
	return t === "t" || t === "b" ? "y" : "x";
}
function mn(e) {
	return dn(pn(e));
}
function hn(e, t, n) {
	n === void 0 && (n = !1);
	let r = un(e), i = mn(e), a = fn(i), o = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
	return t.reference[a] > t.floating[a] && (o = wn(o)), [o, wn(o)];
}
function gn(e) {
	let t = wn(e);
	return [
		_n(e),
		t,
		_n(t)
	];
}
function _n(e) {
	return e.includes("start") ? e.replace("start", "end") : e.replace("end", "start");
}
var vn = ["left", "right"], yn = ["right", "left"], bn = ["top", "bottom"], xn = ["bottom", "top"];
function Sn(e, t, n) {
	switch (e) {
		case "top":
		case "bottom": return n ? t ? yn : vn : t ? vn : yn;
		case "left":
		case "right": return t ? bn : xn;
		default: return [];
	}
}
function Cn(e, t, n, r) {
	let i = un(e), a = Sn(ln(e), n === "start", r);
	return i && (a = a.map((e) => e + "-" + i), t && (a = a.concat(a.map(_n)))), a;
}
function wn(e) {
	let t = ln(e);
	return on[t] + e.slice(t.length);
}
function Tn(e) {
	return {
		top: e.top ?? 0,
		right: e.right ?? 0,
		bottom: e.bottom ?? 0,
		left: e.left ?? 0
	};
}
function En(e) {
	return typeof e == "number" ? {
		top: e,
		right: e,
		bottom: e,
		left: e
	} : Tn(e);
}
function Dn(e) {
	let { x: t, y: n, width: r, height: i } = e;
	return {
		width: r,
		height: i,
		top: n,
		left: t,
		right: t + r,
		bottom: n + i,
		x: t,
		y: n
	};
}
var On = /* #__PURE__ */ [
	"input:not([inert]):not([inert] *)",
	"select:not([inert]):not([inert] *)",
	"textarea:not([inert]):not([inert] *)",
	"a[href]:not([inert]):not([inert] *)",
	"area[href]:not([inert]):not([inert] *)",
	"button:not([inert]):not([inert] *)",
	"[tabindex]:not(slot):not([inert]):not([inert] *)",
	"audio[controls]:not([inert]):not([inert] *)",
	"video[controls]:not([inert]):not([inert] *)",
	"[contenteditable]:not([contenteditable=\"false\"]):not([inert]):not([inert] *)",
	"details>summary:first-of-type:not([inert]):not([inert] *)",
	"details:not([inert]):not([inert] *)"
].join(","), kn = typeof Element > "u", An = kn ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, jn = !kn && Element.prototype.getRootNode ? function(e) {
	return e?.getRootNode?.call(e);
} : function(e) {
	return e?.ownerDocument;
}, Mn = function(e, t) {
	t === void 0 && (t = !0);
	var n = e?.getAttribute?.call(e, "inert");
	return n === "" || n === "true" || t && e && (typeof e.closest == "function" ? e.closest("[inert]") : Mn(e.parentNode));
}, Nn = function(e) {
	var t = e?.getAttribute?.call(e, "contenteditable");
	return t === "" || t === "true";
}, Pn = function(e, t, n) {
	if (Mn(e)) return [];
	var r = Array.prototype.slice.apply(e.querySelectorAll(On));
	return t && An.call(e, On) && r.unshift(e), r = r.filter(n), r;
}, Fn = function(e, t, n) {
	for (var r = [], i = Array.from(e); i.length;) {
		var a = i.shift();
		if (!Mn(a, !1)) {
			if (a.tagName === "SLOT") {
				var o = a.assignedElements(), s = Fn(o.length ? o : a.children, !0, n);
				n.flatten ? r.push.apply(r, s) : r.push({
					scopeParent: a,
					candidates: s
				});
			} else {
				An.call(a, On) && n.filter(a) && (t || !e.includes(a)) && r.push(a);
				var c = a.shadowRoot || typeof n.getShadowRoot == "function" && n.getShadowRoot(a), l = !Mn(c, !1) && (!n.shadowRootFilter || n.shadowRootFilter(a));
				if (c && l) {
					var u = Fn(c === !0 ? a.children : c.children, !0, n);
					n.flatten ? r.push.apply(r, u) : r.push({
						scopeParent: a,
						candidates: u
					});
				} else i.unshift.apply(i, a.children);
			}
		}
	}
	return r;
}, In = function(e) {
	return !isNaN(parseInt(e.getAttribute("tabindex"), 10));
}, Ln = function(e) {
	if (!e) throw Error("No node provided");
	return e.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(e.tagName) || Nn(e)) && !In(e) ? 0 : e.tabIndex;
}, Rn = function(e, t) {
	var n = Ln(e);
	return n < 0 && t && !In(e) ? 0 : n;
}, zn = function(e, t) {
	return e.tabIndex === t.tabIndex ? e.documentOrder - t.documentOrder : e.tabIndex - t.tabIndex;
}, Bn = function(e) {
	return e.tagName === "INPUT";
}, Vn = function(e) {
	return Bn(e) && e.type === "hidden";
}, Hn = function(e) {
	return e.tagName === "DETAILS" && Array.prototype.slice.apply(e.children).some(function(e) {
		return e.tagName === "SUMMARY";
	});
}, Un = function(e, t) {
	for (var n = 0; n < e.length; n++) if (e[n].checked && e[n].form === t) return e[n];
}, Wn = function(e) {
	if (!e.name) return !0;
	var t = e.form || jn(e), n = function(e) {
		return t.querySelectorAll("input[type=\"radio\"][name=\"" + e + "\"]");
	}, r;
	if (typeof window < "u" && window.CSS !== void 0 && typeof window.CSS.escape == "function") r = n(window.CSS.escape(e.name));
	else try {
		r = n(e.name);
	} catch (e) {
		return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", e.message), !1;
	}
	var i = Un(r, e.form);
	return !i || i === e;
}, Gn = function(e) {
	return Bn(e) && e.type === "radio";
}, Kn = function(e) {
	return Gn(e) && !Wn(e);
}, qn = function(e) {
	var t = e && jn(e), n = t?.host, r = !1;
	if (t && t !== e) {
		var i, a, o;
		for (r = !!((i = n) != null && (a = i.ownerDocument) != null && a.contains(n) || e != null && (o = e.ownerDocument) != null && o.contains(e)); !r && n;) {
			var s, c;
			t = jn(n), n = t?.host, r = !!((s = n) != null && (c = s.ownerDocument) != null && c.contains(n));
		}
	}
	return r;
}, Jn = function(e) {
	var t = e.getBoundingClientRect(), n = t.width, r = t.height;
	return n === 0 && r === 0;
}, Yn = function(e, t) {
	var n = t.displayCheck, r = t.getShadowRoot;
	if (n === "full-native" && "checkVisibility" in e) return !e.checkVisibility({
		checkOpacity: !1,
		opacityProperty: !1,
		contentVisibilityAuto: !0,
		visibilityProperty: !0,
		checkVisibilityCSS: !0
	});
	var i = getComputedStyle(e).visibility;
	if (i === "hidden" || i === "collapse") return !0;
	var a = An.call(e, "details>summary:first-of-type") ? e.parentElement : e;
	if (An.call(a, "details:not([open]) *")) return !0;
	if (!n || n === "full" || n === "full-native" || n === "legacy-full") {
		if (typeof r == "function") {
			for (var o = e; e;) {
				var s = e.parentElement, c = jn(e);
				if (s && !s.shadowRoot && r(s) === !0) return Jn(e);
				e = e.assignedSlot ? e.assignedSlot : !s && c !== e.ownerDocument ? c.host : s;
			}
			e = o;
		}
		if (qn(e)) return !e.getClientRects().length;
		if (n !== "legacy-full") return !0;
	} else if (n === "non-zero-area") return Jn(e);
	return !1;
}, Xn = function(e) {
	if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(e.tagName)) for (var t = e.parentElement; t;) {
		if (t.tagName === "FIELDSET" && t.disabled) {
			for (var n = 0; n < t.children.length; n++) {
				var r = t.children.item(n);
				if (r.tagName === "LEGEND") return An.call(t, "fieldset[disabled] *") ? !0 : !r.contains(e);
			}
			return !0;
		}
		t = t.parentElement;
	}
	return !1;
}, Zn = function(e, t) {
	return !(t.disabled || Vn(t) || Yn(t, e) || Hn(t) || Xn(t));
}, Qn = function(e, t) {
	return !(Kn(t) || Ln(t) < 0 || !Zn(e, t));
}, $n = function(e) {
	var t = parseInt(e.getAttribute("tabindex"), 10);
	return !!(isNaN(t) || t >= 0);
}, er = function(e) {
	var t = [], n = [];
	return e.forEach(function(e, r) {
		var i = !!e.scopeParent, a = i ? e.scopeParent : e, o = Rn(a, i), s = i ? er(e.candidates) : a;
		o === 0 ? i ? t.push.apply(t, s) : t.push(a) : n.push({
			documentOrder: r,
			tabIndex: o,
			item: e,
			isScope: i,
			content: s
		});
	}), n.sort(zn).reduce(function(e, t) {
		return t.isScope ? e.push.apply(e, t.content) : e.push(t.content), e;
	}, []).concat(t);
}, tr = function(e, t) {
	return t ||= {}, er(t.getShadowRoot ? Fn([e], t.includeContainer, {
		filter: Qn.bind(null, t),
		flatten: !1,
		getShadowRoot: t.getShadowRoot,
		shadowRootFilter: $n
	}) : Pn(e, t.includeContainer, Qn.bind(null, t)));
}, nr = function(e, t) {
	return t ||= {}, t.getShadowRoot ? Fn([e], t.includeContainer, {
		filter: Zn.bind(null, t),
		flatten: !0,
		getShadowRoot: t.getShadowRoot
	}) : Pn(e, t.includeContainer, Zn.bind(null, t));
}, rr = function(e, t) {
	if (t ||= {}, !e) throw Error("No node provided");
	return An.call(e, On) !== !1 && Qn(t, e);
};
//#endregion
//#region ../../node_modules/.pnpm/@floating-ui+react@0.27.20_react-dom@19.3.0_react@19.3.0__react@19.3.0/node_modules/@floating-ui/react/dist/floating-ui.react.utils.mjs
function ir() {
	let e = navigator.userAgentData;
	return e != null && e.platform ? e.platform : navigator.platform;
}
function ar() {
	let e = navigator.userAgentData;
	return e && Array.isArray(e.brands) ? e.brands.map((e) => {
		let { brand: t, version: n } = e;
		return t + "/" + n;
	}).join(" ") : navigator.userAgent;
}
function or() {
	return /apple/i.test(navigator.vendor);
}
function sr() {
	let e = /android/i;
	return e.test(ir()) || e.test(ar());
}
function cr() {
	return ir().toLowerCase().startsWith("mac") && !navigator.maxTouchPoints;
}
function lr() {
	return ar().includes("jsdom/");
}
var ur = "data-floating-ui-focusable", dr = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])", fr = "ArrowLeft", pr = "ArrowRight", mr = "ArrowUp", hr = "ArrowDown";
function gr(e) {
	let t = e.activeElement;
	for (; ((n = t) == null || (n = n.shadowRoot) == null ? void 0 : n.activeElement) != null;) {
		var n;
		t = t.shadowRoot.activeElement;
	}
	return t;
}
function U(e, t) {
	if (!e || !t) return !1;
	let n = t.getRootNode == null ? void 0 : t.getRootNode();
	if (e.contains(t)) return !0;
	if (n && It(n)) {
		let n = t;
		for (; n;) {
			if (e === n) return !0;
			n = n.parentNode || n.host;
		}
	}
	return !1;
}
function _r(e) {
	return "composedPath" in e ? e.composedPath()[0] : e.target;
}
function vr(e, t) {
	if (t == null) return !1;
	if ("composedPath" in e) return e.composedPath().includes(t);
	let n = e;
	return n.target != null && t.contains(n.target);
}
function yr(e) {
	return e.matches("html,body");
}
function W(e) {
	return e?.ownerDocument || document;
}
function br(e) {
	return H(e) && e.matches(dr);
}
function xr(e) {
	return e ? e.getAttribute("role") === "combobox" && br(e) : !1;
}
function Sr(e) {
	if (!e || lr()) return !0;
	try {
		return e.matches(":focus-visible");
	} catch {
		return !0;
	}
}
function Cr(e) {
	return e ? e.hasAttribute(ur) ? e : e.querySelector("[" + ur + "]") || e : null;
}
function wr(e, t, n) {
	return n === void 0 && (n = !0), e.filter((e) => e.parentId === t && (!n || e.context?.open)).flatMap((t) => [t, ...wr(e, t.id, n)]);
}
function Tr(e, t) {
	let n, r = -1;
	function i(t, a) {
		a > r && (n = t, r = a), wr(e, t).forEach((e) => {
			i(e.id, a + 1);
		});
	}
	return i(t, 0), e.find((e) => e.id === n);
}
function Er(e, t) {
	let n = [], r = e.find((e) => e.id === t)?.parentId;
	for (; r;) {
		let t = e.find((e) => e.id === r);
		r = t?.parentId, t && (n = n.concat(t));
	}
	return n;
}
function G(e) {
	e.preventDefault(), e.stopPropagation();
}
function Dr(e) {
	return "nativeEvent" in e;
}
function Or(e) {
	return e.mozInputSource === 0 && e.isTrusted ? !0 : sr() && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
function kr(e) {
	return lr() ? !1 : !sr() && e.width === 0 && e.height === 0 || sr() && e.width === 1 && e.height === 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "mouse" || e.width < 1 && e.height < 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "touch";
}
function Ar(e, t) {
	let n = ["mouse", "pen"];
	return t || n.push("", void 0), n.includes(e);
}
var K = typeof document < "u" ? c : function() {}, jr = { ...e };
function Mr(t) {
	let n = e.useRef(t);
	return K(() => {
		n.current = t;
	}), n;
}
var Nr = jr.useInsertionEffect || ((e) => e());
function q(t) {
	let n = e.useRef(() => {
		if (process.env.NODE_ENV !== "production") throw Error("Cannot call an event handler while rendering.");
	});
	return Nr(() => {
		n.current = t;
	}), e.useCallback(function() {
		var e = [...arguments];
		return n.current == null ? void 0 : n.current(...e);
	}, []);
}
function Pr(e, t, n) {
	return Math.floor(e / t) !== n;
}
function Fr(e, t) {
	return t < 0 || t >= e.current.length;
}
function Ir(e, t) {
	return J(e, { disabledIndices: t });
}
function Lr(e, t) {
	return J(e, {
		decrement: !0,
		startingIndex: e.current.length,
		disabledIndices: t
	});
}
function J(e, t) {
	let { startingIndex: n = -1, decrement: r = !1, disabledIndices: i, amount: a = 1 } = t === void 0 ? {} : t, o = n;
	do
		o += r ? -a : a;
	while (o >= 0 && o <= e.current.length - 1 && Hr(e, o, i));
	return o;
}
function Rr(e, t) {
	let { event: n, orientation: r, loop: i, rtl: a, cols: o, disabledIndices: s, minIndex: c, maxIndex: l, prevIndex: u, stopEvent: d = !1 } = t, f = u;
	if (n.key === mr) {
		if (d && G(n), u === -1) f = l;
		else if (f = J(e, {
			startingIndex: f,
			amount: o,
			decrement: !0,
			disabledIndices: s
		}), i && (u - o < c || f < 0)) {
			let e = u % o, t = l % o, n = l - (t - e);
			f = t === e ? l : t > e ? n : n - o;
		}
		Fr(e, f) && (f = u);
	}
	if (n.key === hr && (d && G(n), u === -1 ? f = c : (f = J(e, {
		startingIndex: u,
		amount: o,
		disabledIndices: s
	}), i && u + o > l && (f = J(e, {
		startingIndex: u % o - o,
		amount: o,
		disabledIndices: s
	}))), Fr(e, f) && (f = u)), r === "both") {
		let t = rn(u / o);
		n.key === (a ? fr : pr) && (d && G(n), u % o === o - 1 ? i && (f = J(e, {
			startingIndex: u - u % o - 1,
			disabledIndices: s
		})) : (f = J(e, {
			startingIndex: u,
			disabledIndices: s
		}), i && Pr(f, o, t) && (f = J(e, {
			startingIndex: u - u % o - 1,
			disabledIndices: s
		}))), Pr(f, o, t) && (f = u)), n.key === (a ? pr : fr) && (d && G(n), u % o === 0 ? i && (f = J(e, {
			startingIndex: u + (o - u % o),
			decrement: !0,
			disabledIndices: s
		})) : (f = J(e, {
			startingIndex: u,
			decrement: !0,
			disabledIndices: s
		}), i && Pr(f, o, t) && (f = J(e, {
			startingIndex: u + (o - u % o),
			decrement: !0,
			disabledIndices: s
		}))), Pr(f, o, t) && (f = u));
		let r = rn(l / o) === t;
		Fr(e, f) && (f = i && r ? n.key === (a ? pr : fr) ? l : J(e, {
			startingIndex: u - u % o - 1,
			disabledIndices: s
		}) : u);
	}
	return f;
}
function zr(e, t, n) {
	let r = [], i = 0;
	return e.forEach((e, a) => {
		let { width: o, height: s } = e;
		if (o > t && process.env.NODE_ENV !== "production") throw Error("[Floating UI]: Invalid grid - item width at index " + a + " is greater than grid columns");
		let c = !1;
		for (n && (i = 0); !c;) {
			let e = [];
			for (let n = 0; n < o; n++) for (let r = 0; r < s; r++) e.push(i + n + r * t);
			i % t + o <= t && e.every((e) => r[e] == null) ? (e.forEach((e) => {
				r[e] = a;
			}), c = !0) : i++;
		}
	}), [...r];
}
function Br(e, t, n, r, i) {
	if (e === -1) return -1;
	let a = n.indexOf(e), o = t[e];
	switch (i) {
		case "tl": return a;
		case "tr": return o ? a + o.width - 1 : a;
		case "bl": return o ? a + (o.height - 1) * r : a;
		case "br": return n.lastIndexOf(e);
	}
}
function Vr(e, t) {
	return t.flatMap((t, n) => e.includes(t) ? [n] : []);
}
function Hr(e, t, n) {
	if (typeof n == "function") return n(t);
	if (n) return n.includes(t);
	let r = e.current[t];
	return r == null || r.hasAttribute("disabled") || r.getAttribute("aria-disabled") === "true";
}
var Ur = () => ({
	getShadowRoot: !0,
	displayCheck: typeof ResizeObserver == "function" && ResizeObserver.toString().includes("[native code]") ? "full" : "none"
});
function Wr(e, t) {
	let n = tr(e, Ur()), r = n.length;
	if (r === 0) return;
	let i = gr(W(e)), a = n.indexOf(i);
	return n[a === -1 ? t === 1 ? 0 : r - 1 : a + t];
}
function Gr(e) {
	return Wr(W(e).body, 1) || e;
}
function Kr(e) {
	return Wr(W(e).body, -1) || e;
}
function qr(e, t) {
	let n = t || e.currentTarget, r = e.relatedTarget;
	return !r || !U(n, r);
}
function Jr(e) {
	tr(e, Ur()).forEach((e) => {
		e.dataset.tabindex = e.getAttribute("tabindex") || "", e.setAttribute("tabindex", "-1");
	});
}
function Yr(e) {
	e.querySelectorAll("[data-tabindex]").forEach((e) => {
		let t = e.dataset.tabindex;
		delete e.dataset.tabindex, t ? e.setAttribute("tabindex", t) : e.removeAttribute("tabindex");
	});
}
//#endregion
//#region ../../node_modules/.pnpm/@floating-ui+core@1.8.0/node_modules/@floating-ui/core/dist/floating-ui.core.mjs
function Xr(e, t, n) {
	let { reference: r, floating: i } = e, a = pn(t), o = mn(t), s = fn(o), c = ln(t), l = a === "y", u = r.x + r.width / 2 - i.width / 2, d = r.y + r.height / 2 - i.height / 2, f = r[s] / 2 - i[s] / 2, p;
	switch (c) {
		case "top":
			p = {
				x: u,
				y: r.y - i.height
			};
			break;
		case "bottom":
			p = {
				x: u,
				y: r.y + r.height
			};
			break;
		case "right":
			p = {
				x: r.x + r.width,
				y: d
			};
			break;
		case "left":
			p = {
				x: r.x - i.width,
				y: d
			};
			break;
		default: p = {
			x: r.x,
			y: r.y
		};
	}
	let m = un(t);
	return m && (p[o] += f * (m === "end" ? 1 : -1) * (n && l ? -1 : 1)), p;
}
async function Zr(e, t) {
	t === void 0 && (t = {});
	let { x: n, y: r, platform: i, rects: a, elements: o, strategy: s } = e, { boundary: c = "clippingAncestors", rootBoundary: l = "viewport", elementContext: u = "floating", altBoundary: d = !1, padding: f = 0 } = cn(t, e), p = En(f), m = o[d ? u === "floating" ? "reference" : "floating" : u], h = Dn(await i.getClippingRect({
		element: await (i.isElement == null ? void 0 : i.isElement(m)) ?? !0 ? m : m.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(o.floating)),
		boundary: c,
		rootBoundary: l,
		strategy: s
	})), g = u === "floating" ? {
		x: n,
		y: r,
		width: a.floating.width,
		height: a.floating.height
	} : a.reference, _ = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(o.floating)), v = await (i.isElement == null ? void 0 : i.isElement(_)) && await (i.getScale == null ? void 0 : i.getScale(_)) || {
		x: 1,
		y: 1
	}, y = Dn(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
		elements: o,
		rect: g,
		offsetParent: _,
		strategy: s
	}) : g);
	return {
		top: (h.top - y.top + p.top) / v.y,
		bottom: (y.bottom - h.bottom + p.bottom) / v.y,
		left: (h.left - y.left + p.left) / v.x,
		right: (y.right - h.right + p.right) / v.x
	};
}
var Qr = 50, $r = async (e, t, n) => {
	let { placement: r = "bottom", strategy: i = "absolute", middleware: a = [], platform: o } = n, s = o.detectOverflow ? o : {
		...o,
		detectOverflow: Zr
	}, c = await (o.isRTL == null ? void 0 : o.isRTL(t)), l = await o.getElementRects({
		reference: e,
		floating: t,
		strategy: i
	}), { x: u, y: d } = Xr(l, r, c), f = r, p = 0, m = {};
	for (let n = 0; n < a.length; n++) {
		let h = a[n];
		if (!h) continue;
		let { name: g, fn: _ } = h, { x: v, y, data: b, reset: x } = await _({
			x: u,
			y: d,
			initialPlacement: r,
			placement: f,
			strategy: i,
			middlewareData: m,
			rects: l,
			platform: s,
			elements: {
				reference: e,
				floating: t
			}
		});
		u = v ?? u, d = y ?? d, m[g] = {
			...m[g],
			...b
		}, x && p < Qr && (p++, typeof x == "object" && (x.placement && (f = x.placement), x.rects && (l = x.rects === !0 ? await o.getElementRects({
			reference: e,
			floating: t,
			strategy: i
		}) : x.rects), {x: u, y: d} = Xr(l, f, c)), n = -1);
	}
	return {
		x: u,
		y: d,
		placement: f,
		strategy: i,
		middlewareData: m
	};
}, ei = function(e) {
	return e === void 0 && (e = {}), {
		name: "flip",
		options: e,
		async fn(t) {
			var n;
			let { placement: r, middlewareData: i, rects: a, initialPlacement: o, platform: s, elements: c } = t, { mainAxis: l = !0, crossAxis: u = !0, fallbackPlacements: d, fallbackStrategy: f = "bestFit", fallbackAxisSideDirection: p = "none", flipAlignment: m = !0, ...h } = cn(e, t);
			if ((n = i.arrow) != null && n.alignmentOffset) return {};
			let g = ln(r), _ = pn(o), v = ln(o) === o, y = await (s.isRTL == null ? void 0 : s.isRTL(c.floating)), b = d || (v || !m ? [wn(o)] : gn(o)), x = p !== "none";
			!d && x && b.push(...Cn(o, m, p, y));
			let S = [o, ...b], C = await s.detectOverflow(t, h), w = [], T = i.flip?.overflows || [];
			if (l && w.push(C[g]), u) {
				let e = hn(r, a, y);
				w.push(C[e[0]], C[e[1]]);
			}
			if (T = [...T, {
				placement: r,
				overflows: w
			}], !w.every((e) => e <= 0)) {
				let e = (i.flip?.index || 0) + 1, t = S[e];
				if (t && (u !== "alignment" || _ === pn(t) || T.every((e) => pn(e.placement) !== _ || e.overflows[0] > 0))) return {
					data: {
						index: e,
						overflows: T
					},
					reset: { placement: t }
				};
				let n = T.filter((e) => e.overflows[0] <= 0).sort((e, t) => e.overflows[1] - t.overflows[1])[0]?.placement;
				if (!n) switch (f) {
					case "bestFit": {
						let e = T.filter((e) => {
							if (x) {
								let t = pn(e.placement);
								return t === _ || t === "y";
							}
							return !0;
						}).map((e) => [e.placement, e.overflows.filter((e) => e > 0).reduce((e, t) => e + t, 0)]).sort((e, t) => e[1] - t[1])[0]?.[0];
						e && (n = e);
						break;
					}
					case "initialPlacement": n = o;
				}
				if (r !== n) return { reset: { placement: n } };
			}
			return {};
		}
	};
}, ti = /*#__PURE__*/ new Set(["left", "top"]);
async function ni(e, t) {
	let { placement: n, platform: r, elements: i } = e, a = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), o = ln(n), s = un(n), c = pn(n) === "y", l = ti.has(o) ? -1 : 1, u = a && c ? -1 : 1, d = cn(t, e), { mainAxis: f, crossAxis: p, alignmentAxis: m } = typeof d == "number" ? {
		mainAxis: d,
		crossAxis: 0,
		alignmentAxis: null
	} : {
		mainAxis: d.mainAxis || 0,
		crossAxis: d.crossAxis || 0,
		alignmentAxis: d.alignmentAxis
	};
	return s && typeof m == "number" && (p = s === "end" ? m * -1 : m), c ? {
		x: p * u,
		y: f * l
	} : {
		x: f * l,
		y: p * u
	};
}
var ri = function(e) {
	return e === void 0 && (e = 0), {
		name: "offset",
		options: e,
		async fn(t) {
			var n;
			let { x: r, y: i, placement: a, middlewareData: o } = t, s = await ni(t, e);
			return a === o.offset?.placement && (n = o.arrow) != null && n.alignmentOffset ? {} : {
				x: r + s.x,
				y: i + s.y,
				data: {
					...s,
					placement: a
				}
			};
		}
	};
}, ii = function(e) {
	return e === void 0 && (e = {}), {
		name: "shift",
		options: e,
		async fn(t) {
			let { x: n, y: r, placement: i, platform: a } = t, { mainAxis: o = !0, crossAxis: s = !1, limiter: c = { fn: (e) => {
				let { x: t, y: n } = e;
				return {
					x: t,
					y: n
				};
			} }, ...l } = cn(e, t), u = {
				x: n,
				y: r
			}, d = await a.detectOverflow(t, l), f = pn(i), p = dn(f), m = u[p], h = u[f], g = (e, t) => sn(t + d[e === "y" ? "top" : "left"], t, t - d[e === "y" ? "bottom" : "right"]);
			o && (m = g(p, m)), s && (h = g(f, h));
			let _ = c.fn({
				...t,
				[p]: m,
				[f]: h
			});
			return {
				..._,
				data: {
					x: _.x - n,
					y: _.y - r,
					enabled: {
						[p]: o,
						[f]: s
					}
				}
			};
		}
	};
};
//#endregion
//#region ../../node_modules/.pnpm/@floating-ui+dom@1.8.0/node_modules/@floating-ui/dom/dist/floating-ui.dom.mjs
function ai(e) {
	let t = Jt(e), n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0, i = H(e), a = i ? e.offsetWidth : n, o = i ? e.offsetHeight : r, s = nn(n) !== a || nn(r) !== o;
	return s && (n = a, r = o), {
		width: n,
		height: r,
		$: s
	};
}
function oi(e) {
	return V(e) ? e : e.contextElement;
}
function si(e) {
	let t = oi(e);
	if (!H(t)) return an(1);
	let n = t.getBoundingClientRect(), { width: r, height: i, $: a } = ai(t), o = (a ? nn(n.width) : n.width) / r, s = (a ? nn(n.height) : n.height) / i;
	return (!o || !Number.isFinite(o)) && (o = 1), (!s || !Number.isFinite(s)) && (s = 1), {
		x: o,
		y: s
	};
}
var ci = /*#__PURE__*/ an(0);
function li(e) {
	let t = B(e);
	return !Kt() || !t.visualViewport ? ci : {
		x: t.visualViewport.offsetLeft,
		y: t.visualViewport.offsetTop
	};
}
function ui(e, t, n) {
	return t === void 0 && (t = !1), !!n && t && n === B(e);
}
function di(e, t, n, r) {
	t === void 0 && (t = !1), n === void 0 && (n = !1);
	let i = e.getBoundingClientRect(), a = oi(e), o = an(1);
	t && (r ? V(r) && (o = si(r)) : o = si(e));
	let s = ui(a, n, r) ? li(a) : an(0), c = (i.left + s.x) / o.x, l = (i.top + s.y) / o.y, u = i.width / o.x, d = i.height / o.y;
	if (a && r) {
		let e = B(a), t = V(r) ? B(r) : r, n = e, i = $t(n);
		for (; i && t !== n;) {
			let e = si(i), t = i.getBoundingClientRect(), r = Jt(i), a = t.left + (i.clientLeft + parseFloat(r.paddingLeft)) * e.x, o = t.top + (i.clientTop + parseFloat(r.paddingTop)) * e.y;
			c *= e.x, l *= e.y, u *= e.x, d *= e.y, c += a, l += o, n = B(i), i = $t(n);
		}
	}
	return Dn({
		width: u,
		height: d,
		x: c,
		y: l
	});
}
function fi(e, t) {
	let n = Yt(e).scrollLeft;
	return t ? t.left + n : di(Pt(e)).left + n;
}
function pi(e, t) {
	let n = e.getBoundingClientRect();
	return {
		x: n.left + t.scrollLeft - fi(e, n),
		y: n.top + t.scrollTop
	};
}
function mi(e) {
	let { elements: t, rect: n, offsetParent: r, strategy: i } = e, a = i === "fixed", o = Pt(r), s = t ? zt(t.floating) : !1;
	if (r === o || s && a) return n;
	let c = {
		scrollLeft: 0,
		scrollTop: 0
	}, l = an(1), u = an(0), d = H(r);
	if ((d || !a) && ((Nt(r) !== "body" || Lt(o)) && (c = Yt(r)), d)) {
		let e = di(r);
		l = si(r), u.x = e.x + r.clientLeft, u.y = e.y + r.clientTop;
	}
	let f = o && !d && !a ? pi(o, c) : an(0);
	return {
		width: n.width * l.x,
		height: n.height * l.y,
		x: n.x * l.x - c.scrollLeft * l.x + u.x + f.x,
		y: n.y * l.y - c.scrollTop * l.y + u.y + f.y
	};
}
function hi(e) {
	return e.getClientRects ? Array.from(e.getClientRects()) : [];
}
function gi(e) {
	let t = Yt(e), n = e.ownerDocument.body, r = tn(e.scrollWidth, e.clientWidth, n.scrollWidth, n.clientWidth), i = tn(e.scrollHeight, e.clientHeight, n.scrollHeight, n.clientHeight), a = -t.scrollLeft + fi(e), o = -t.scrollTop;
	return Jt(n).direction === "rtl" && (a += tn(e.clientWidth, n.clientWidth) - r), {
		width: r,
		height: i,
		x: a,
		y: o
	};
}
var _i = 25;
function vi(e, t, n) {
	n === void 0 && (n = "viewport");
	let r = n === "layoutViewport", i = B(e), a = Pt(e), o = i.visualViewport, s = a.clientWidth, c = a.clientHeight, l = 0, u = 0;
	if (o) {
		let e = !Kt() || t === "fixed";
		r ? e || (l = -o.offsetLeft, u = -o.offsetTop) : (s = o.width, c = o.height, e && (l = o.offsetLeft, u = o.offsetTop));
	}
	if (fi(a) <= 0) {
		let e = a.ownerDocument, t = e.body, n = getComputedStyle(t), r = e.compatMode === "CSS1Compat" && parseFloat(n.marginLeft) + parseFloat(n.marginRight) || 0, i = Math.abs(a.clientWidth - t.clientWidth - r), o = getComputedStyle(a).scrollbarGutter === "stable both-edges" ? i / 2 : i;
		o <= _i && (s -= o);
	}
	return {
		width: s,
		height: c,
		x: l,
		y: u
	};
}
function yi(e, t) {
	let n = di(e, !0, t === "fixed"), r = n.top + e.clientTop, i = n.left + e.clientLeft, a = si(e);
	return {
		width: e.clientWidth * a.x,
		height: e.clientHeight * a.y,
		x: i * a.x,
		y: r * a.y
	};
}
function bi(e, t, n) {
	let r;
	if (t === "viewport" || t === "layoutViewport") r = vi(e, n, t);
	else if (t === "document") r = gi(Pt(e));
	else if (V(t)) r = yi(t, n);
	else {
		let n = li(e);
		r = {
			x: t.x - n.x,
			y: t.y - n.y,
			width: t.width,
			height: t.height
		};
	}
	return Dn(r);
}
function xi(e, t) {
	let n = t.get(e);
	if (n) return n;
	let r = Qt(e, [], !1).filter((e) => V(e) && Nt(e) !== "body"), i = null, a = Jt(e).position === "fixed", o = a ? Xt(e) : e;
	for (; V(o) && !qt(o);) {
		let e = Jt(o), t = Wt(o), n = i ? i.position : a ? "fixed" : "";
		!t && (n === "fixed" || n === "absolute" && e.position === "static") ? r = r.filter((e) => e !== o) : i = e, o = Xt(o);
	}
	return t.set(e, r), r;
}
function Si(e) {
	let { element: t, boundary: n, rootBoundary: r, strategy: i } = e, a = [...n === "clippingAncestors" ? zt(t) ? [] : xi(t, this._c) : [].concat(n), r], o = bi(t, a[0], i), s = o.top, c = o.right, l = o.bottom, u = o.left;
	for (let e = 1; e < a.length; e++) {
		let n = bi(t, a[e], i);
		s = tn(n.top, s), c = en(n.right, c), l = en(n.bottom, l), u = tn(n.left, u);
	}
	return {
		width: c - u,
		height: l - s,
		x: u,
		y: s
	};
}
function Ci(e) {
	let { width: t, height: n } = ai(e);
	return {
		width: t,
		height: n
	};
}
function wi(e, t, n) {
	let r = H(t), i = Pt(t), a = n === "fixed", o = di(e, !0, a, t), s = {
		scrollLeft: 0,
		scrollTop: 0
	}, c = an(0);
	if ((r || !a) && ((Nt(t) !== "body" || Lt(i)) && (s = Yt(t)), r)) {
		let e = di(t, !0, a, t);
		c.x = e.x + t.clientLeft, c.y = e.y + t.clientTop;
	}
	!r && i && (c.x = fi(i));
	let l = i && !r && !a ? pi(i, s) : an(0);
	return {
		x: o.left + s.scrollLeft - c.x - l.x,
		y: o.top + s.scrollTop - c.y - l.y,
		width: o.width,
		height: o.height
	};
}
function Ti(e) {
	return Jt(e).position === "static";
}
function Ei(e, t) {
	if (!H(e) || Jt(e).position === "fixed") return null;
	if (t) return t(e);
	let n = e.offsetParent;
	return Pt(e) === n && (n = n.ownerDocument.body), n;
}
function Di(e, t) {
	let n = B(e);
	if (zt(e)) return n;
	if (!H(e)) {
		let t = Xt(e);
		for (; t && !qt(t);) {
			if (V(t) && !Ti(t)) return t;
			t = Xt(t);
		}
		return n;
	}
	let r = Ei(e, t);
	for (; r && Rt(r) && Ti(r);) r = Ei(r, t);
	return r && qt(r) && Ti(r) && !Wt(r) ? n : r || Gt(e) || n;
}
var Oi = async function(e) {
	let t = this.getOffsetParent || Di, n = this.getDimensions, r = await n(e.floating);
	return {
		reference: wi(e.reference, await t(e.floating), e.strategy),
		floating: {
			x: 0,
			y: 0,
			width: r.width,
			height: r.height
		}
	};
};
function ki(e) {
	return Jt(e).direction === "rtl";
}
var Ai = {
	convertOffsetParentRelativeRectToViewportRelativeRect: mi,
	getDocumentElement: Pt,
	getClippingRect: Si,
	getOffsetParent: Di,
	getElementRects: Oi,
	getClientRects: hi,
	getDimensions: Ci,
	getScale: si,
	isElement: V,
	isRTL: ki
};
function ji(e, t) {
	return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function Mi(e, t, n) {
	let r = null, i, a = Pt(e);
	function o() {
		var e;
		clearTimeout(i), (e = r) == null || e.disconnect(), r = null;
	}
	function s(n, c) {
		n === void 0 && (n = !1), c === void 0 && (c = 1), o();
		let l = e.getBoundingClientRect(), { left: u, top: d, width: f, height: p } = l;
		if (n || t(), !f || !p) return;
		let m = rn(d), h = rn(a.clientWidth - (u + f)), g = rn(a.clientHeight - (d + p)), _ = rn(u), v = {
			rootMargin: -m + "px " + -h + "px " + -g + "px " + -_ + "px",
			threshold: tn(0, en(1, c)) || 1
		}, y = !0;
		function b(t) {
			let n = t[0].intersectionRatio;
			if (!ji(l, e.getBoundingClientRect())) return s();
			if (n !== c) {
				if (!y) return s();
				n ? s(!1, n) : i = setTimeout(() => {
					s(!1, 1e-7);
				}, 1e3);
			}
			y = !1;
		}
		try {
			r = new IntersectionObserver(b, {
				...v,
				root: a.ownerDocument
			});
		} catch {
			r = new IntersectionObserver(b, v);
		}
		r.observe(e);
	}
	let c = B(e), l = () => s(n);
	return c.addEventListener("resize", l), s(!0), () => {
		c.removeEventListener("resize", l), o();
	};
}
function Ni(e, t, n, r) {
	r === void 0 && (r = {});
	let { ancestorScroll: i = !0, ancestorResize: a = !0, elementResize: o = typeof ResizeObserver == "function", layoutShift: s = typeof IntersectionObserver == "function", animationFrame: c = !1 } = r, l = oi(e), u = i || a ? [...l ? Qt(l) : [], ...t ? Qt(t) : []] : [];
	u.forEach((e) => {
		i && e.addEventListener("scroll", n), a && e.addEventListener("resize", n);
	});
	let d = l && s ? Mi(l, n, a) : null, f = -1, p = null;
	o && (p = new ResizeObserver((e) => {
		let [r] = e;
		r && r.target === l && p && t && (p.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
			var e;
			(e = p) == null || e.observe(t);
		})), n();
	}), l && !c && p.observe(l), t && p.observe(t));
	let m, h = c ? di(e) : null;
	c && g();
	function g() {
		let t = di(e);
		h && !ji(h, t) && n(), h = t, m = requestAnimationFrame(g);
	}
	return n(), () => {
		var e;
		u.forEach((e) => {
			i && e.removeEventListener("scroll", n), a && e.removeEventListener("resize", n);
		}), d?.(), (e = p) == null || e.disconnect(), p = null, c && cancelAnimationFrame(m);
	};
}
var Pi = ri, Fi = ii, Ii = ei, Li = (e, t, n) => {
	let r = /* @__PURE__ */ new Map(), i = n ?? {}, a = {
		...Ai,
		...i.platform,
		_c: r
	};
	return $r(e, t, {
		...i,
		platform: a
	});
}, Ri = typeof document < "u" ? c : function() {};
function zi(e, t) {
	if (e === t) return !0;
	if (typeof e != typeof t) return !1;
	if (typeof e == "function" && e.toString() === t.toString()) return !0;
	let n, r, i;
	if (e && t && typeof e == "object") {
		if (Array.isArray(e)) {
			if (n = e.length, n !== t.length) return !1;
			for (r = n; r-- !== 0;) if (!zi(e[r], t[r])) return !1;
			return !0;
		}
		if (i = Object.keys(e), n = i.length, n !== Object.keys(t).length) return !1;
		for (r = n; r-- !== 0;) if (!{}.hasOwnProperty.call(t, i[r])) return !1;
		for (r = n; r-- !== 0;) {
			let n = i[r];
			if (!(n === "_owner" && e.$$typeof) && !zi(e[n], t[n])) return !1;
		}
		return !0;
	}
	return e !== e && t !== t;
}
function Bi(e) {
	return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Vi(e, t) {
	let n = Bi(e);
	return Math.round(t * n) / n;
}
function Hi(t) {
	let n = e.useRef(t);
	return Ri(() => {
		n.current = t;
	}), n;
}
function Ui(t) {
	t === void 0 && (t = {});
	let { placement: n = "bottom", strategy: r = "absolute", middleware: i = [], platform: a, elements: { reference: o, floating: s } = {}, transform: c = !0, whileElementsMounted: l, open: u } = t, [d, f] = e.useState({
		x: 0,
		y: 0,
		strategy: r,
		placement: n,
		middlewareData: {},
		isPositioned: !1
	}), [p, m] = e.useState(i);
	zi(p, i) || m(i);
	let [h, _] = e.useState(null), [v, y] = e.useState(null), b = e.useCallback((e) => {
		e !== w.current && (w.current = e, _(e));
	}, []), x = e.useCallback((e) => {
		e !== T.current && (T.current = e, y(e));
	}, []), S = o || h, C = s || v, w = e.useRef(null), T = e.useRef(null), E = e.useRef(d), D = l != null, O = Hi(l), k = Hi(a), A = Hi(u), j = e.useCallback(() => {
		if (!w.current || !T.current) return;
		let e = {
			placement: n,
			strategy: r,
			middleware: p
		};
		k.current && (e.platform = k.current), Li(w.current, T.current, e).then((e) => {
			let t = {
				...e,
				isPositioned: A.current !== !1
			};
			M.current && !zi(E.current, t) && (E.current = t, g.flushSync(() => {
				f(t);
			}));
		});
	}, [
		p,
		n,
		r,
		k,
		A
	]);
	Ri(() => {
		u === !1 && E.current.isPositioned && (E.current.isPositioned = !1, f((e) => ({
			...e,
			isPositioned: !1
		})));
	}, [u]);
	let M = e.useRef(!1);
	Ri(() => (M.current = !0, () => {
		M.current = !1;
	}), []), Ri(() => {
		if (S && (w.current = S), C && (T.current = C), S && C) {
			if (O.current) return O.current(S, C, j);
			j();
		}
	}, [
		S,
		C,
		j,
		O,
		D
	]);
	let N = e.useMemo(() => ({
		reference: w,
		floating: T,
		setReference: b,
		setFloating: x
	}), [b, x]), P = e.useMemo(() => ({
		reference: S,
		floating: C
	}), [S, C]), F = e.useMemo(() => {
		let e = {
			position: r,
			left: 0,
			top: 0
		};
		if (!P.floating) return e;
		let t = Vi(P.floating, d.x), n = Vi(P.floating, d.y);
		return c ? {
			...e,
			transform: "translate(" + t + "px, " + n + "px)",
			...Bi(P.floating) >= 1.5 && { willChange: "transform" }
		} : {
			position: r,
			left: t,
			top: n
		};
	}, [
		r,
		c,
		P.floating,
		d.x,
		d.y
	]);
	return e.useMemo(() => ({
		...d,
		update: j,
		refs: N,
		elements: P,
		floatingStyles: F
	}), [
		d,
		j,
		N,
		P,
		F
	]);
}
var Wi = (e, t) => {
	let n = Pi(e);
	return {
		name: n.name,
		fn: n.fn,
		options: [e, t]
	};
}, Gi = (e, t) => {
	let n = Fi(e);
	return {
		name: n.name,
		fn: n.fn,
		options: [e, t]
	};
}, Ki = (e, t) => {
	let n = Ii(e);
	return {
		name: n.name,
		fn: n.fn,
		options: [e, t]
	};
};
//#endregion
//#region ../../node_modules/.pnpm/@floating-ui+react@0.27.20_react-dom@19.3.0_react@19.3.0__react@19.3.0/node_modules/@floating-ui/react/dist/floating-ui.react.mjs
function qi(t) {
	let n = e.useRef(void 0), r = e.useCallback((e) => {
		let n = t.map((t) => {
			if (t != null) {
				if (typeof t == "function") {
					let n = t, r = n(e);
					return typeof r == "function" ? r : () => {
						n(null);
					};
				}
				return t.current = e, () => {
					t.current = null;
				};
			}
		});
		return () => {
			n.forEach((e) => e?.());
		};
	}, t);
	return e.useMemo(() => t.every((e) => e == null) ? null : (e) => {
		n.current &&= (n.current(), void 0), e != null && (n.current = r(e));
	}, t);
}
var Ji = "data-floating-ui-focusable", Yi = "active", Xi = "selected", Zi = "ArrowLeft", Qi = "ArrowRight", $i = "ArrowUp", ea = "ArrowDown", ta = [Zi, Qi], na = [$i, ea];
[...ta, ...na];
var ra = { ...e }, ia = !1, aa = 0, oa = () => "floating-ui-" + Math.random().toString(36).slice(2, 6) + aa++;
function sa() {
	let [t, n] = e.useState(() => ia ? oa() : void 0);
	return K(() => {
		t ?? n(oa());
	}, []), e.useEffect(() => {
		ia = !0;
	}, []), t;
}
var ca = ra.useId || sa, la;
process.env.NODE_ENV !== "production" && (la = /*#__PURE__*/ new Set());
function ua() {
	var e;
	let t = "Floating UI: " + [...arguments].join(" ");
	if (!((e = la) != null && e.has(t))) {
		var n;
		(n = la) == null || n.add(t), console.warn(t);
	}
}
function da() {
	var e;
	let t = "Floating UI: " + [...arguments].join(" ");
	if (!((e = la) != null && e.has(t))) {
		var n;
		(n = la) == null || n.add(t), console.error(t);
	}
}
function fa() {
	let e = /* @__PURE__ */ new Map();
	return {
		emit(t, n) {
			var r;
			(r = e.get(t)) == null || r.forEach((e) => e(n));
		},
		on(t, n) {
			e.has(t) || e.set(t, /* @__PURE__ */ new Set()), e.get(t).add(n);
		},
		off(t, n) {
			var r;
			(r = e.get(t)) == null || r.delete(n);
		}
	};
}
var pa = /*#__PURE__*/ e.createContext(null), ma = /*#__PURE__*/ e.createContext(null), ha = () => e.useContext(pa)?.id || null, ga = () => e.useContext(ma);
function _a(e) {
	return "data-floating-ui-" + e;
}
function Y(e) {
	e.current !== -1 && (clearTimeout(e.current), e.current = -1);
}
var va = /*#__PURE__*/ _a("safe-polygon");
function ya(e, t, n) {
	if (n && !Ar(n)) return 0;
	if (typeof e == "number") return e;
	if (typeof e == "function") {
		let n = e();
		return typeof n == "number" ? n : n?.[t];
	}
	return e?.[t];
}
function ba(e) {
	return typeof e == "function" ? e() : e;
}
function xa(t, n) {
	n === void 0 && (n = {});
	let { open: r, onOpenChange: i, dataRef: a, events: o, elements: s } = t, { enabled: c = !0, delay: l = 0, handleClose: u = null, mouseOnly: d = !1, restMs: f = 0, move: p = !0 } = n, m = ga(), h = ha(), g = Mr(u), _ = Mr(l), v = Mr(r), y = Mr(f), b = e.useRef(), x = e.useRef(-1), S = e.useRef(), C = e.useRef(-1), w = e.useRef(!0), T = e.useRef(!1), E = e.useRef(() => {}), D = e.useRef(!1), O = q(() => {
		let e = a.current.openEvent?.type;
		return e?.includes("mouse") && e !== "mousedown";
	});
	e.useEffect(() => {
		if (!c) return;
		function e(e) {
			let { open: t } = e;
			t || (Y(x), Y(C), w.current = !0, D.current = !1);
		}
		return o.on("openchange", e), () => {
			o.off("openchange", e);
		};
	}, [c, o]), e.useEffect(() => {
		if (!c || !g.current || !r) return;
		function e(e) {
			O() && i(!1, e, "hover");
		}
		let t = W(s.floating).documentElement;
		return t.addEventListener("mouseleave", e), () => {
			t.removeEventListener("mouseleave", e);
		};
	}, [
		s.floating,
		r,
		i,
		c,
		g,
		O
	]);
	let k = e.useCallback(function(e, t, n) {
		t === void 0 && (t = !0), n === void 0 && (n = "hover");
		let r = ya(_.current, "close", b.current);
		r && !S.current ? (Y(x), x.current = window.setTimeout(() => i(!1, e, n), r)) : t && (Y(x), i(!1, e, n));
	}, [_, i]), A = q(() => {
		E.current(), S.current = void 0;
	}), j = q(() => {
		if (T.current) {
			let e = W(s.floating).body;
			e.style.pointerEvents = "", e.removeAttribute(va), T.current = !1;
		}
	}), M = q(() => a.current.openEvent ? ["click", "mousedown"].includes(a.current.openEvent.type) : !1);
	e.useEffect(() => {
		if (!c) return;
		function e(e) {
			if (Y(x), w.current = !1, d && !Ar(b.current) || ba(y.current) > 0 && !ya(_.current, "open")) return;
			let t = ya(_.current, "open", b.current);
			t ? x.current = window.setTimeout(() => {
				v.current || i(!0, e, "hover");
			}, t) : r || i(!0, e, "hover");
		}
		function t(e) {
			if (M()) {
				j();
				return;
			}
			E.current();
			let t = W(s.floating);
			if (Y(C), D.current = !1, g.current && a.current.floatingContext) {
				r || Y(x), S.current = g.current({
					...a.current.floatingContext,
					tree: m,
					x: e.clientX,
					y: e.clientY,
					onClose() {
						j(), A(), M() || k(e, !0, "safe-polygon");
					}
				});
				let n = S.current;
				t.addEventListener("mousemove", n), E.current = () => {
					t.removeEventListener("mousemove", n);
				};
				return;
			}
			(b.current !== "touch" || !U(s.floating, e.relatedTarget)) && k(e);
		}
		function n(e) {
			M() || a.current.floatingContext && (g.current == null || g.current({
				...a.current.floatingContext,
				tree: m,
				x: e.clientX,
				y: e.clientY,
				onClose() {
					j(), A(), M() || k(e);
				}
			})(e));
		}
		function o() {
			Y(x);
		}
		function l(e) {
			M() || k(e, !1);
		}
		if (V(s.domReference)) {
			let i = s.domReference, a = s.floating;
			return r && i.addEventListener("mouseleave", n), p && i.addEventListener("mousemove", e, { once: !0 }), i.addEventListener("mouseenter", e), i.addEventListener("mouseleave", t), a && (a.addEventListener("mouseleave", n), a.addEventListener("mouseenter", o), a.addEventListener("mouseleave", l)), () => {
				r && i.removeEventListener("mouseleave", n), p && i.removeEventListener("mousemove", e), i.removeEventListener("mouseenter", e), i.removeEventListener("mouseleave", t), a && (a.removeEventListener("mouseleave", n), a.removeEventListener("mouseenter", o), a.removeEventListener("mouseleave", l));
			};
		}
	}, [
		s,
		c,
		t,
		d,
		p,
		k,
		A,
		j,
		i,
		r,
		v,
		m,
		_,
		g,
		a,
		M,
		y
	]), K(() => {
		var e;
		if (c && r && (e = g.current) != null && (e = e.__options) != null && e.blockPointerEvents && O()) {
			T.current = !0;
			let e = s.floating;
			if (V(s.domReference) && e) {
				var t;
				let n = W(s.floating).body;
				n.setAttribute(va, "");
				let r = s.domReference, i = m == null || (t = m.nodesRef.current.find((e) => e.id === h)) == null || (t = t.context) == null ? void 0 : t.elements.floating;
				return i && (i.style.pointerEvents = ""), n.style.pointerEvents = "none", r.style.pointerEvents = "auto", e.style.pointerEvents = "auto", () => {
					n.style.pointerEvents = "", r.style.pointerEvents = "", e.style.pointerEvents = "";
				};
			}
		}
	}, [
		c,
		r,
		h,
		s,
		m,
		g,
		O
	]), K(() => {
		r || (b.current = void 0, D.current = !1, A(), j());
	}, [
		r,
		A,
		j
	]), e.useEffect(() => () => {
		A(), Y(x), Y(C), j();
	}, [
		c,
		s.domReference,
		A,
		j
	]);
	let N = e.useMemo(() => {
		function e(e) {
			b.current = e.pointerType;
		}
		return {
			onPointerDown: e,
			onPointerEnter: e,
			onMouseMove(e) {
				let { nativeEvent: t } = e;
				function n() {
					!w.current && !v.current && i(!0, t, "hover");
				}
				(!d || Ar(b.current)) && (r || ba(y.current) === 0 || D.current && e.movementX ** 2 + e.movementY ** 2 < 2 || (Y(C), b.current === "touch" ? n() : (D.current = !0, C.current = window.setTimeout(n, ba(y.current)))));
			}
		};
	}, [
		d,
		i,
		r,
		v,
		y
	]);
	return e.useMemo(() => c ? { reference: N } : {}, [c, N]);
}
var Sa = 0;
function Ca(e, t) {
	t === void 0 && (t = {});
	let { preventScroll: n = !1, cancelPrevious: r = !0, sync: i = !1 } = t;
	r && cancelAnimationFrame(Sa);
	let a = () => e?.focus({ preventScroll: n });
	i ? a() : Sa = requestAnimationFrame(a);
}
function wa(e) {
	return e?.ownerDocument || document;
}
var Ta = {
	inert: /*#__PURE__*/ new WeakMap(),
	"aria-hidden": /*#__PURE__*/ new WeakMap(),
	none: /*#__PURE__*/ new WeakMap()
};
function Ea(e) {
	return e === "inert" ? Ta.inert : e === "aria-hidden" ? Ta["aria-hidden"] : Ta.none;
}
var Da = /*#__PURE__*/ new WeakSet(), Oa = {}, ka = 0, Aa = () => typeof HTMLElement < "u" && "inert" in HTMLElement.prototype;
function ja(e) {
	return e ? It(e) ? e.host : ja(e.parentNode) : null;
}
var Ma = (e, t) => t.map((t) => {
	if (e.contains(t)) return t;
	let n = ja(t);
	return e.contains(n) ? n : null;
}).filter((e) => e != null);
function Na(e, t, n, r) {
	let i = "data-floating-ui-inert", a = r ? "inert" : n ? "aria-hidden" : null, o = Ma(t, e), s = /* @__PURE__ */ new Set(), c = new Set(o), l = [];
	Oa[i] || (Oa[i] = /* @__PURE__ */ new WeakMap());
	let u = Oa[i];
	o.forEach(d), f(t), s.clear();
	function d(e) {
		e && !s.has(e) && (s.add(e), e.parentNode && d(e.parentNode));
	}
	function f(e) {
		e && !c.has(e) && [].forEach.call(e.children, (e) => {
			if (Nt(e) !== "script") {
				if (s.has(e)) f(e);
				else {
					let t = a ? e.getAttribute(a) : null, n = t !== null && t !== "false", r = Ea(a), o = (r.get(e) || 0) + 1, s = (u.get(e) || 0) + 1;
					r.set(e, o), u.set(e, s), l.push(e), o === 1 && n && Da.add(e), s === 1 && e.setAttribute(i, ""), !n && a && e.setAttribute(a, a === "inert" ? "" : "true");
				}
			}
		});
	}
	return ka++, () => {
		l.forEach((e) => {
			let t = Ea(a), n = (t.get(e) || 0) - 1, r = (u.get(e) || 0) - 1;
			t.set(e, n), u.set(e, r), n || (!Da.has(e) && a && e.removeAttribute(a), Da.delete(e)), r || e.removeAttribute(i);
		}), ka--, ka || (Ta.inert = /* @__PURE__ */ new WeakMap(), Ta["aria-hidden"] = /* @__PURE__ */ new WeakMap(), Ta.none = /* @__PURE__ */ new WeakMap(), Da = /* @__PURE__ */ new WeakSet(), Oa = {});
	};
}
function Pa(e, t, n) {
	t === void 0 && (t = !1), n === void 0 && (n = !1);
	let r = wa(e[0]).body;
	return Na(e.concat(Array.from(r.querySelectorAll("[aria-live],[role=\"status\"],output"))), r, t, n);
}
var Fa = {
	border: 0,
	clip: "rect(0 0 0 0)",
	height: "1px",
	margin: "-1px",
	overflow: "hidden",
	padding: 0,
	position: "fixed",
	whiteSpace: "nowrap",
	width: "1px",
	top: 0,
	left: 0
}, Ia = /*#__PURE__*/ e.forwardRef(function(t, n) {
	let [r, i] = e.useState();
	K(() => {
		or() && i("button");
	}, []);
	let a = {
		ref: n,
		tabIndex: 0,
		role: r,
		"aria-hidden": !r || void 0,
		[_a("focus-guard")]: "",
		style: Fa
	};
	return /*#__PURE__*/ m("span", {
		...t,
		...a
	});
}), La = {
	clipPath: "inset(50%)",
	position: "fixed",
	top: 0,
	left: 0
}, Ra = /*#__PURE__*/ e.createContext(null), za = /*#__PURE__*/ _a("portal");
function Ba(t) {
	t === void 0 && (t = {});
	let { id: n, root: r } = t, i = ca(), a = Ha(), [o, s] = e.useState(null), c = e.useRef(null);
	return K(() => () => {
		o?.remove(), queueMicrotask(() => {
			c.current = null;
		});
	}, [o]), K(() => {
		if (!i || c.current) return;
		let e = n ? document.getElementById(n) : null;
		if (!e) return;
		let t = document.createElement("div");
		t.id = i, t.setAttribute(za, ""), e.appendChild(t), c.current = t, s(t);
	}, [n, i]), K(() => {
		if (r === null || !i || c.current) return;
		let e = r || a?.portalNode;
		e && !Ft(e) && (e = e.current), e ||= document.body;
		let t = null;
		n && (t = document.createElement("div"), t.id = n, e.appendChild(t));
		let o = document.createElement("div");
		o.id = i, o.setAttribute(za, ""), e = t || e, e.appendChild(o), c.current = o, s(o);
	}, [
		n,
		r,
		i,
		a
	]), o;
}
function Va(t) {
	let { children: n, id: r, root: i, preserveTabOrder: a = !0 } = t, o = Ba({
		id: r,
		root: i
	}), [s, c] = e.useState(null), l = e.useRef(null), u = e.useRef(null), d = e.useRef(null), f = e.useRef(null), p = s?.modal, _ = s?.open, v = !!s && !s.modal && s.open && a && !!(i || o);
	return e.useEffect(() => {
		if (!o || !a || p) return;
		function e(e) {
			o && qr(e) && (e.type === "focusin" ? Yr : Jr)(o);
		}
		return o.addEventListener("focusin", e, !0), o.addEventListener("focusout", e, !0), () => {
			o.removeEventListener("focusin", e, !0), o.removeEventListener("focusout", e, !0);
		};
	}, [
		o,
		a,
		p
	]), e.useEffect(() => {
		o && (_ || Yr(o));
	}, [_, o]), /*#__PURE__*/ h(Ra.Provider, {
		value: e.useMemo(() => ({
			preserveTabOrder: a,
			beforeOutsideRef: l,
			afterOutsideRef: u,
			beforeInsideRef: d,
			afterInsideRef: f,
			portalNode: o,
			setFocusManagerState: c
		}), [a, o]),
		children: [
			v && o && /*#__PURE__*/ m(Ia, {
				"data-type": "outside",
				ref: l,
				onFocus: (e) => {
					if (qr(e, o)) {
						var t;
						(t = d.current) == null || t.focus();
					} else Kr(s ? s.domReference : null)?.focus();
				}
			}),
			v && o && /*#__PURE__*/ m("span", {
				"aria-owns": o.id,
				style: La
			}),
			o && /*#__PURE__*/ g.createPortal(n, o),
			v && o && /*#__PURE__*/ m(Ia, {
				"data-type": "outside",
				ref: u,
				onFocus: (e) => {
					if (qr(e, o)) {
						var t;
						(t = f.current) == null || t.focus();
					} else Gr(s ? s.domReference : null)?.focus(), s != null && s.closeOnFocusOut && s?.onOpenChange(!1, e.nativeEvent, "focus-out");
				}
			})
		]
	});
}
var Ha = () => e.useContext(Ra);
function Ua(t) {
	return e.useMemo(() => (e) => {
		t.forEach((t) => {
			t && (t.current = e);
		});
	}, t);
}
var Wa = 20, Ga = [];
function Ka() {
	Ga = Ga.filter((e) => e.deref()?.isConnected);
}
function qa(e) {
	Ka(), e && Nt(e) !== "body" && (Ga.push(new WeakRef(e)), Ga.length > Wa && (Ga = Ga.slice(-20)));
}
function Ja() {
	return Ka(), Ga[Ga.length - 1]?.deref();
}
function Ya(e) {
	let t = Ur();
	return rr(e, t) ? e : tr(e, t)[0] || e;
}
function Xa(e, t) {
	var n;
	if (!t.current.includes("floating") && !((n = e.getAttribute("role")) != null && n.includes("dialog"))) return;
	let r = Ur(), i = nr(e, r).filter((e) => {
		let t = e.getAttribute("data-tabindex") || "";
		return rr(e, r) || e.hasAttribute("data-tabindex") && !t.startsWith("-");
	}), a = e.getAttribute("tabindex");
	t.current.includes("floating") || i.length === 0 ? a !== "0" && e.setAttribute("tabindex", "0") : (a !== "-1" || e.hasAttribute("data-tabindex") && e.getAttribute("data-tabindex") !== "-1") && (e.setAttribute("tabindex", "-1"), e.setAttribute("data-tabindex", "-1"));
}
var Za = /*#__PURE__*/ e.forwardRef(function(e, t) {
	return /*#__PURE__*/ m("button", {
		...e,
		type: "button",
		ref: t,
		tabIndex: -1,
		style: Fa
	});
});
function Qa(t) {
	let { context: n, children: r, disabled: i = !1, order: a = ["content"], guards: o = !0, initialFocus: s = 0, returnFocus: c = !0, restoreFocus: l = !1, modal: u = !0, visuallyHiddenDismiss: d = !1, closeOnFocusOut: f = !0, outsideElementsInert: g = !1, getInsideElements: _ = () => [] } = t, { open: v, onOpenChange: y, events: b, dataRef: x, elements: { domReference: S, floating: C } } = n, w = q(() => x.current.floatingContext?.nodeId), T = q(_), E = typeof s == "number" && s < 0, D = xr(S) && E, O = Aa(), k = !O || o, A = !k || O && g, j = Mr(a), M = Mr(s), N = Mr(c), P = ga(), F = Ha(), I = e.useRef(null), ee = e.useRef(null), L = e.useRef(!1), te = e.useRef(!1), R = e.useRef(-1), ne = e.useRef(-1), re = F != null, z = Cr(C), ie = q(function(e) {
		return e === void 0 && (e = z), e ? tr(e, Ur()) : [];
	}), ae = q((e) => {
		let t = ie(e);
		return j.current.map((e) => S && e === "reference" ? S : z && e === "floating" ? z : t).filter(Boolean).flat();
	});
	e.useEffect(() => {
		if (i || !u) return;
		function e(e) {
			if (e.key === "Tab") {
				U(z, gr(W(z))) && ie().length === 0 && !D && G(e);
				let t = ae(), n = _r(e);
				j.current[0] === "reference" && n === S && (G(e), e.shiftKey ? Ca(t[t.length - 1]) : Ca(t[1])), j.current[1] === "floating" && n === z && e.shiftKey && (G(e), Ca(t[0]));
			}
		}
		let t = W(z);
		return t.addEventListener("keydown", e), () => {
			t.removeEventListener("keydown", e);
		};
	}, [
		i,
		S,
		z,
		u,
		j,
		D,
		ie,
		ae
	]), e.useEffect(() => {
		if (i || !C) return;
		function e(e) {
			let t = _r(e), n = ie().indexOf(t);
			n !== -1 && (R.current = n);
		}
		return C.addEventListener("focusin", e), () => {
			C.removeEventListener("focusin", e);
		};
	}, [
		i,
		C,
		ie
	]), e.useEffect(() => {
		if (i || !f) return;
		function e() {
			te.current = !0, setTimeout(() => {
				te.current = !1;
			});
		}
		function t(e) {
			let t = e.relatedTarget, n = e.currentTarget, r = _r(e);
			queueMicrotask(() => {
				let i = w(), a = !(U(S, t) || U(C, t) || U(t, C) || U(F?.portalNode, t) || t != null && t.hasAttribute(_a("focus-guard")) || P && (wr(P.nodesRef.current, i).find((e) => U(e.context?.elements.floating, t) || U(e.context?.elements.domReference, t)) || Er(P.nodesRef.current, i).find((e) => [e.context?.elements.floating, Cr(e.context?.elements.floating)].includes(t) || e.context?.elements.domReference === t)));
				if (n === S && z && Xa(z, j), l && n !== S && !(r != null && r.isConnected) && gr(W(z)) === W(z).body) {
					H(z) && z.focus();
					let e = R.current, t = ie(), n = t[e] || t[t.length - 1] || z;
					H(n) && n.focus();
				}
				if (x.current.insideReactTree) {
					x.current.insideReactTree = !1;
					return;
				}
				(D || !u) && t && a && !te.current && t !== Ja() && (L.current = !0, y(!1, e, "focus-out"));
			});
		}
		let n = !(P || !F);
		function r() {
			Y(ne), x.current.insideReactTree = !0, ne.current = window.setTimeout(() => {
				x.current.insideReactTree = !1;
			});
		}
		if (C && H(S)) return S.addEventListener("focusout", t), S.addEventListener("pointerdown", e), C.addEventListener("focusout", t), n && C.addEventListener("focusout", r, !0), () => {
			S.removeEventListener("focusout", t), S.removeEventListener("pointerdown", e), C.removeEventListener("focusout", t), n && C.removeEventListener("focusout", r, !0);
		};
	}, [
		i,
		S,
		C,
		z,
		u,
		P,
		F,
		y,
		f,
		l,
		ie,
		D,
		w,
		j,
		x
	]);
	let oe = e.useRef(null), se = e.useRef(null), ce = Ua([oe, F?.beforeInsideRef]), le = Ua([se, F?.afterInsideRef]);
	e.useEffect(() => {
		var e, t;
		if (i || !C) return;
		let n = Array.from((F == null || (e = F.portalNode) == null ? void 0 : e.querySelectorAll("[" + _a("portal") + "]")) || []), r = (t = (P ? Er(P.nodesRef.current, w()) : []).find((e) => xr(e.context?.elements.domReference || null))) == null || (t = t.context) == null ? void 0 : t.elements.domReference, a = [
			C,
			r,
			...n,
			...T(),
			I.current,
			ee.current,
			oe.current,
			se.current,
			F?.beforeOutsideRef.current,
			F?.afterOutsideRef.current,
			j.current.includes("reference") || D ? S : null
		].filter((e) => e != null), o = u || D ? Pa(a, !A, A) : Pa(a);
		return () => {
			o();
		};
	}, [
		i,
		S,
		C,
		u,
		j,
		F,
		D,
		k,
		A,
		P,
		w,
		T
	]), K(() => {
		if (i || !H(z)) return;
		let e = gr(W(z));
		queueMicrotask(() => {
			let t = ae(z), n = M.current, r = (typeof n == "number" ? t[n] : n.current) || z, i = U(z, e);
			!E && !i && v && Ca(r, { preventScroll: r === z });
		});
	}, [
		i,
		v,
		z,
		E,
		ae,
		M
	]), K(() => {
		if (i || !z) return;
		let e = W(z);
		qa(gr(e));
		function t(e) {
			let { reason: t, event: n, nested: r } = e;
			if (["hover", "safe-polygon"].includes(t) && n.type === "mouseleave" && (L.current = !0), t === "outside-press") {
				if (r) L.current = !1;
				else if (Or(n) || kr(n)) L.current = !1;
				else {
					let e = !1;
					document.createElement("div").focus({ get preventScroll() {
						return e = !0, !1;
					} }), e ? L.current = !1 : L.current = !0;
				}
			}
		}
		b.on("openchange", t);
		let n = e.createElement("span");
		n.setAttribute("tabindex", "-1"), n.setAttribute("aria-hidden", "true"), Object.assign(n.style, Fa), re && S && S.insertAdjacentElement("afterend", n);
		function r() {
			if (typeof N.current == "boolean") {
				let e = S || Ja();
				return e && e.isConnected ? e : n;
			}
			return N.current.current || n;
		}
		return () => {
			b.off("openchange", t);
			let i = gr(e), a = U(C, i) || P && wr(P.nodesRef.current, w(), !1).some((e) => U(e.context?.elements.floating, i)), o = r();
			queueMicrotask(() => {
				let t = Ya(o);
				N.current && !L.current && H(t) && (t === i || i === e.body || a) && t.focus({ preventScroll: !0 }), n.remove();
			});
		};
	}, [
		i,
		C,
		z,
		N,
		x,
		b,
		P,
		re,
		S,
		w
	]), e.useEffect(() => (queueMicrotask(() => {
		L.current = !1;
	}), () => {
		queueMicrotask(Ka);
	}), [i]), K(() => {
		if (!i && F) return F.setFocusManagerState({
			modal: u,
			closeOnFocusOut: f,
			open: v,
			onOpenChange: y,
			domReference: S
		}), () => {
			F.setFocusManagerState(null);
		};
	}, [
		i,
		F,
		u,
		v,
		y,
		f,
		S
	]), K(() => {
		i || z && Xa(z, j);
	}, [
		i,
		z,
		j
	]);
	function ue(e) {
		return i || !d || !u ? null : /*#__PURE__*/ m(Za, {
			ref: e === "start" ? I : ee,
			onClick: (e) => y(!1, e.nativeEvent),
			children: typeof d == "string" ? d : "Dismiss"
		});
	}
	let de = !i && k && (!u || !D) && (re || u);
	return /*#__PURE__*/ h(p, { children: [
		de && /*#__PURE__*/ m(Ia, {
			"data-type": "inside",
			ref: ce,
			onFocus: (e) => {
				if (u) {
					let e = ae();
					Ca(a[0] === "reference" ? e[0] : e[e.length - 1]);
				} else if (F != null && F.preserveTabOrder && F.portalNode) {
					if (L.current = !1, qr(e, F.portalNode)) Gr(S)?.focus();
					else {
						var t;
						(t = F.beforeOutsideRef.current) == null || t.focus();
					}
				}
			}
		}),
		!D && ue("start"),
		r,
		ue("end"),
		de && /*#__PURE__*/ m(Ia, {
			"data-type": "inside",
			ref: le,
			onFocus: (e) => {
				if (u) Ca(ae()[0]);
				else if (F != null && F.preserveTabOrder && F.portalNode) {
					if (f && (L.current = !0), qr(e, F.portalNode)) Kr(S)?.focus();
					else {
						var t;
						(t = F.afterOutsideRef.current) == null || t.focus();
					}
				}
			}
		})
	] });
}
function $a(e) {
	return H(e.target) && e.target.tagName === "BUTTON";
}
function eo(e) {
	return H(e.target) && e.target.tagName === "A";
}
function to(e) {
	return br(e);
}
function no(t, n) {
	n === void 0 && (n = {});
	let { open: r, onOpenChange: i, dataRef: a, elements: { domReference: o } } = t, { enabled: s = !0, event: c = "click", toggle: l = !0, ignoreMouse: u = !1, keyboardHandlers: d = !0, stickIfOpen: f = !0 } = n, p = e.useRef(), m = e.useRef(!1), h = e.useMemo(() => ({
		onPointerDown(e) {
			p.current = e.pointerType;
		},
		onMouseDown(e) {
			let t = p.current;
			e.button === 0 && c !== "click" && (Ar(t, !0) && u || (r && l && (!(a.current.openEvent && f) || a.current.openEvent.type === "mousedown") ? i(!1, e.nativeEvent, "click") : (e.preventDefault(), i(!0, e.nativeEvent, "click"))));
		},
		onClick(e) {
			let t = p.current;
			if (c === "mousedown" && p.current) {
				p.current = void 0;
				return;
			}
			Ar(t, !0) && u || (r && l && (!(a.current.openEvent && f) || a.current.openEvent.type === "click") ? i(!1, e.nativeEvent, "click") : i(!0, e.nativeEvent, "click"));
		},
		onKeyDown(e) {
			p.current = void 0, !(e.defaultPrevented || !d || $a(e)) && (e.key === " " && !to(o) && (e.preventDefault(), m.current = !0), !eo(e) && e.key === "Enter" && i(!(r && l), e.nativeEvent, "click"));
		},
		onKeyUp(e) {
			e.defaultPrevented || !d || $a(e) || to(o) || e.key === " " && m.current && (m.current = !1, i(!(r && l), e.nativeEvent, "click"));
		}
	}), [
		a,
		o,
		c,
		u,
		d,
		i,
		r,
		f,
		l
	]);
	return e.useMemo(() => s ? { reference: h } : {}, [s, h]);
}
var ro = {
	pointerdown: "onPointerDown",
	mousedown: "onMouseDown",
	click: "onClick"
}, io = {
	pointerdown: "onPointerDownCapture",
	mousedown: "onMouseDownCapture",
	click: "onClickCapture"
}, ao = (e) => ({
	escapeKey: typeof e == "boolean" ? e : e?.escapeKey ?? !1,
	outsidePress: typeof e == "boolean" ? e : e?.outsidePress ?? !0
});
function oo(t, n) {
	n === void 0 && (n = {});
	let { open: r, onOpenChange: i, elements: a, dataRef: o } = t, { enabled: s = !0, escapeKey: c = !0, outsidePress: l = !0, outsidePressEvent: u = "pointerdown", referencePress: d = !1, referencePressEvent: f = "pointerdown", ancestorScroll: p = !1, bubbles: m, capture: h } = n, g = ga(), _ = q(typeof l == "function" ? l : () => !1), v = typeof l == "function" ? _ : l, y = e.useRef(!1), { escapeKey: b, outsidePress: x } = ao(m), { escapeKey: S, outsidePress: C } = ao(h), w = e.useRef(!1), T = q((e) => {
		if (!r || !s || !c || e.key !== "Escape" || w.current) return;
		let t = o.current.floatingContext?.nodeId, n = g ? wr(g.nodesRef.current, t) : [];
		if (!b && (e.stopPropagation(), n.length > 0)) {
			let e = !0;
			if (n.forEach((t) => {
				var n;
				if ((n = t.context) != null && n.open && !t.context.dataRef.current.__escapeKeyBubbles) {
					e = !1;
					return;
				}
			}), !e) return;
		}
		i(!1, Dr(e) ? e.nativeEvent : e, "escape-key");
	}), E = q((e) => {
		var t;
		let n = () => {
			var t;
			T(e), (t = _r(e)) == null || t.removeEventListener("keydown", n);
		};
		(t = _r(e)) == null || t.addEventListener("keydown", n);
	}), D = q((e) => {
		let t = o.current.insideReactTree;
		o.current.insideReactTree = !1;
		let n = y.current;
		if (y.current = !1, u === "click" && n || t || typeof v == "function" && !v(e)) return;
		let r = _r(e), s = "[" + _a("inert") + "]", c = W(a.floating).querySelectorAll(s), l = V(r) ? r : null;
		for (; l && !qt(l);) {
			let e = Xt(l);
			if (qt(e) || !V(e)) break;
			l = e;
		}
		if (c.length && V(r) && !yr(r) && !U(r, a.floating) && Array.from(c).every((e) => !U(l, e))) return;
		if (H(r) && A) {
			let t = qt(r), n = Jt(r), i = /auto|scroll/, a = t || i.test(n.overflowX), o = t || i.test(n.overflowY), s = a && r.clientWidth > 0 && r.scrollWidth > r.clientWidth, c = o && r.clientHeight > 0 && r.scrollHeight > r.clientHeight, l = n.direction === "rtl", u = c && (l ? e.offsetX <= r.offsetWidth - r.clientWidth : e.offsetX > r.clientWidth), d = s && e.offsetY > r.clientHeight;
			if (u || d) return;
		}
		let d = o.current.floatingContext?.nodeId, f = g && wr(g.nodesRef.current, d).some((t) => vr(e, t.context?.elements.floating));
		if (vr(e, a.floating) || vr(e, a.domReference) || f) return;
		let p = g ? wr(g.nodesRef.current, d) : [];
		if (p.length > 0) {
			let e = !0;
			if (p.forEach((t) => {
				var n;
				if ((n = t.context) != null && n.open && !t.context.dataRef.current.__outsidePressBubbles) {
					e = !1;
					return;
				}
			}), !e) return;
		}
		i(!1, e, "outside-press");
	}), O = q((e) => {
		var t;
		let n = () => {
			var t;
			D(e), (t = _r(e)) == null || t.removeEventListener(u, n);
		};
		(t = _r(e)) == null || t.addEventListener(u, n);
	});
	e.useEffect(() => {
		if (!r || !s) return;
		o.current.__escapeKeyBubbles = b, o.current.__outsidePressBubbles = x;
		let e = -1;
		function t(e) {
			i(!1, e, "ancestor-scroll");
		}
		function n() {
			window.clearTimeout(e), w.current = !0;
		}
		function l() {
			e = window.setTimeout(() => {
				w.current = !1;
			}, Kt() ? 5 : 0);
		}
		let d = W(a.floating);
		c && (d.addEventListener("keydown", S ? E : T, S), d.addEventListener("compositionstart", n), d.addEventListener("compositionend", l)), v && d.addEventListener(u, C ? O : D, C);
		let f = [];
		return p && (V(a.domReference) && (f = Qt(a.domReference)), V(a.floating) && (f = f.concat(Qt(a.floating))), !V(a.reference) && a.reference && a.reference.contextElement && (f = f.concat(Qt(a.reference.contextElement)))), f = f.filter((e) => e !== d.defaultView?.visualViewport), f.forEach((e) => {
			e.addEventListener("scroll", t);
		}), () => {
			c && (d.removeEventListener("keydown", S ? E : T, S), d.removeEventListener("compositionstart", n), d.removeEventListener("compositionend", l)), v && d.removeEventListener(u, C ? O : D, C), f.forEach((e) => {
				e.removeEventListener("scroll", t);
			}), window.clearTimeout(e);
		};
	}, [
		o,
		a,
		c,
		v,
		u,
		r,
		i,
		p,
		s,
		b,
		x,
		T,
		S,
		E,
		D,
		C,
		O
	]), e.useEffect(() => {
		o.current.insideReactTree = !1;
	}, [
		o,
		v,
		u
	]);
	let k = e.useMemo(() => ({
		onKeyDown: T,
		...d && {
			[ro[f]]: (e) => {
				i(!1, e.nativeEvent, "reference-press");
			},
			...f !== "click" && { onClick(e) {
				i(!1, e.nativeEvent, "reference-press");
			} }
		}
	}), [
		T,
		i,
		d,
		f
	]), A = e.useMemo(() => {
		function e(e) {
			e.button === 0 && (y.current = !0);
		}
		return {
			onKeyDown: T,
			onMouseDown: e,
			onMouseUp: e,
			[io[u]]: () => {
				o.current.insideReactTree = !0;
			}
		};
	}, [
		T,
		u,
		o
	]);
	return e.useMemo(() => s ? {
		reference: k,
		floating: A
	} : {}, [
		s,
		k,
		A
	]);
}
function so(t) {
	let { open: n = !1, onOpenChange: r, elements: i } = t, a = ca(), o = e.useRef({}), [s] = e.useState(() => fa()), c = ha() != null;
	if (process.env.NODE_ENV !== "production") {
		let e = i.reference;
		e && !V(e) && da("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
	}
	let [l, u] = e.useState(i.reference), d = q((e, t, n) => {
		o.current.openEvent = e ? t : void 0, s.emit("openchange", {
			open: e,
			event: t,
			reason: n,
			nested: c
		}), r?.(e, t, n);
	}), f = e.useMemo(() => ({ setPositionReference: u }), []), p = e.useMemo(() => ({
		reference: l || i.reference || null,
		floating: i.floating || null,
		domReference: i.reference
	}), [
		l,
		i.reference,
		i.floating
	]);
	return e.useMemo(() => ({
		dataRef: o,
		open: n,
		onOpenChange: d,
		elements: p,
		events: s,
		floatingId: a,
		refs: f
	}), [
		n,
		d,
		p,
		s,
		a,
		f
	]);
}
function co(t) {
	let { elements: n, ...r } = t === void 0 ? {} : t, { nodeId: i } = r, a = so({
		...r,
		elements: {
			reference: n?.reference ?? null,
			floating: n?.floating ?? null
		}
	}), o = r.rootContext || a, s = o.elements, [c, l] = e.useState(null), [u, d] = e.useState(null), f = s?.domReference || c, p = e.useRef(null), m = ga();
	K(() => {
		f && (p.current = f);
	}, [f]);
	let h = Ui({
		...r,
		elements: {
			...s,
			...u && { reference: u }
		}
	}), g = e.useCallback((e) => {
		let t = V(e) ? {
			getBoundingClientRect: () => e.getBoundingClientRect(),
			getClientRects: () => e.getClientRects(),
			contextElement: e
		} : e;
		d(t), h.refs.setReference(t);
	}, [h.refs]), _ = e.useCallback((e) => {
		(V(e) || e === null) && (p.current = e, l(e)), (V(h.refs.reference.current) || h.refs.reference.current === null || e !== null && !V(e)) && h.refs.setReference(e);
	}, [h.refs]), v = e.useMemo(() => ({
		...h.refs,
		setReference: _,
		setPositionReference: g,
		domReference: p
	}), [
		h.refs,
		_,
		g
	]), y = e.useMemo(() => ({
		...h.elements,
		domReference: f
	}), [h.elements, f]), b = e.useMemo(() => ({
		...h,
		...o,
		refs: v,
		elements: y,
		nodeId: i
	}), [
		h,
		v,
		y,
		i,
		o
	]);
	return K(() => {
		o.dataRef.current.floatingContext = b;
		let e = m?.nodesRef.current.find((e) => e.id === i);
		e && (e.context = b);
	}), e.useMemo(() => ({
		...h,
		context: b,
		refs: v,
		elements: y
	}), [
		h,
		v,
		y,
		b
	]);
}
function lo() {
	return cr() && or();
}
function uo(t, n) {
	n === void 0 && (n = {});
	let { open: r, onOpenChange: i, events: a, dataRef: o, elements: s } = t, { enabled: c = !0, visibleOnly: l = !0 } = n, u = e.useRef(!1), d = e.useRef(-1), f = e.useRef(!0);
	e.useEffect(() => {
		if (!c) return;
		let e = B(s.domReference);
		function t() {
			!r && H(s.domReference) && s.domReference === gr(W(s.domReference)) && (u.current = !0);
		}
		function n() {
			f.current = !0;
		}
		function i() {
			f.current = !1;
		}
		return e.addEventListener("blur", t), lo() && (e.addEventListener("keydown", n, !0), e.addEventListener("pointerdown", i, !0)), () => {
			e.removeEventListener("blur", t), lo() && (e.removeEventListener("keydown", n, !0), e.removeEventListener("pointerdown", i, !0));
		};
	}, [
		s.domReference,
		r,
		c
	]), e.useEffect(() => {
		if (!c) return;
		function e(e) {
			let { reason: t } = e;
			(t === "reference-press" || t === "escape-key") && (u.current = !0);
		}
		return a.on("openchange", e), () => {
			a.off("openchange", e);
		};
	}, [a, c]), e.useEffect(() => () => {
		Y(d);
	}, []);
	let p = e.useMemo(() => ({
		onMouseLeave() {
			u.current = !1;
		},
		onFocus(e) {
			if (u.current) return;
			let t = _r(e.nativeEvent);
			if (l && V(t)) {
				if (lo() && !e.relatedTarget) {
					if (!f.current && !br(t)) return;
				} else if (!Sr(t)) return;
			}
			i(!0, e.nativeEvent, "focus");
		},
		onBlur(e) {
			u.current = !1;
			let t = e.relatedTarget, n = e.nativeEvent, r = V(t) && t.hasAttribute(_a("focus-guard")) && t.getAttribute("data-type") === "outside";
			d.current = window.setTimeout(() => {
				let e = gr(s.domReference ? s.domReference.ownerDocument : document);
				(t || e !== s.domReference) && (U(o.current.floatingContext?.refs.floating.current, e) || U(s.domReference, e) || r || i(!1, n, "focus"));
			});
		}
	}), [
		o,
		s.domReference,
		i,
		l
	]);
	return e.useMemo(() => c ? { reference: p } : {}, [c, p]);
}
function fo(e, t, n) {
	let r = /* @__PURE__ */ new Map(), i = n === "item", a = e;
	if (i && e) {
		let { [Yi]: t, [Xi]: n, ...r } = e;
		a = r;
	}
	return {
		...n === "floating" && {
			tabIndex: -1,
			[Ji]: ""
		},
		...a,
		...t.map((t) => {
			let r = t ? t[n] : null;
			return typeof r == "function" ? e ? r(e) : null : r;
		}).concat(e).reduce((e, t) => (t && Object.entries(t).forEach((t) => {
			let [n, a] = t;
			if (!(i && [Yi, Xi].includes(n))) {
				if (n.indexOf("on") === 0) {
					if (r.has(n) || r.set(n, []), typeof a == "function") {
						var o;
						(o = r.get(n)) == null || o.push(a), e[n] = function() {
							var e = [...arguments];
							return r.get(n)?.map((t) => t(...e)).find((e) => e !== void 0);
						};
					}
				} else e[n] = a;
			}
		}), e), {})
	};
}
function po(t) {
	t === void 0 && (t = []);
	let n = t.map((e) => e?.reference), r = t.map((e) => e?.floating), i = t.map((e) => e?.item), a = e.useCallback((e) => fo(e, t, "reference"), n), o = e.useCallback((e) => fo(e, t, "floating"), r), s = e.useCallback((e) => fo(e, t, "item"), i);
	return e.useMemo(() => ({
		getReferenceProps: a,
		getFloatingProps: o,
		getItemProps: s
	}), [
		a,
		o,
		s
	]);
}
var mo = "Escape";
function ho(e, t, n) {
	switch (e) {
		case "vertical": return t;
		case "horizontal": return n;
		default: return t || n;
	}
}
function go(e, t) {
	return ho(t, e === $i || e === ea, e === Zi || e === Qi);
}
function _o(e, t, n) {
	return ho(t, e === ea, n ? e === Zi : e === Qi) || e === "Enter" || e === " " || e === "";
}
function vo(e, t, n) {
	return ho(t, n ? e === Zi : e === Qi, e === ea);
}
function yo(e, t, n, r) {
	return t === "both" || t === "horizontal" && r && r > 1 ? e === mo : ho(t, n ? e === Qi : e === Zi, e === $i);
}
function bo(t, n) {
	let { open: r, onOpenChange: i, elements: a, floatingId: o } = t, { listRef: s, activeIndex: c, onNavigate: l = () => {}, enabled: u = !0, selectedIndex: d = null, allowEscape: f = !1, loop: p = !1, nested: m = !1, rtl: h = !1, virtual: g = !1, focusItemOnOpen: _ = "auto", focusItemOnHover: v = !0, openOnArrowKeyDown: y = !0, disabledIndices: b = void 0, orientation: x = "vertical", parentOrientation: S, cols: C = 1, scrollItemIntoView: w = !0, virtualItemRef: T, itemSizes: E, dense: D = !1 } = n;
	process.env.NODE_ENV !== "production" && (f && (p || ua("`useListNavigation` looping must be enabled to allow escaping."), g || ua("`useListNavigation` must be virtual to allow escaping.")), x === "vertical" && C > 1 && ua("In grid list navigation mode (`cols` > 1), the `orientation` should", "be either \"horizontal\" or \"both\"."));
	let O = Mr(Cr(a.floating)), k = ha(), A = ga();
	K(() => {
		t.dataRef.current.orientation = x;
	}, [t, x]);
	let j = q(() => {
		l(P.current === -1 ? null : P.current);
	}), M = xr(a.domReference), N = e.useRef(_), P = e.useRef(d ?? -1), F = e.useRef(null), I = e.useRef(!0), ee = e.useRef(j), L = e.useRef(!!a.floating), te = e.useRef(r), R = e.useRef(!1), ne = e.useRef(!1), re = Mr(b), z = Mr(r), ie = Mr(w), ae = Mr(d), [oe, se] = e.useState(), [ce, le] = e.useState(), ue = q(() => {
		function e(e) {
			if (g) {
				var t;
				(t = e.id) != null && t.endsWith("-fui-option") && (e.id = o + "-" + Math.random().toString(16).slice(2, 10)), se(e.id), A?.events.emit("virtualfocus", e), T && (T.current = e);
			} else Ca(e, {
				sync: R.current,
				preventScroll: !0
			});
		}
		let t = s.current[P.current], n = ne.current;
		t && e(t), (R.current ? (e) => e() : requestAnimationFrame)(() => {
			let r = s.current[P.current] || t;
			if (!r) return;
			t || e(r);
			let i = ie.current;
			i && fe && (n || !I.current) && (r.scrollIntoView == null || r.scrollIntoView(typeof i == "boolean" ? {
				block: "nearest",
				inline: "nearest"
			} : i));
		});
	});
	K(() => {
		u && (r && a.floating ? N.current && d != null && (ne.current = !0, P.current = d, j()) : L.current && (P.current = -1, ee.current()));
	}, [
		u,
		r,
		a.floating,
		d,
		j
	]), K(() => {
		if (u && r && a.floating) {
			if (c == null) {
				if (R.current = !1, ae.current != null) return;
				if (L.current && (P.current = -1, ue()), (!te.current || !L.current) && N.current && (F.current != null || N.current === !0 && F.current == null)) {
					let e = 0, t = () => {
						s.current[0] == null ? (e < 2 && (e ? requestAnimationFrame : queueMicrotask)(t), e++) : (P.current = F.current == null || _o(F.current, x, h) || m ? Ir(s, re.current) : Lr(s, re.current), F.current = null, j());
					};
					t();
				}
			} else Fr(s, c) || (P.current = c, ue(), ne.current = !1);
		}
	}, [
		u,
		r,
		a.floating,
		c,
		ae,
		m,
		s,
		x,
		h,
		j,
		ue,
		re
	]), K(() => {
		var e;
		if (!u || a.floating || !A || g || !L.current) return;
		let t = A.nodesRef.current, n = (e = t.find((e) => e.id === k)) == null || (e = e.context) == null ? void 0 : e.elements.floating, r = gr(W(a.floating)), i = t.some((e) => e.context && U(e.context.elements.floating, r));
		n && !i && I.current && n.focus({ preventScroll: !0 });
	}, [
		u,
		a.floating,
		A,
		k,
		g
	]), K(() => {
		if (!u || !A || !g || k) return;
		function e(e) {
			le(e.id), T && (T.current = e);
		}
		return A.events.on("virtualfocus", e), () => {
			A.events.off("virtualfocus", e);
		};
	}, [
		u,
		A,
		g,
		k,
		T
	]), K(() => {
		ee.current = j, te.current = r, L.current = !!a.floating;
	}), K(() => {
		r || (F.current = null, N.current = _);
	}, [r, _]);
	let de = c != null, fe = e.useMemo(() => {
		function e(e) {
			if (!z.current) return;
			let t = s.current.indexOf(e);
			t !== -1 && P.current !== t && (P.current = t, j());
		}
		return {
			onFocus(t) {
				let { currentTarget: n } = t;
				R.current = !0, e(n);
			},
			onClick: (e) => {
				let { currentTarget: t } = e;
				return t.focus({ preventScroll: !0 });
			},
			onMouseMove(t) {
				let { currentTarget: n } = t;
				R.current = !0, ne.current = !1, v && e(n);
			},
			onPointerLeave(e) {
				let { pointerType: t } = e;
				if (I.current && t !== "touch" && (R.current = !0, v && (P.current = -1, j(), !g))) {
					var n;
					(n = O.current) == null || n.focus({ preventScroll: !0 });
				}
			}
		};
	}, [
		z,
		O,
		v,
		s,
		j,
		g
	]), pe = e.useCallback(() => {
		var e;
		return S ?? (A == null || (e = A.nodesRef.current.find((e) => e.id === k)) == null || (e = e.context) == null || (e = e.dataRef) == null ? void 0 : e.current.orientation);
	}, [
		k,
		A,
		S
	]), me = q((e) => {
		if (I.current = !1, R.current = !0, e.which === 229 || !z.current && e.currentTarget === O.current) return;
		if (m && yo(e.key, x, h, C)) {
			go(e.key, pe()) || G(e), i(!1, e.nativeEvent, "list-navigation"), H(a.domReference) && (g ? A?.events.emit("virtualfocus", a.domReference) : a.domReference.focus());
			return;
		}
		let t = P.current, n = Ir(s, b), o = Lr(s, b);
		if (M || (e.key === "Home" && (G(e), P.current = n, j()), e.key === "End" && (G(e), P.current = o, j())), C > 1) {
			let t = E || Array.from({ length: s.current.length }, () => ({
				width: 1,
				height: 1
			})), r = zr(t, C, D), i = r.findIndex((e) => e != null && !Hr(s, e, b)), a = r.reduce((e, t, n) => t != null && !Hr(s, t, b) ? n : e, -1), c = r[Rr({ current: r.map((e) => e == null ? null : s.current[e]) }, {
				event: e,
				orientation: x,
				loop: p,
				rtl: h,
				cols: C,
				disabledIndices: Vr([...(typeof b == "function" ? null : b) || s.current.map((e, t) => Hr(s, t, b) ? t : void 0), void 0], r),
				minIndex: i,
				maxIndex: a,
				prevIndex: Br(P.current > o ? n : P.current, t, r, C, e.key === ea ? "bl" : e.key === (h ? Zi : Qi) ? "tr" : "tl"),
				stopEvent: !0
			})];
			if (c != null && (P.current = c, j()), x === "both") return;
		}
		if (go(e.key, x)) {
			if (G(e), r && !g && gr(e.currentTarget.ownerDocument) === e.currentTarget) {
				P.current = _o(e.key, x, h) ? n : o, j();
				return;
			}
			_o(e.key, x, h) ? p ? P.current = t >= o ? f && t !== s.current.length ? -1 : n : J(s, {
				startingIndex: t,
				disabledIndices: b
			}) : P.current = Math.min(o, J(s, {
				startingIndex: t,
				disabledIndices: b
			})) : p ? P.current = t <= n ? f && t !== -1 ? s.current.length : o : J(s, {
				startingIndex: t,
				decrement: !0,
				disabledIndices: b
			}) : P.current = Math.max(n, J(s, {
				startingIndex: t,
				decrement: !0,
				disabledIndices: b
			})), Fr(s, P.current) && (P.current = -1), j();
		}
	}), he = e.useMemo(() => g && r && de && { "aria-activedescendant": ce || oe }, [
		g,
		r,
		de,
		ce,
		oe
	]), ge = e.useMemo(() => ({
		"aria-orientation": x === "both" ? void 0 : x,
		...M ? {} : he,
		onKeyDown: me,
		onPointerMove() {
			I.current = !0;
		}
	}), [
		he,
		me,
		x,
		M
	]), _e = e.useMemo(() => {
		function e(e) {
			_ === "auto" && Or(e.nativeEvent) && (N.current = !0);
		}
		function t(e) {
			N.current = _, _ === "auto" && kr(e.nativeEvent) && (N.current = !0);
		}
		return {
			...he,
			onKeyDown(e) {
				I.current = !1;
				let t = e.key.startsWith("Arrow"), n = ["Home", "End"].includes(e.key), a = t || n, o = vo(e.key, x, h), c = yo(e.key, x, h, C), l = vo(e.key, pe(), h), u = go(e.key, x), f = (m ? l : u) || e.key === "Enter" || e.key.trim() === "";
				if (g && r) {
					let t = A?.nodesRef.current.find((e) => e.parentId == null), r = A && t ? Tr(A.nodesRef.current, t.id) : null;
					if (a && r && T) {
						let t = new KeyboardEvent("keydown", {
							key: e.key,
							bubbles: !0
						});
						if (o || c) {
							let n = r.context?.elements.domReference === e.currentTarget, i = c && !n ? r.context?.elements.domReference : o ? s.current.find((e) => e?.id === oe) : null;
							i && (G(e), i.dispatchEvent(t), le(void 0));
						}
						if ((u || n) && r.context && r.context.open && r.parentId && e.currentTarget !== r.context.elements.domReference) {
							var p;
							G(e), (p = r.context.elements.domReference) == null || p.dispatchEvent(t);
							return;
						}
					}
					return me(e);
				}
				if (r || y || !t) {
					if (f) {
						let t = go(e.key, pe());
						F.current = m && t ? null : e.key;
					}
					if (m) {
						l && (G(e), r ? (P.current = Ir(s, re.current), j()) : i(!0, e.nativeEvent, "list-navigation"));
						return;
					}
					u && (d != null && (P.current = d), G(e), !r && y ? i(!0, e.nativeEvent, "list-navigation") : me(e), r && j());
				}
			},
			onFocus() {
				r && !g && (P.current = -1, j());
			},
			onPointerDown: t,
			onPointerEnter: t,
			onMouseDown: e,
			onClick: e
		};
	}, [
		oe,
		he,
		C,
		me,
		re,
		_,
		s,
		m,
		j,
		i,
		r,
		y,
		x,
		pe,
		h,
		d,
		A,
		g,
		T
	]);
	return e.useMemo(() => u ? {
		reference: _e,
		floating: ge,
		item: fe
	} : {}, [
		u,
		_e,
		ge,
		fe
	]);
}
var xo = /*#__PURE__*/ new Map([
	["select", "listbox"],
	["combobox", "listbox"],
	["label", !1]
]);
function So(t, n) {
	n === void 0 && (n = {});
	let { open: r, elements: i, floatingId: a } = t, { enabled: o = !0, role: s = "dialog" } = n, c = ca(), l = i.domReference?.id || c, u = e.useMemo(() => Cr(i.floating)?.id || a, [i.floating, a]), d = xo.get(s) ?? s, f = ha() != null, p = e.useMemo(() => d === "tooltip" || s === "label" ? { ["aria-" + (s === "label" ? "labelledby" : "describedby")]: r ? u : void 0 } : {
		"aria-expanded": r ? "true" : "false",
		"aria-haspopup": d === "alertdialog" ? "dialog" : d,
		"aria-controls": r ? u : void 0,
		...d === "listbox" && { role: "combobox" },
		...d === "menu" && { id: l },
		...d === "menu" && f && { role: "menuitem" },
		...s === "select" && { "aria-autocomplete": "none" },
		...s === "combobox" && { "aria-autocomplete": "list" }
	}, [
		d,
		u,
		f,
		r,
		l,
		s
	]), m = e.useMemo(() => {
		let e = {
			id: u,
			...d && { role: d }
		};
		return d === "tooltip" || s === "label" ? e : {
			...e,
			...d === "menu" && { "aria-labelledby": l }
		};
	}, [
		d,
		u,
		l,
		s
	]), h = e.useCallback((e) => {
		let { active: t, selected: n } = e, r = {
			role: "option",
			...t && { id: u + "-fui-option" }
		};
		switch (s) {
			case "select":
			case "combobox": return {
				...r,
				"aria-selected": n
			};
		}
		return {};
	}, [u, s]);
	return e.useMemo(() => o ? {
		reference: p,
		floating: m,
		item: h
	} : {}, [
		o,
		p,
		m,
		h
	]);
}
function Co(t, n) {
	let { open: r, dataRef: i } = t, { listRef: a, activeIndex: o, onMatch: s, onTypingChange: c, enabled: l = !0, findMatch: u = null, resetMs: d = 750, ignoreKeys: f = [], selectedIndex: p = null } = n, m = e.useRef(-1), h = e.useRef(""), g = e.useRef(p ?? o ?? -1), _ = e.useRef(null), v = q(s), y = q(c), b = Mr(u), x = Mr(f);
	K(() => {
		r && (Y(m), _.current = null, h.current = "");
	}, [r]), K(() => {
		r && h.current === "" && (g.current = p ?? o ?? -1);
	}, [
		r,
		p,
		o
	]);
	let S = q((e) => {
		e ? i.current.typing || (i.current.typing = e, y(e)) : i.current.typing && (i.current.typing = e, y(e));
	}), C = q((e) => {
		function t(e, t, n) {
			let r = b.current ? b.current(t, n) : t.find((e) => e?.toLocaleLowerCase().indexOf(n.toLocaleLowerCase()) === 0);
			return r ? e.indexOf(r) : -1;
		}
		let n = a.current;
		if (h.current.length > 0 && h.current[0] !== " " && (t(n, n, h.current) === -1 ? S(!1) : e.key === " " && G(e)), n == null || x.current.includes(e.key) || e.key.length !== 1 || e.ctrlKey || e.metaKey || e.altKey) return;
		r && e.key !== " " && (G(e), S(!0)), n.every((e) => !e || e[0]?.toLocaleLowerCase() !== e[1]?.toLocaleLowerCase()) && h.current === e.key && (h.current = "", g.current = _.current), h.current += e.key, Y(m), m.current = window.setTimeout(() => {
			h.current = "", g.current = _.current, S(!1);
		}, d);
		let i = g.current, o = t(n, [...n.slice((i || 0) + 1), ...n.slice(0, (i || 0) + 1)], h.current);
		o === -1 ? e.key !== " " && (h.current = "", S(!1)) : (v(o), _.current = o);
	}), w = e.useMemo(() => ({ onKeyDown: C }), [C]), T = e.useMemo(() => ({
		onKeyDown: C,
		onKeyUp(e) {
			e.key === " " && S(!1);
		}
	}), [C, S]);
	return e.useMemo(() => l ? {
		reference: w,
		floating: T
	} : {}, [
		l,
		w,
		T
	]);
}
var wo = { tooltip: "ex-tooltip-UA7H9" };
//#endregion
//#region src/components/Tooltip/Tooltip.tsx
function To({ content: e, children: n, placement: r = "top", openDelay: i = 200, disabled: a = !1, className: o }) {
	let [s, c] = d(!1), { refs: l, floatingStyles: u, context: f } = co({
		open: s,
		onOpenChange: c,
		placement: r,
		middleware: [
			Wi(8),
			Ki(),
			Gi({ padding: 8 })
		],
		whileElementsMounted: Ni
	}), { getReferenceProps: g, getFloatingProps: _ } = po([
		xa(f, {
			move: !1,
			delay: {
				open: i,
				close: 0
			}
		}),
		uo(f),
		oo(f, { referencePress: !1 }),
		So(f, { role: "tooltip" })
	]), { ref: v, ...y } = n.props, b = qi([l.setReference, v]);
	return a ? n : /* @__PURE__ */ h(p, { children: [t(n, {
		...g(y),
		ref: b
	}), s ? /* @__PURE__ */ m("div", {
		..._(),
		ref: l.setFloating,
		className: P(wo.tooltip, o),
		style: u,
		children: e
	}) : null] });
}
var Eo = {
	tabs: "ex-tabs-QzIkz",
	tablist: "ex-tablist-WR6ag",
	tab: "ex-tab-IdDYc",
	panel: "ex-panel-08i9c"
}, Do = r(function({ items: e, value: t, defaultValue: n, onValueChange: r, label: i, className: a, ...o }, c) {
	let l = s(), f = u(/* @__PURE__ */ new Map()), p = e.find((e) => e.disabled !== !0)?.id, [g, _] = d(n ?? p), v = t !== void 0, y = v ? t : g, b = (e) => {
		v || _(e), r?.(e);
	}, x = e.filter((e) => e.disabled !== !0), S = (e) => {
		if (x.length === 0) return;
		let t = x.findIndex((e) => e.id === y), n = t === -1 ? 0 : (t + e + x.length) % x.length, r = x[n];
		r !== void 0 && (b(r.id), f.current.get(r.id)?.focus());
	}, C = (e) => {
		let t = e === "first" ? x[0] : x[x.length - 1];
		t !== void 0 && (b(t.id), f.current.get(t.id)?.focus());
	}, w = (e) => {
		switch (e.key) {
			case "ArrowRight":
			case "ArrowDown":
				e.preventDefault(), S(1);
				return;
			case "ArrowLeft":
			case "ArrowUp":
				e.preventDefault(), S(-1);
				return;
			case "Home":
				e.preventDefault(), C("first");
				return;
			case "End":
				e.preventDefault(), C("last");
				return;
		}
	};
	return /* @__PURE__ */ h("div", {
		...o,
		ref: c,
		className: P(Eo.tabs, a),
		children: [/* @__PURE__ */ m("div", {
			className: Eo.tablist,
			role: "tablist",
			"aria-label": i,
			onKeyDown: w,
			children: e.map((e) => {
				let t = e.id === y;
				return /* @__PURE__ */ m("button", {
					ref: (t) => {
						t === null ? f.current.delete(e.id) : f.current.set(e.id, t);
					},
					type: "button",
					role: "tab",
					id: `${l}-tab-${e.id}`,
					className: Eo.tab,
					"aria-selected": t,
					"aria-controls": `${l}-panel-${e.id}`,
					tabIndex: t ? 0 : -1,
					disabled: e.disabled,
					onClick: () => {
						b(e.id);
					},
					children: e.label
				}, e.id);
			})
		}), e.map((e) => {
			let t = e.id === y;
			return /* @__PURE__ */ m("div", {
				role: "tabpanel",
				id: `${l}-panel-${e.id}`,
				className: Eo.panel,
				"aria-labelledby": `${l}-tab-${e.id}`,
				hidden: !t,
				tabIndex: t ? 0 : -1,
				children: e.content
			}, e.id);
		})]
	});
}), Oo = {
	list: "ex-list-hXiqr",
	item: "ex-item-O4g3P",
	link: "ex-link-7WM67",
	current: "ex-current-JdlcS",
	separator: "ex-separator-zGWyJ"
}, ko = r(function({ items: e, label: t = "Breadcrumb", separator: n = "/", renderLink: r, className: i, ...a }, o) {
	return /* @__PURE__ */ m("nav", {
		...a,
		ref: o,
		"aria-label": t,
		className: i,
		children: /* @__PURE__ */ m("ol", {
			className: Oo.list,
			children: e.map((t, i) => {
				let a = i === e.length - 1;
				return /* @__PURE__ */ h("li", {
					className: Oo.item,
					children: [t.href !== void 0 && !a ? r === void 0 ? /* @__PURE__ */ m("a", {
						className: Oo.link,
						href: t.href,
						children: t.label
					}) : r({
						href: t.href,
						className: Oo.link ?? "",
						children: t.label
					}) : /* @__PURE__ */ m("span", {
						className: P(Oo.current),
						"aria-current": a ? "page" : void 0,
						children: t.label
					}), a ? null : /* @__PURE__ */ m("span", {
						className: Oo.separator,
						"aria-hidden": "true",
						children: n
					})]
				}, t.id ?? (typeof t.label == "string" ? t.label : i));
			})
		})
	});
}), Ao = {
	menu: "ex-menu-uj3BS",
	item: "ex-item-NMXha",
	icon: "ex-icon-n6RdC",
	label: "ex-label-4FBGa",
	shortcut: "ex-shortcut-hA8bN"
};
//#endregion
//#region src/components/Menu/Menu.tsx
function jo({ trigger: e, items: n, placement: r = "bottom-start", label: i, open: a, onOpenChange: o, className: c }) {
	let [f, g] = d(!1), [_, v] = d(null), y = s(), b = a !== void 0, x = b ? a : f, S = u([]), C = n.map((e) => `${e.id}\u001e${e.label}\u001e${String(e.disabled ?? !1)}`).join(""), w = l(() => ({ current: n.map((e) => e.label) }), [C]), T = l(() => n.flatMap((e, t) => e.disabled === !0 ? [t] : []), [C]), E = (e) => {
		b || g(e), o?.(e);
	}, { refs: D, floatingStyles: O, context: k } = co({
		open: x,
		onOpenChange: E,
		placement: r,
		middleware: [
			Wi(4),
			Ki(),
			Gi({ padding: 8 })
		],
		whileElementsMounted: Ni
	}), { getReferenceProps: A, getFloatingProps: j, getItemProps: M } = po([
		no(k),
		oo(k),
		So(k, { role: "menu" }),
		bo(k, {
			listRef: S,
			activeIndex: _,
			onNavigate: v,
			loop: !0,
			focusItemOnOpen: !0,
			disabledIndices: T
		}),
		Co(k, {
			listRef: w,
			activeIndex: _,
			onMatch: v,
			enabled: x
		})
	]), { ref: N, ...F } = e.props, I = qi([D.setReference, N]);
	return /* @__PURE__ */ h(p, { children: [t(e, {
		...A(F),
		ref: I,
		id: y,
		"aria-haspopup": "menu"
	}), x ? /* @__PURE__ */ m(Va, { children: /* @__PURE__ */ m(Qa, {
		context: k,
		modal: !1,
		returnFocus: !0,
		children: /* @__PURE__ */ m("div", {
			...j(),
			ref: D.setFloating,
			className: P(Ao.menu, c),
			style: O,
			"aria-label": i,
			"aria-labelledby": i === void 0 ? y : void 0,
			children: n.map((e, t) => /* @__PURE__ */ h("button", {
				...M({ onClick: () => {
					e.onSelect?.(), E(!1);
				} }),
				ref: (e) => {
					S.current[t] = e;
				},
				type: "button",
				role: "menuitem",
				className: Ao.item,
				"data-tone": e.tone ?? "default",
				"data-active": t === _,
				disabled: e.disabled,
				children: [
					e.icon === void 0 ? null : /* @__PURE__ */ m("span", {
						className: Ao.icon,
						"aria-hidden": "true",
						children: e.icon
					}),
					/* @__PURE__ */ m("span", {
						className: Ao.label,
						children: e.label
					}),
					e.shortcut === void 0 ? null : /* @__PURE__ */ m("span", {
						className: Ao.shortcut,
						"aria-hidden": "true",
						children: e.shortcut
					})
				]
			}, e.id))
		})
	}) }) : null] });
}
var Mo = {
	accordion: "ex-accordion-LVhhv",
	item: "ex-item-7ryVk",
	heading: "ex-heading-6PDIo",
	trigger: "ex-trigger-9BYFY",
	chevron: "ex-chevron-i-HVZ",
	panel: "ex-panel-Wx50w"
}, No = r(function({ items: e, multiple: t = !1, defaultOpen: n = [], open: r, onOpenChange: i, headingLevel: a = 3, className: o, ...c }, l) {
	let u = s(), [f, p] = d(n), g = r !== void 0, _ = g ? r : f, v = `h${String(a)}`, y = (e) => {
		let n = _.includes(e) ? _.filter((t) => t !== e) : t ? [..._, e] : [e];
		g || p(n), i?.(n);
	};
	return /* @__PURE__ */ m("div", {
		...c,
		ref: l,
		className: P(Mo.accordion, o),
		children: e.map((e) => {
			let t = _.includes(e.id), n = `${u}-trigger-${e.id}`, r = `${u}-panel-${e.id}`;
			return /* @__PURE__ */ h("div", {
				className: Mo.item,
				children: [/* @__PURE__ */ m(v, {
					className: Mo.heading,
					children: /* @__PURE__ */ h("button", {
						type: "button",
						id: n,
						className: Mo.trigger,
						"aria-expanded": t,
						"aria-controls": r,
						disabled: e.disabled,
						onClick: () => {
							y(e.id);
						},
						children: [/* @__PURE__ */ m("span", { children: e.label }), /* @__PURE__ */ m("span", {
							className: Mo.chevron,
							"aria-hidden": "true",
							children: "▾"
						})]
					})
				}), /* @__PURE__ */ m("div", {
					id: r,
					role: "region",
					className: Mo.panel,
					"aria-labelledby": n,
					hidden: !t,
					children: e.content
				})]
			}, e.id);
		})
	});
}), Po = [
	"a[href]",
	"area[href]",
	"button:not([disabled])",
	"input:not([disabled]):not([type=\"hidden\"])",
	"select:not([disabled])",
	"textarea:not([disabled])",
	"summary",
	"iframe",
	"audio[controls]",
	"video[controls]",
	"[contenteditable]:not([contenteditable=\"false\"])",
	"[tabindex]:not([tabindex=\"-1\"])"
].join(",");
function Fo(e) {
	return Array.from(e.querySelectorAll(Po)).filter((e) => !e.hasAttribute("hidden") && e.getAttribute("aria-hidden") !== "true" && (e.offsetParent !== null || e.ownerDocument.defaultView?.name === void 0));
}
function Io(e, t) {
	o(() => {
		if (!t) return;
		let n = e.current;
		if (!n) return;
		let r = document.activeElement;
		(n.querySelector("[data-autofocus]") ?? Fo(n)[0] ?? n).focus();
		let i = (e) => {
			if (e.key !== "Tab") return;
			let t = Fo(n);
			if (t.length === 0) {
				e.preventDefault(), n.focus();
				return;
			}
			let r = t[0], i = t[t.length - 1];
			if (r === void 0 || i === void 0) return;
			let a = document.activeElement;
			e.shiftKey && (a === r || a === n) ? (e.preventDefault(), i.focus()) : !e.shiftKey && a === i ? (e.preventDefault(), r.focus()) : a !== null && !n.contains(a) && (e.preventDefault(), (e.shiftKey ? i : r).focus());
		};
		return document.addEventListener("keydown", i, !0), () => {
			document.removeEventListener("keydown", i, !0), r instanceof HTMLElement && r.focus();
		};
	}, [t, e]);
}
var Lo = [];
function Ro(e, t) {
	o(() => {
		if (!e) return;
		let n = () => {
			t();
		};
		Lo.push(n);
		let r = (e) => {
			e.key === "Escape" && Lo[Lo.length - 1] === n && (e.preventDefault(), n());
		};
		return document.addEventListener("keydown", r), () => {
			document.removeEventListener("keydown", r);
			let e = Lo.lastIndexOf(n);
			e !== -1 && Lo.splice(e, 1);
		};
	}, [e, t]);
}
var zo = 0, Bo = "";
function Vo(e) {
	o(() => {
		if (e) return zo === 0 && (Bo = document.body.style.overflow, document.body.style.overflow = "hidden"), zo += 1, () => {
			--zo, zo === 0 && (document.body.style.overflow = Bo);
		};
	}, [e]);
}
var Ho = {
	backdrop: "ex-backdrop-GVUh4",
	dialog: "ex-dialog-ptM-K",
	header: "ex-header-ILG9i",
	titleGroup: "ex-titleGroup-IxHYQ",
	title: "ex-title-A5OeE",
	description: "ex-description-iUYzr",
	body: "ex-body-lVhql",
	footer: "ex-footer-rro2w",
	close: "ex-close--ER1C"
}, Uo = [
	"sm",
	"md",
	"lg"
];
function Wo({ open: e, onClose: t, title: n, children: r, description: i, footer: a, size: o = "md", closeOnBackdropClick: c = !0, showClose: l = !0, closeLabel: d = "Close dialog", className: f }) {
	let p = u(null), g = s(), v = `${g}-title`, y = `${g}-description`;
	return Io(p, e), Ro(e, t), Vo(e), !e || typeof document > "u" ? null : _(/* @__PURE__ */ m("div", {
		className: Ho.backdrop,
		onMouseDown: (e) => {
			c && e.target === e.currentTarget && t();
		},
		children: /* @__PURE__ */ h("div", {
			ref: p,
			role: "dialog",
			"aria-modal": "true",
			"aria-labelledby": v,
			"aria-describedby": i === void 0 ? void 0 : y,
			className: P(Ho.dialog, f),
			"data-size": o,
			tabIndex: -1,
			children: [
				/* @__PURE__ */ h("div", {
					className: Ho.header,
					children: [/* @__PURE__ */ h("div", {
						className: Ho.titleGroup,
						children: [/* @__PURE__ */ m("h2", {
							className: Ho.title,
							id: v,
							children: n
						}), i === void 0 ? null : /* @__PURE__ */ m("p", {
							className: Ho.description,
							id: y,
							children: i
						})]
					}), l ? /* @__PURE__ */ m("button", {
						type: "button",
						className: Ho.close,
						"aria-label": d,
						onClick: t,
						children: "✕"
					}) : null]
				}),
				/* @__PURE__ */ m("div", {
					className: Ho.body,
					children: r
				}),
				a === void 0 ? null : /* @__PURE__ */ m("div", {
					className: Ho.footer,
					children: a
				})
			]
		})
	}), document.body);
}
var Go = {
	backdrop: "ex-backdrop-czg6e",
	panel: "ex-panel-wUX0N",
	header: "ex-header-sYoP1",
	titleGroup: "ex-titleGroup--Nf-c",
	title: "ex-title-LqUOu",
	description: "ex-description-haipn",
	body: "ex-body-aV9FG",
	footer: "ex-footer-AuvUP",
	close: "ex-close-tYPhU"
}, Ko = [
	"start",
	"end",
	"top",
	"bottom"
];
function qo({ open: e, onClose: t, title: n, children: r, description: i, footer: a, side: o = "end", closeOnBackdropClick: c = !0, showClose: l = !0, closeLabel: d = "Close panel", className: f }) {
	let p = u(null), g = s(), v = `${g}-title`, y = `${g}-description`;
	return Io(p, e), Ro(e, t), Vo(e), !e || typeof document > "u" ? null : _(/* @__PURE__ */ m("div", {
		className: Go.backdrop,
		"data-side": o,
		onMouseDown: (e) => {
			c && e.target === e.currentTarget && t();
		},
		children: /* @__PURE__ */ h("div", {
			ref: p,
			role: "dialog",
			"aria-modal": "true",
			"aria-labelledby": v,
			"aria-describedby": i === void 0 ? void 0 : y,
			className: P(Go.panel, f),
			"data-side": o,
			tabIndex: -1,
			children: [
				/* @__PURE__ */ h("div", {
					className: Go.header,
					children: [/* @__PURE__ */ h("div", {
						className: Go.titleGroup,
						children: [/* @__PURE__ */ m("h2", {
							className: Go.title,
							id: v,
							children: n
						}), i === void 0 ? null : /* @__PURE__ */ m("p", {
							className: Go.description,
							id: y,
							children: i
						})]
					}), l ? /* @__PURE__ */ m("button", {
						type: "button",
						className: Go.close,
						"aria-label": d,
						onClick: t,
						children: "✕"
					}) : null]
				}),
				/* @__PURE__ */ m("div", {
					className: Go.body,
					children: r
				}),
				a === void 0 ? null : /* @__PURE__ */ m("div", {
					className: Go.footer,
					children: a
				})
			]
		})
	}), document.body);
}
var Jo = {
	popover: "ex-popover-E9K9X",
	header: "ex-header-u8-jn",
	title: "ex-title-hAl5w",
	dismiss: "ex-dismiss-RLSHt"
};
//#endregion
//#region src/components/Popover/Popover.tsx
function Yo({ trigger: e, children: n, title: r, placement: i = "bottom-start", open: a, onOpenChange: o, showDismiss: c = !1, dismissLabel: l = "Close", className: u }) {
	let [f, g] = d(!1), _ = a !== void 0, v = _ ? a : f, y = s(), b = (e) => {
		_ || g(e), o?.(e);
	}, { refs: x, floatingStyles: S, context: C } = co({
		open: v,
		onOpenChange: b,
		placement: i,
		middleware: [
			Wi(8),
			Ki(),
			Gi({ padding: 8 })
		],
		whileElementsMounted: Ni
	}), { getReferenceProps: w, getFloatingProps: T } = po([
		no(C),
		oo(C),
		So(C, { role: "dialog" })
	]), { ref: E, ...D } = e.props, O = qi([x.setReference, E]);
	return /* @__PURE__ */ h(p, { children: [t(e, {
		...w(D),
		ref: O
	}), v ? /* @__PURE__ */ m(Va, { children: /* @__PURE__ */ m(Qa, {
		context: C,
		modal: !1,
		returnFocus: !0,
		children: /* @__PURE__ */ h("div", {
			...T(),
			ref: x.setFloating,
			className: P(Jo.popover, u),
			style: S,
			"aria-labelledby": r === void 0 ? void 0 : y,
			children: [r !== void 0 || c ? /* @__PURE__ */ h("div", {
				className: Jo.header,
				children: [r === void 0 ? /* @__PURE__ */ m("span", {}) : /* @__PURE__ */ m("h2", {
					className: Jo.title,
					id: y,
					children: r
				}), c ? /* @__PURE__ */ m("button", {
					type: "button",
					className: Jo.dismiss,
					"aria-label": l,
					onClick: () => {
						b(!1);
					},
					children: "✕"
				}) : null]
			}) : null, n]
		})
	}) }) : null] });
}
var Xo = { stack: "ex-stack-yUU-B" }, X = r(function({ gap: e, align: t, justify: n, className: r, style: i, ...a }, o) {
	return /* @__PURE__ */ m("div", {
		...a,
		ref: o,
		className: P(Xo.stack, r),
		style: j({ "--ex-stack-gap": N(e) }, i),
		"data-align": t,
		"data-justify": n
	});
}), Zo = { inline: "ex-inline-NBkzl" }, Z = r(function({ gap: e, align: t, justify: n, wrap: r = !0, className: i, style: a, ...o }, s) {
	return /* @__PURE__ */ m("div", {
		...o,
		ref: s,
		className: P(Zo.inline, i),
		style: j({ "--ex-cluster-gap": N(e) }, a),
		"data-align": t,
		"data-justify": n,
		"data-wrap": r ? void 0 : "false"
	});
}), Qo = { grid: "ex-grid-h49fk" }, $o = r(function({ gap: e, minItemWidth: t, columns: n, className: r, style: i, ...a }, o) {
	return /* @__PURE__ */ m("div", {
		...a,
		ref: o,
		className: P(Qo.grid, r),
		style: j({
			"--ex-grid-gap": N(e),
			"--ex-grid-min": t,
			"--ex-grid-columns": n === void 0 ? void 0 : String(n)
		}, i),
		"data-fixed-columns": n === void 0 ? void 0 : "true"
	});
}), es = { container: "ex-container-JMoiT" }, ts = [
	"sm",
	"md",
	"lg",
	"xl",
	"full"
], ns = r(function({ size: e = "lg", className: t, ...n }, r) {
	return /* @__PURE__ */ m("div", {
		...n,
		ref: r,
		className: P(es.container, t),
		"data-size": e
	});
}), rs = {
	header: "ex-header-AIWmk",
	eyebrow: "ex-eyebrow-h6Csn",
	titleRow: "ex-titleRow-bD5z9",
	titleGroup: "ex-titleGroup-6T8c4",
	title: "ex-title-mv-ab",
	description: "ex-description-IaGTq",
	actions: "ex-actions-6XyFL"
}, is = r(function({ title: e, eyebrow: t, description: n, actions: r, breadcrumbs: i, headingLevel: a = 1, className: o, children: s, ...c }, l) {
	let u = a === 1 ? "h1" : "h2";
	return /* @__PURE__ */ h("header", {
		...c,
		ref: l,
		className: P(rs.header, o),
		children: [
			i,
			t === void 0 ? null : /* @__PURE__ */ m("span", {
				className: rs.eyebrow,
				children: t
			}),
			/* @__PURE__ */ h("div", {
				className: rs.titleRow,
				children: [/* @__PURE__ */ h("div", {
					className: rs.titleGroup,
					children: [/* @__PURE__ */ m(u, {
						className: rs.title,
						children: e
					}), n === void 0 ? null : /* @__PURE__ */ m("p", {
						className: rs.description,
						children: n
					})]
				}), r === void 0 ? null : /* @__PURE__ */ m("div", {
					className: rs.actions,
					children: r
				})]
			}),
			s
		]
	});
}), as = {
	section: "ex-section-rDCqT",
	header: "ex-header-PQ9ox",
	titleGroup: "ex-titleGroup-3l3gT",
	title: "ex-title--9dX0",
	description: "ex-description-HIBwb",
	actions: "ex-actions-FYZQm"
}, os = r(function({ title: e, description: t, actions: n, headingLevel: r = 2, gap: i, className: a, style: o, children: c, ...l }, u) {
	let d = s(), f = `h${String(r)}`, p = e !== void 0 || t !== void 0 || n !== void 0;
	return /* @__PURE__ */ h("section", {
		...l,
		ref: u,
		className: P(as.section, a),
		style: j({ "--ex-section-gap": N(i) }, o),
		"aria-labelledby": e === void 0 ? void 0 : d,
		children: [p ? /* @__PURE__ */ h("div", {
			className: as.header,
			children: [/* @__PURE__ */ h("div", {
				className: as.titleGroup,
				children: [e === void 0 ? null : /* @__PURE__ */ m(f, {
					className: as.title,
					id: d,
					children: e
				}), t === void 0 ? null : /* @__PURE__ */ m("p", {
					className: as.description,
					children: t
				})]
			}), n === void 0 ? null : /* @__PURE__ */ m("div", {
				className: as.actions,
				children: n
			})]
		}) : null, c]
	});
}), Q = {
	gallery: "ex-gallery-1baBr",
	toolbar: "ex-toolbar-OYoCh",
	toolbarInner: "ex-toolbarInner-Gq6cY",
	brand: "ex-brand-GyUUX",
	brandTitle: "ex-brandTitle-8VsuF",
	brandSubtitle: "ex-brandSubtitle-JDk33",
	controls: "ex-controls-3Z2-I",
	content: "ex-content-YyaM-",
	specimen: "ex-specimen-yVXbv",
	specimenLabel: "ex-specimenLabel-2Dago",
	specimenNote: "ex-specimenNote-igjbB",
	swatchGrid: "ex-swatchGrid-lBc0z",
	swatch: "ex-swatch-CJQJl",
	swatchChip: "ex-swatchChip-P1P2x",
	swatchName: "ex-swatchName-E2cFj",
	scaleRow: "ex-scaleRow-noOrU",
	scaleBar: "ex-scaleBar-BRHgR",
	scaleName: "ex-scaleName-qi4gp",
	radiusChip: "ex-radiusChip-xCMj2",
	typeSpecimen: "ex-typeSpecimen-sBm-3",
	fieldGrid: "ex-fieldGrid-hthH3",
	fieldset: "ex-fieldset-KHfco",
	legend: "ex-legend-aUXXq"
};
//#endregion
//#region src/gallery/ComponentGallery.tsx
function $({ label: e, note: t, children: n }) {
	return /* @__PURE__ */ h("div", {
		className: Q.specimen,
		children: [
			/* @__PURE__ */ m("span", {
				className: Q.specimenLabel,
				children: e
			}),
			t === void 0 ? null : /* @__PURE__ */ m("p", {
				className: Q.specimenNote,
				children: t
			}),
			n
		]
	});
}
var ss = [
	{
		value: "light",
		label: "Light"
	},
	{
		value: "dark",
		label: "Dark"
	},
	{
		value: "system",
		label: "System"
	}
];
function cs({ greyscale: e, onGreyscaleChange: t }) {
	let { theme: n, resolvedTheme: r, setTheme: i } = y();
	return /* @__PURE__ */ m("div", {
		className: Q.toolbar,
		children: /* @__PURE__ */ m(ns, {
			size: "xl",
			children: /* @__PURE__ */ h("div", {
				className: Q.toolbarInner,
				children: [/* @__PURE__ */ h("div", {
					className: Q.brand,
					children: [/* @__PURE__ */ m("h1", {
						className: Q.brandTitle,
						children: "Endeavor X component gallery"
					}), /* @__PURE__ */ h("p", {
						className: Q.brandSubtitle,
						children: ["@catalog/ui — currently rendering ", r]
					})]
				}), /* @__PURE__ */ h("div", {
					className: Q.controls,
					children: [/* @__PURE__ */ m(Z, {
						gap: "1",
						role: "group",
						"aria-label": "Theme",
						children: ss.map((e) => /* @__PURE__ */ m(R, {
							size: "sm",
							variant: n === e.value ? "primary" : "ghost",
							"aria-pressed": n === e.value,
							onClick: () => {
								i(e.value);
							},
							children: e.label
						}, e.value))
					}), /* @__PURE__ */ m(Fe, {
						label: "Greyscale",
						checked: e,
						onChange: (e) => {
							t(e.target.checked);
						}
					})]
				})]
			})
		})
	});
}
var ls = [
	"--ex-color-brand",
	"--ex-color-brand-strong",
	"--ex-color-brand-deep",
	"--ex-surface-brand",
	"--ex-color-action",
	"--ex-color-action-strong",
	"--ex-surface",
	"--ex-surface-muted",
	"--ex-surface-sunken",
	"--ex-text",
	"--ex-text-muted",
	"--ex-border",
	"--ex-border-subtle",
	"--ex-color-success",
	"--ex-color-warning",
	"--ex-color-danger",
	"--ex-color-neutral"
], us = [
	"1",
	"2",
	"3",
	"4",
	"5",
	"6",
	"8",
	"12",
	"16",
	"20"
], ds = [
	"sm",
	"md",
	"lg",
	"xl",
	"2xl",
	"pill"
], fs = [
	"display-1",
	"display-2",
	"display-3"
];
function ps() {
	return /* @__PURE__ */ m(os, {
		id: "tokens",
		title: "Tokens",
		description: "Every value below is read from tokens.css, which is a verbatim copy of the Endeavor X source. Switch the theme to see which of them re-point.",
		children: /* @__PURE__ */ h(X, {
			gap: "4",
			children: [
				/* @__PURE__ */ m($, {
					label: "Colour",
					children: /* @__PURE__ */ m("div", {
						className: Q.swatchGrid,
						children: ls.map((e) => /* @__PURE__ */ h("div", {
							className: Q.swatch,
							children: [/* @__PURE__ */ m("div", {
								className: Q.swatchChip,
								style: j({ "--ex-swatch-color": `var(${e})` })
							}), /* @__PURE__ */ m("span", {
								className: Q.swatchName,
								children: e
							})]
						}, e))
					})
				}),
				/* @__PURE__ */ m($, {
					label: "Spacing",
					note: "The Evolution 4px base scale.",
					children: /* @__PURE__ */ m(X, {
						gap: "2",
						children: us.map((e) => /* @__PURE__ */ h("div", {
							className: Q.scaleRow,
							children: [/* @__PURE__ */ m("div", {
								className: Q.scaleBar,
								style: j({ "--ex-scale-size": `var(--ex-space-${e})` })
							}), /* @__PURE__ */ h("span", {
								className: Q.scaleName,
								children: ["--ex-space-", e]
							})]
						}, e))
					})
				}),
				/* @__PURE__ */ m($, {
					label: "Radius",
					children: /* @__PURE__ */ m(Z, {
						gap: "3",
						children: ds.map((e) => /* @__PURE__ */ m("div", {
							className: Q.radiusChip,
							style: j({ "--ex-radius-chip": `var(--ex-radius-${e})` }),
							children: e
						}, e))
					})
				}),
				/* @__PURE__ */ m($, {
					label: "Display scale",
					note: "Plus Jakarta Sans, self-hosted.",
					children: /* @__PURE__ */ m(X, {
						gap: "2",
						children: fs.map((e) => /* @__PURE__ */ m("p", {
							className: Q.typeSpecimen,
							style: j({ "--ex-type-size": `var(--ex-${e})` }),
							children: "Grounded, not generative"
						}, e))
					})
				})
			]
		})
	});
}
function ms() {
	return /* @__PURE__ */ m(os, {
		id: "primitives",
		title: "Primitives",
		children: /* @__PURE__ */ h(X, {
			gap: "4",
			children: [
				/* @__PURE__ */ m($, {
					label: "Button — variants",
					note: "Pill-shaped in every variant. The action yellow takes dark ink: white on it measures 1.49:1.",
					children: /* @__PURE__ */ m(Z, {
						gap: "2",
						children: L.map((e) => /* @__PURE__ */ m(R, {
							variant: e,
							children: e
						}, e))
					})
				}),
				/* @__PURE__ */ m($, {
					label: "Button — sizes",
					children: /* @__PURE__ */ m(Z, {
						gap: "2",
						align: "center",
						children: te.map((e) => /* @__PURE__ */ h(R, {
							size: e,
							children: ["Size ", e]
						}, e))
					})
				}),
				/* @__PURE__ */ m($, {
					label: "Button — states",
					note: "A loading button keeps focus; a disabled one leaves the tab order.",
					children: /* @__PURE__ */ h(Z, {
						gap: "2",
						children: [
							/* @__PURE__ */ m(R, {
								loading: !0,
								children: "Searching"
							}),
							/* @__PURE__ */ m(R, {
								loading: !0,
								variant: "action",
								loadingLabel: "Enrolling",
								children: "Enrol"
							}),
							/* @__PURE__ */ m(R, {
								disabled: !0,
								children: "Disabled"
							}),
							/* @__PURE__ */ m(R, {
								variant: "danger",
								disabled: !0,
								children: "Disabled danger"
							})
						]
					})
				}),
				/* @__PURE__ */ m($, {
					label: "IconButton",
					note: "Every one has an aria-label; the glyph is hidden.",
					children: /* @__PURE__ */ h(Z, {
						gap: "2",
						align: "center",
						children: [
							re.map((e) => /* @__PURE__ */ m(ie, {
								variant: e,
								label: `${e} action`,
								children: "★"
							}, e)),
							/* @__PURE__ */ m(ie, {
								size: "sm",
								label: "Small action",
								children: "★"
							}),
							/* @__PURE__ */ m(ie, {
								size: "lg",
								label: "Large action",
								children: "★"
							}),
							/* @__PURE__ */ m(ie, {
								disabled: !0,
								label: "Unavailable action",
								children: "★"
							})
						]
					})
				}),
				/* @__PURE__ */ m($, {
					label: "Link",
					children: /* @__PURE__ */ h(Z, {
						gap: "4",
						children: [
							/* @__PURE__ */ m(se, {
								href: "#link-demo",
								children: "Default link"
							}),
							/* @__PURE__ */ m(se, {
								href: "#link-demo",
								variant: "subtle",
								children: "Subtle link"
							}),
							/* @__PURE__ */ m(se, {
								href: "https://pearson.com",
								external: !0,
								children: "External link"
							})
						]
					})
				}),
				/* @__PURE__ */ m($, {
					label: "Spinner",
					children: /* @__PURE__ */ h(Z, {
						gap: "4",
						align: "center",
						children: [
							/* @__PURE__ */ m(ue, {
								size: "sm",
								label: "Loading small"
							}),
							/* @__PURE__ */ m(ue, { label: "Loading" }),
							/* @__PURE__ */ m(ue, {
								size: "lg",
								label: "Loading large"
							})
						]
					})
				}),
				/* @__PURE__ */ m($, {
					label: "Skeleton",
					children: /* @__PURE__ */ h(X, {
						gap: "3",
						children: [/* @__PURE__ */ m(pe, { lines: 3 }), /* @__PURE__ */ h(Z, {
							gap: "3",
							align: "center",
							children: [/* @__PURE__ */ m(pe, { shape: "circle" }), /* @__PURE__ */ m(pe, {
								shape: "rect",
								width: "12rem",
								height: "var(--ex-space-8)"
							})]
						})]
					})
				}),
				/* @__PURE__ */ m($, {
					label: "Divider",
					children: /* @__PURE__ */ h(X, {
						gap: "4",
						children: [
							/* @__PURE__ */ m(he, {}),
							/* @__PURE__ */ m(he, { label: "or" }),
							/* @__PURE__ */ h(Z, {
								gap: "3",
								align: "center",
								children: [
									/* @__PURE__ */ m("span", { children: "Before" }),
									/* @__PURE__ */ m(he, { orientation: "vertical" }),
									/* @__PURE__ */ m("span", { children: "After" })
								]
							})
						]
					})
				})
			]
		})
	});
}
var hs = [
	{
		id: "cka",
		label: "Certified Kubernetes Administrator",
		description: "14 h · 9 modules"
	},
	{
		id: "saa",
		label: "AWS Certified Solutions Architect",
		description: "22 h · 14 modules"
	},
	{
		id: "sec",
		label: "CompTIA Security+ SY0-701",
		description: "18 h · 11 modules"
	}
];
function gs(e) {
	let t = Math.floor(e / 3600), n = Math.round(e % 3600 / 60);
	return t === 0 ? `${String(n)} min` : n === 0 ? `${String(t)} h` : `${String(t)} h ${String(n)} min`;
}
function _s() {
	let [e, t] = d(""), [n, r] = d([1800, 36e3]), [i, a] = d(!0), [o, s] = d("beginner"), [c, l] = d(!1);
	return /* @__PURE__ */ m(os, {
		id: "forms",
		title: "Forms",
		description: "FormField owns the label/hint/error wiring; the controls read it from context.",
		children: /* @__PURE__ */ h(X, {
			gap: "4",
			children: [
				/* @__PURE__ */ m($, {
					label: "FormField — the four states",
					children: /* @__PURE__ */ h("div", {
						className: Q.fieldGrid,
						children: [
							/* @__PURE__ */ m(be, {
								label: "Course title",
								children: /* @__PURE__ */ m(Ce, { placeholder: "e.g. Kubernetes" })
							}),
							/* @__PURE__ */ m(be, {
								label: "Course title",
								hint: "Searches titles and descriptions only.",
								children: /* @__PURE__ */ m(Ce, { placeholder: "e.g. Kubernetes" })
							}),
							/* @__PURE__ */ m(be, {
								label: "ISBN",
								required: !0,
								hint: "13 digits, no dashes.",
								children: /* @__PURE__ */ m(Ce, {
									placeholder: "9780138057398",
									inputMode: "numeric"
								})
							}),
							/* @__PURE__ */ m(be, {
								label: "ISBN",
								required: !0,
								hint: "13 digits, no dashes.",
								error: "That ISBN is not in the licensed catalog.",
								children: /* @__PURE__ */ m(Ce, {
									defaultValue: "123",
									inputMode: "numeric"
								})
							})
						]
					})
				}),
				/* @__PURE__ */ m($, {
					label: "Input, Textarea, Select",
					children: /* @__PURE__ */ h("div", {
						className: Q.fieldGrid,
						children: [
							/* @__PURE__ */ m(be, {
								label: "Small",
								children: /* @__PURE__ */ m(Ce, {
									size: "sm",
									placeholder: "Small"
								})
							}),
							/* @__PURE__ */ m(be, {
								label: "Large",
								children: /* @__PURE__ */ m(Ce, {
									size: "lg",
									placeholder: "Large"
								})
							}),
							/* @__PURE__ */ m(be, {
								label: "Disabled",
								children: /* @__PURE__ */ m(Ce, {
									disabled: !0,
									defaultValue: "Not editable"
								})
							}),
							/* @__PURE__ */ m(be, {
								label: "Knowledge suite",
								children: /* @__PURE__ */ h(Oe, {
									placeholder: "Any suite",
									defaultValue: "",
									children: [
										/* @__PURE__ */ m("option", {
											value: "cloud",
											children: "Cloud"
										}),
										/* @__PURE__ */ m("option", {
											value: "security",
											children: "Security"
										}),
										/* @__PURE__ */ m("option", {
											value: "ai",
											children: "AI and data"
										})
									]
								})
							}),
							/* @__PURE__ */ m(be, {
								label: "Notes",
								hint: "Markdown is not supported.",
								children: /* @__PURE__ */ m(Te, { placeholder: "Why is this course relevant?" })
							}),
							/* @__PURE__ */ m(be, {
								label: "Notes",
								error: "Please say something.",
								children: /* @__PURE__ */ m(Te, {})
							})
						]
					})
				}),
				/* @__PURE__ */ m($, {
					label: "SearchInput",
					note: "A combobox: ArrowDown opens the list, Enter picks the highlighted row, Escape closes it and then clears.",
					children: /* @__PURE__ */ h(X, {
						gap: "3",
						children: [/* @__PURE__ */ m(Re, {
							value: e,
							onValueChange: t,
							suggestions: hs.filter((t) => t.label.toLowerCase().includes(e.toLowerCase())),
							emptyMessage: "No courses match that.",
							placeholder: "Search the catalog",
							suggestionsLabel: "Course suggestions"
						}), /* @__PURE__ */ m(Re, {
							value: "",
							onValueChange: () => void 0,
							size: "sm",
							placeholder: "Small, no suggestions"
						})]
					})
				}),
				/* @__PURE__ */ m($, {
					label: "Checkbox, Radio, Switch",
					note: "Each state is a glyph or a position, not a colour.",
					children: /* @__PURE__ */ h("div", {
						className: Q.fieldGrid,
						children: [
							/* @__PURE__ */ h(X, {
								gap: "2",
								children: [
									/* @__PURE__ */ m(je, {
										label: "Has transcripts",
										description: "Excludes the 69 metadata-only courses.",
										checked: i,
										onChange: (e) => {
											a(e.target.checked);
										}
									}),
									/* @__PURE__ */ m(je, { label: "Unchecked" }),
									/* @__PURE__ */ m(je, {
										label: "Indeterminate",
										indeterminate: !0
									}),
									/* @__PURE__ */ m(je, {
										label: "Disabled",
										disabled: !0
									})
								]
							}),
							/* @__PURE__ */ h("fieldset", {
								className: Q.fieldset,
								children: [
									/* @__PURE__ */ m("legend", {
										className: Q.legend,
										children: "Level"
									}),
									[
										"beginner",
										"intermediate",
										"advanced"
									].map((e) => /* @__PURE__ */ m(Ne, {
										name: "gallery-level",
										value: e,
										label: e,
										checked: o === e,
										onChange: () => {
											s(e);
										}
									}, e)),
									/* @__PURE__ */ m(Ne, {
										name: "gallery-level-disabled",
										label: "Disabled",
										disabled: !0
									})
								]
							}),
							/* @__PURE__ */ h(X, {
								gap: "2",
								children: [
									/* @__PURE__ */ m(Fe, {
										label: "Transcripts only",
										checked: c,
										onChange: (e) => {
											l(e.target.checked);
										}
									}),
									/* @__PURE__ */ m(Fe, {
										label: "Label first",
										labelPosition: "start",
										defaultChecked: !0
									}),
									/* @__PURE__ */ m(Fe, {
										label: "Disabled",
										disabled: !0
									})
								]
							})
						]
					})
				}),
				/* @__PURE__ */ m($, {
					label: "RangeSlider",
					note: "Two native range inputs, each separately named and announcing a formatted value.",
					children: /* @__PURE__ */ m(Ve, {
						label: "Course duration",
						min: 0,
						max: 86400,
						step: 1800,
						value: n,
						onValueChange: r,
						formatValue: gs
					})
				})
			]
		})
	});
}
var vs = [
	{
		isbn: "9780138057398",
		title: "AWS Certified Solutions Architect",
		duration: 79200,
		lessons: 142
	},
	{
		isbn: "9780135375099",
		title: "Certified Kubernetes Administrator",
		duration: 50400,
		lessons: 96
	},
	{
		isbn: "9780138250966",
		title: "CompTIA Security+ SY0-701",
		duration: 64800,
		lessons: 118
	}
];
function ys() {
	let [e, t] = d({
		key: "title",
		direction: "ascending"
	}), [n, r] = d([
		"Kubernetes",
		"Security",
		"Beginner"
	]), i = [...vs].sort((t, n) => {
		let r = e.direction === "ascending" ? 1 : -1;
		return e.key === "duration" ? (t.duration - n.duration) * r : e.key === "lessons" ? (t.lessons - n.lessons) * r : t.title.localeCompare(n.title) * r;
	});
	return /* @__PURE__ */ m(os, {
		id: "data-display",
		title: "Data display",
		children: /* @__PURE__ */ h(X, {
			gap: "4",
			children: [
				/* @__PURE__ */ m($, {
					label: "Card",
					note: "An interactive card is a real button, so it must not contain its own controls.",
					children: /* @__PURE__ */ h($o, {
						minItemWidth: "16rem",
						children: [
							/* @__PURE__ */ m(Ue, {
								header: "Static card",
								footer: /* @__PURE__ */ m(Je, {
									tone: "brand",
									children: "Cloud"
								}),
								children: "Header, body and footer bands. Nothing here is interactive."
							}),
							/* @__PURE__ */ m(Ue, {
								interactive: !0,
								header: "Interactive card",
								"aria-label": "Open the Kubernetes course",
								onClick: () => void 0,
								children: "Hover and tab to it. It activates on Enter and Space because it is a button."
							}),
							/* @__PURE__ */ m(Ue, { children: "A card with body only." })
						]
					})
				}),
				/* @__PURE__ */ m($, {
					label: "Badge",
					note: "The four status tones always carry a glyph and name the tone; neutral and brand are plain descriptors.",
					children: /* @__PURE__ */ m(Z, {
						gap: "2",
						children: Ke.map((e) => /* @__PURE__ */ m(Je, {
							tone: e,
							children: e
						}, e))
					})
				}),
				/* @__PURE__ */ m($, {
					label: "Tag",
					note: "The remove button names its tag, not the action.",
					children: /* @__PURE__ */ h(Z, {
						gap: "2",
						children: [
							n.map((e) => /* @__PURE__ */ m(Xe, {
								label: e,
								onRemove: () => {
									r((t) => t.filter((t) => t !== e));
								}
							}, e)),
							/* @__PURE__ */ m(Xe, { label: "Not removable" }),
							n.length === 0 ? /* @__PURE__ */ m(R, {
								size: "sm",
								variant: "ghost",
								onClick: () => {
									r([
										"Kubernetes",
										"Security",
										"Beginner"
									]);
								},
								children: "Reset tags"
							}) : null
						]
					})
				}),
				/* @__PURE__ */ m($, {
					label: "Mark",
					note: "Search highlighting. The caller splits the text on the API's offsets — never markup.",
					children: /* @__PURE__ */ h("p", {
						style: { maxWidth: "36rem" },
						children: [
							"In this lesson we look at how ",
							/* @__PURE__ */ m(Qe, { children: "Kubernetes" }),
							" schedules a pod, why a",
							" ",
							/* @__PURE__ */ m(Qe, {
								current: !0,
								children: "scheduler"
							}),
							" might refuse one, and what the events tell you when",
							" ",
							/* @__PURE__ */ m(Qe, { children: "Kubernetes" }),
							" cannot place it at all."
						]
					})
				}),
				/* @__PURE__ */ m($, {
					label: "Avatar",
					children: /* @__PURE__ */ h(Z, {
						gap: "3",
						align: "center",
						children: [
							/* @__PURE__ */ m(nt, {
								name: "Greg Davis",
								size: "sm"
							}),
							/* @__PURE__ */ m(nt, { name: "Greg Davis" }),
							/* @__PURE__ */ m(nt, {
								name: "Greg Davis",
								size: "lg"
							}),
							/* @__PURE__ */ m(nt, { name: "Pearson Evolution" })
						]
					})
				}),
				/* @__PURE__ */ m($, {
					label: "Stat",
					note: "The trend is an arrow in a filled chip plus a word, never only a colour.",
					children: /* @__PURE__ */ h($o, {
						minItemWidth: "12rem",
						children: [
							/* @__PURE__ */ m(st, {
								label: "Licensed courses",
								value: "117",
								hint: "48 with transcripts"
							}),
							/* @__PURE__ */ m(st, {
								label: "Indexed lessons",
								value: "12,480",
								trend: "up",
								trendValue: "+4.2%"
							}),
							/* @__PURE__ */ m(st, {
								label: "Failed embeddings",
								value: "3",
								trend: "down",
								trendValue: "−12"
							}),
							/* @__PURE__ */ m(st, {
								label: "Pathways",
								value: "9",
								trend: "flat",
								trendValue: "no change"
							})
						]
					})
				}),
				/* @__PURE__ */ m($, {
					label: "Table",
					note: "Sortable headers carry aria-sort; the scroller is focusable so narrow screens stay navigable.",
					children: /* @__PURE__ */ m(ft, {
						caption: "Licensed courses",
						columns: [
							{
								key: "title",
								header: "Title",
								sortable: !0,
								cell: (e) => e.title
							},
							{
								key: "duration",
								header: "Duration",
								sortable: !0,
								align: "end",
								cell: (e) => gs(e.duration)
							},
							{
								key: "lessons",
								header: "Lessons",
								sortable: !0,
								align: "end",
								cell: (e) => e.lessons
							},
							{
								key: "isbn",
								header: "ISBN",
								cell: (e) => e.isbn
							}
						],
						rows: i,
						getRowKey: (e) => e.isbn,
						sort: e,
						onSortChange: t
					})
				}),
				/* @__PURE__ */ m($, {
					label: "Table — empty",
					children: /* @__PURE__ */ m(ft, {
						caption: "Search results",
						captionHidden: !0,
						columns: [{
							key: "title",
							header: "Title",
							cell: (e) => e.title
						}],
						rows: [],
						getRowKey: (e) => e.isbn,
						emptyMessage: "No courses matched those filters."
					})
				}),
				/* @__PURE__ */ m($, {
					label: "DescriptionList",
					children: /* @__PURE__ */ h($o, {
						minItemWidth: "18rem",
						children: [/* @__PURE__ */ m(vt, {
							orientation: "horizontal",
							items: [
								{
									term: "ISBN",
									description: "9780138057398"
								},
								{
									term: "Duration",
									description: "22 h"
								},
								{
									term: "Transcripts",
									description: "Available"
								}
							]
						}), /* @__PURE__ */ m(vt, { items: [{
							term: "Publisher",
							description: "Pearson"
						}, {
							term: "Licensed to",
							description: "HCLTech"
						}] })]
					})
				}),
				/* @__PURE__ */ m($, {
					label: "EmptyState",
					children: /* @__PURE__ */ m(lt, {
						icon: "⌕",
						title: "No courses match those filters",
						description: "Try widening the duration range, or clear the knowledge-suite filter.",
						actions: /* @__PURE__ */ m(R, {
							variant: "secondary",
							children: "Clear filters"
						})
					})
				})
			]
		})
	});
}
function bs() {
	let { toast: e, dismissAll: t } = Dt();
	return /* @__PURE__ */ h(Z, {
		gap: "2",
		children: [
			/* @__PURE__ */ m(R, {
				size: "sm",
				onClick: () => {
					e({
						tone: "success",
						title: "Pathway saved",
						description: "9 courses, 42 hours."
					});
				},
				children: "Success toast"
			}),
			/* @__PURE__ */ m(R, {
				size: "sm",
				variant: "ghost",
				onClick: () => {
					e({
						tone: "danger",
						title: "Embedding failed",
						description: "Azure OpenAI returned 429.",
						action: {
							label: "Retry",
							onClick: () => void 0
						},
						duration: 0
					});
				},
				children: "Sticky danger toast"
			}),
			/* @__PURE__ */ m(R, {
				size: "sm",
				variant: "ghost",
				onClick: t,
				children: "Dismiss all"
			})
		]
	});
}
function xs() {
	let [e, t] = d(42);
	return /* @__PURE__ */ m(os, {
		id: "feedback",
		title: "Feedback",
		children: /* @__PURE__ */ h(X, {
			gap: "4",
			children: [
				/* @__PURE__ */ m($, {
					label: "Alert",
					note: "warning and danger are role=alert and interrupt; info and success are role=status and wait.",
					children: /* @__PURE__ */ h(X, {
						gap: "3",
						children: [
							/* @__PURE__ */ m(St, {
								tone: "info",
								title: "69 courses have no transcripts",
								children: "They are still in the catalog and still findable by metadata."
							}),
							/* @__PURE__ */ m(St, {
								tone: "success",
								title: "Ingest finished",
								children: "117 courses, 12,480 lessons."
							}),
							/* @__PURE__ */ m(St, {
								tone: "warning",
								title: "Embeddings are stale",
								children: "14 courses changed since the last embedding run."
							}),
							/* @__PURE__ */ m(St, {
								tone: "danger",
								title: "Could not reach Azure OpenAI",
								actions: /* @__PURE__ */ m(R, {
									size: "sm",
									variant: "danger",
									children: "Retry"
								}),
								onDismiss: () => void 0,
								children: "The search answer could not be grounded, so none was returned."
							})
						]
					})
				}),
				/* @__PURE__ */ m($, {
					label: "Toast",
					note: "Two live regions, one polite and one assertive. Auto-dismiss pauses on hover and focus.",
					children: /* @__PURE__ */ h(X, {
						gap: "3",
						children: [/* @__PURE__ */ m(bs, {}), /* @__PURE__ */ m(wt, {
							tone: "info",
							title: "Placed by hand",
							description: "The presentational component.",
							onDismiss: () => void 0
						})]
					})
				}),
				/* @__PURE__ */ m($, {
					label: "ProgressBar",
					children: /* @__PURE__ */ h(X, {
						gap: "3",
						children: [
							/* @__PURE__ */ m(jt, {
								label: "Transcript ingest",
								value: e
							}),
							/* @__PURE__ */ m(jt, {
								label: "Lessons embedded",
								value: 38,
								max: 117,
								tone: "success",
								formatValue: (e, t) => `${String(e)} of ${String(t)} courses`
							}),
							/* @__PURE__ */ m(jt, {
								label: "Disk used",
								value: 92,
								tone: "danger"
							}),
							/* @__PURE__ */ m(jt, {
								label: "Contacting Azure OpenAI",
								indeterminate: !0
							}),
							/* @__PURE__ */ h(Z, {
								gap: "2",
								children: [/* @__PURE__ */ m(R, {
									size: "sm",
									variant: "ghost",
									onClick: () => {
										t((e) => Math.max(0, e - 10));
									},
									children: "−10%"
								}), /* @__PURE__ */ m(R, {
									size: "sm",
									variant: "ghost",
									onClick: () => {
										t((e) => Math.min(100, e + 10));
									},
									children: "+10%"
								})]
							})
						]
					})
				}),
				/* @__PURE__ */ m($, {
					label: "Tooltip",
					note: "Opens on hover and on keyboard focus; Escape dismisses it.",
					children: /* @__PURE__ */ h(Z, {
						gap: "3",
						children: [/* @__PURE__ */ m(To, {
							content: "Metadata-only: this course has no transcript to search.",
							children: /* @__PURE__ */ m(R, {
								variant: "ghost",
								children: "Hover or focus me"
							})
						}), /* @__PURE__ */ m(To, {
							content: "Re-run the embedding job for this course.",
							placement: "right",
							children: /* @__PURE__ */ m(ie, {
								label: "Re-embed course",
								children: "↻"
							})
						})]
					})
				})
			]
		})
	});
}
function Ss() {
	let [e, t] = d(4);
	return /* @__PURE__ */ m(os, {
		id: "navigation",
		title: "Navigation",
		children: /* @__PURE__ */ h(X, {
			gap: "4",
			children: [
				/* @__PURE__ */ m($, {
					label: "Tabs",
					note: "Roving tabindex: one Tab press leaves the strip, arrows move within it.",
					children: /* @__PURE__ */ m(Do, {
						label: "Course sections",
						items: [
							{
								id: "overview",
								label: "Overview",
								content: /* @__PURE__ */ m("p", { children: "Course summary and metadata." })
							},
							{
								id: "lessons",
								label: "Lessons",
								content: /* @__PURE__ */ m("p", { children: "The lesson tree, with durations." })
							},
							{
								id: "transcript",
								label: "Transcript",
								content: /* @__PURE__ */ m("p", { children: "Searchable transcript text." })
							},
							{
								id: "admin",
								label: "Admin",
								content: /* @__PURE__ */ m("p", { children: "Admins only." }),
								disabled: !0
							}
						]
					})
				}),
				/* @__PURE__ */ m($, {
					label: "Breadcrumbs",
					children: /* @__PURE__ */ m(ko, { items: [
						{
							label: "Catalog",
							href: "#catalog"
						},
						{
							label: "Cloud",
							href: "#cloud"
						},
						{ label: "AWS Certified Solutions Architect" }
					] })
				}),
				/* @__PURE__ */ m($, {
					label: "Pagination",
					note: "Truncated with ellipses — a nav landmark of 400 buttons is worse than none.",
					children: /* @__PURE__ */ h(X, {
						gap: "3",
						children: [/* @__PURE__ */ m(gt, {
							page: e,
							pageCount: 24,
							onPageChange: t,
							label: "Pagination, 24 pages"
						}), /* @__PURE__ */ m(gt, {
							page: 1,
							pageCount: 3,
							onPageChange: () => void 0,
							label: "Pagination, 3 pages"
						})]
					})
				}),
				/* @__PURE__ */ m($, {
					label: "Menu",
					note: "Up/Down with wrapping, Home/End, letter typeahead, Escape to close, focus back to the trigger.",
					children: /* @__PURE__ */ m(jo, {
						trigger: /* @__PURE__ */ m(R, {
							variant: "secondary",
							children: "Course actions"
						}),
						items: [
							{
								id: "open",
								label: "Open course",
								icon: "↗"
							},
							{
								id: "embed",
								label: "Re-run embeddings",
								icon: "↻",
								shortcut: "⌘E"
							},
							{
								id: "export",
								label: "Export metadata",
								icon: "⇩"
							},
							{
								id: "archive",
								label: "Archive (admin only)",
								disabled: !0
							},
							{
								id: "delete",
								label: "Remove from catalog",
								icon: "✕",
								tone: "danger"
							}
						]
					})
				}),
				/* @__PURE__ */ m($, {
					label: "Accordion",
					note: "Each trigger is a button inside a heading, so the set is navigable by heading.",
					children: /* @__PURE__ */ m(No, {
						defaultOpen: ["module-1"],
						items: [
							{
								id: "module-1",
								label: "Module 1 — Foundations",
								content: /* @__PURE__ */ m("p", { children: "12 lessons · 3 h 20 min" })
							},
							{
								id: "module-2",
								label: "Module 2 — Networking",
								content: /* @__PURE__ */ m("p", { children: "9 lessons · 2 h 45 min" })
							},
							{
								id: "module-3",
								label: "Module 3 — Security",
								content: /* @__PURE__ */ m("p", { children: "11 lessons · 3 h 05 min" })
							}
						]
					})
				})
			]
		})
	});
}
function Cs() {
	let [e, t] = d(!1), [n, r] = d(!1);
	return /* @__PURE__ */ m(os, {
		id: "overlay",
		title: "Overlay",
		description: "Open each one and press Tab repeatedly: focus must stay inside, and Escape must return it to the button that opened it.",
		children: /* @__PURE__ */ h(X, {
			gap: "4",
			children: [
				/* @__PURE__ */ h($, {
					label: "Modal",
					children: [/* @__PURE__ */ m(R, {
						onClick: () => {
							t(!0);
						},
						children: "Open modal"
					}), /* @__PURE__ */ m(Wo, {
						open: e,
						onClose: () => {
							t(!1);
						},
						title: "Remove course from catalog?",
						description: "This hides the course from search. Transcripts are kept.",
						footer: /* @__PURE__ */ h(p, { children: [/* @__PURE__ */ m(R, {
							variant: "ghost",
							onClick: () => {
								t(!1);
							},
							children: "Cancel"
						}), /* @__PURE__ */ m(R, {
							variant: "danger",
							onClick: () => {
								t(!1);
							},
							children: "Remove course"
						})] }),
						children: /* @__PURE__ */ h(X, {
							gap: "3",
							children: [/* @__PURE__ */ m("p", { children: "AWS Certified Solutions Architect — 142 lessons, 22 hours." }), /* @__PURE__ */ m(be, {
								label: "Reason",
								hint: "Recorded in the audit log.",
								children: /* @__PURE__ */ m(Ce, {
									"data-autofocus": !0,
									placeholder: "Licence expired"
								})
							})]
						})
					})]
				}),
				/* @__PURE__ */ h($, {
					label: "Drawer",
					note: "side is logical, so start/end follow the writing direction.",
					children: [/* @__PURE__ */ m(R, {
						variant: "secondary",
						onClick: () => {
							r(!0);
						},
						children: "Open filters drawer"
					}), /* @__PURE__ */ m(qo, {
						open: n,
						onClose: () => {
							r(!1);
						},
						title: "Filters",
						description: "Narrow the catalog.",
						footer: /* @__PURE__ */ m(R, {
							onClick: () => {
								r(!1);
							},
							children: "Apply"
						}),
						children: /* @__PURE__ */ h(X, {
							gap: "4",
							children: [
								/* @__PURE__ */ m(je, {
									label: "Has transcripts",
									defaultChecked: !0
								}),
								/* @__PURE__ */ m(je, { label: "Beginner level" }),
								/* @__PURE__ */ m(Ve, {
									label: "Duration",
									min: 0,
									max: 86400,
									step: 1800,
									value: [3600, 43200],
									onValueChange: () => void 0,
									formatValue: gs
								})
							]
						})
					})]
				}),
				/* @__PURE__ */ m($, {
					label: "Popover",
					note: "Holds controls, so focus moves into it — unlike a tooltip.",
					children: /* @__PURE__ */ m(Yo, {
						trigger: /* @__PURE__ */ m(R, {
							variant: "ghost",
							children: "Knowledge suite"
						}),
						title: "Knowledge suite",
						showDismiss: !0,
						children: /* @__PURE__ */ h(X, {
							gap: "2",
							children: [
								/* @__PURE__ */ m(je, {
									label: "Cloud",
									defaultChecked: !0
								}),
								/* @__PURE__ */ m(je, { label: "Security" }),
								/* @__PURE__ */ m(je, { label: "AI and data" })
							]
						})
					})
				})
			]
		})
	});
}
function ws() {
	return /* @__PURE__ */ m(os, {
		id: "layout",
		title: "Layout",
		children: /* @__PURE__ */ h(X, {
			gap: "4",
			children: [
				/* @__PURE__ */ m($, {
					label: "PageHeader",
					children: /* @__PURE__ */ m(is, {
						headingLevel: 2,
						eyebrow: "Cloud",
						title: "AWS Certified Solutions Architect",
						description: "22 hours across 142 lessons, with full transcripts.",
						breadcrumbs: /* @__PURE__ */ m(ko, {
							label: "Course breadcrumb",
							items: [{
								label: "Catalog",
								href: "#catalog"
							}, { label: "AWS Solutions Architect" }]
						}),
						actions: /* @__PURE__ */ h(p, { children: [/* @__PURE__ */ m(R, {
							variant: "ghost",
							children: "Share"
						}), /* @__PURE__ */ m(R, {
							variant: "action",
							children: "Enrol"
						})] })
					})
				}),
				/* @__PURE__ */ m($, {
					label: "Stack and Inline",
					children: /* @__PURE__ */ h($o, {
						minItemWidth: "16rem",
						children: [/* @__PURE__ */ h(X, {
							gap: "2",
							children: [
								/* @__PURE__ */ m(Je, {
									tone: "brand",
									children: "Stack, gap 2"
								}),
								/* @__PURE__ */ m(Je, {
									tone: "brand",
									children: "Second"
								}),
								/* @__PURE__ */ m(Je, {
									tone: "brand",
									children: "Third"
								})
							]
						}), /* @__PURE__ */ h(Z, {
							gap: "2",
							children: [
								/* @__PURE__ */ m(Je, {
									tone: "neutral",
									children: "Inline"
								}),
								/* @__PURE__ */ m(Je, {
									tone: "neutral",
									children: "wraps"
								}),
								/* @__PURE__ */ m(Je, {
									tone: "neutral",
									children: "by"
								}),
								/* @__PURE__ */ m(Je, {
									tone: "neutral",
									children: "default"
								})
							]
						})]
					})
				}),
				/* @__PURE__ */ m($, {
					label: "Grid",
					note: "Column count follows from minItemWidth, so it reflows without breakpoints.",
					children: /* @__PURE__ */ m($o, {
						minItemWidth: "10rem",
						gap: "3",
						children: [
							"Cloud",
							"Security",
							"AI and data",
							"Leadership",
							"Networking",
							"Linux"
						].map((e) => /* @__PURE__ */ m(Ue, { children: e }, e))
					})
				}),
				/* @__PURE__ */ m($, {
					label: "Section and Container",
					note: "Container holds the side gutters, so no page can touch the screen edge.",
					children: /* @__PURE__ */ m(os, {
						headingLevel: 3,
						title: "A nested section",
						description: "Labelled by its title, so it is a named landmark.",
						actions: /* @__PURE__ */ m(R, {
							size: "sm",
							variant: "ghost",
							children: "Action"
						}),
						children: /* @__PURE__ */ m("p", { children: "Section content." })
					})
				}),
				/* @__PURE__ */ m($, {
					label: "VisuallyHidden",
					children: /* @__PURE__ */ h("p", { children: ["This sentence has hidden text after it.", /* @__PURE__ */ m(I, { children: " Only a screen reader reads this." })] })
				})
			]
		})
	});
}
function Ts({ themeStorageKey: e } = {}) {
	let [t, n] = d(!1);
	return /* @__PURE__ */ m(D, {
		...e === void 0 ? {} : { storageKey: e },
		children: /* @__PURE__ */ m(Ot, { children: /* @__PURE__ */ h("div", {
			className: Q.gallery,
			children: [/* @__PURE__ */ m(cs, {
				greyscale: t,
				onGreyscaleChange: n
			}), /* @__PURE__ */ m("div", {
				className: Q.content,
				"data-greyscale": t,
				children: /* @__PURE__ */ m(ns, {
					size: "xl",
					children: /* @__PURE__ */ h(X, {
						gap: "8",
						children: [
							/* @__PURE__ */ m(ps, {}),
							/* @__PURE__ */ m(ms, {}),
							/* @__PURE__ */ m(_s, {}),
							/* @__PURE__ */ m(ys, {}),
							/* @__PURE__ */ m(xs, {}),
							/* @__PURE__ */ m(Ss, {}),
							/* @__PURE__ */ m(Cs, {}),
							/* @__PURE__ */ m(ws, {})
						]
					})
				})
			})]
		}) })
	});
}
//#endregion
export { bt as ALERT_TONES, et as AVATAR_SIZES, No as Accordion, St as Alert, nt as Avatar, Ke as BADGE_TONES, te as BUTTON_SIZES, L as BUTTON_VARIANTS, Je as Badge, ko as Breadcrumbs, R as Button, ts as CONTAINER_SIZES, Ue as Card, je as Checkbox, Ts as ComponentGallery, ns as Container, Ko as DRAWER_SIDES, vt as DescriptionList, he as Divider, qo as Drawer, lt as EmptyState, be as FormField, $o as Grid, z as ICON_BUTTON_SIZES, re as ICON_BUTTON_VARIANTS, Se as INPUT_SIZES, ie as IconButton, Z as Inline, Ce as Input, oe as LINK_VARIANTS, se as Link, Uo as MODAL_SIZES, Qe as Mark, jo as Menu, Wo as Modal, At as PROGRESS_TONES, is as PageHeader, gt as Pagination, Yo as Popover, jt as ProgressBar, Ne as Radio, Ve as RangeSlider, Le as SEARCH_INPUT_SIZES, De as SELECT_SIZES, fe as SKELETON_SHAPES, M as SPACE_STEPS, le as SPINNER_SIZES, k as STATUS_GLYPH, A as STATUS_LABEL, O as STATUS_TONES, Re as SearchInput, os as Section, Oe as Select, pe as Skeleton, ue as Spinner, X as Stack, st as Stat, Fe as Switch, it as TREND_DIRECTIONS, ft as Table, Do as Tabs, Xe as Tag, Te as Textarea, D as ThemeProvider, wt as Toast, Ot as ToastProvider, To as Tooltip, I as VisuallyHidden, tt as initialsFor, ht as paginationRange, y as useTheme, Dt as useToast };

//# sourceMappingURL=index.js.map